// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AppControllerGetServiceStatusResponse, AuthControllerLoginData, AuthControllerLoginResponse, AuthControllerSsoLoginData, AuthControllerSsoLoginResponse, AuthControllerSsoSignupData, AuthControllerSsoSignupResponse, AuthControllerSendPasswordResetEmailData, AuthControllerSendPasswordResetEmailResponse, AuthControllerUpdatePasswordData, AuthControllerUpdatePasswordResponse, AuthControllerSelfUpdatePasswordData, AuthControllerSelfUpdatePasswordResponse, AuthControllerUpdateEmailData, AuthControllerUpdateEmailResponse, UserControllerGetUsersData, UserControllerGetUsersResponse, UserControllerCreateData, UserControllerCreateResponse, UserControllerDeleteUserData, UserControllerDeleteUserResponse, UserControllerGetFrontendUsersData, UserControllerGetFrontendUsersResponse, UserControllerGetUserByIdData, UserControllerGetUserByIdResponse, UserControllerGetFrontendUserByIdData, UserControllerGetFrontendUserByIdResponse, UserControllerUpdateData, UserControllerUpdateResponse, UserControllerUpdateAssignedLocationsData, UserControllerUpdateAssignedLocationsResponse, UserControllerSelectCompanyData, UserControllerSelectCompanyResponse, UserControllerAddUserCompanyData, UserControllerAddUserCompanyResponse, UserControllerSyncUserCompaniesData, UserControllerSyncUserCompaniesResponse, UserControllerRemoveUserCompanyData, UserControllerRemoveUserCompanyResponse, UserControllerPatchUserData, UserControllerPatchUserResponse, UserControllerUpdateAppReloadRequiredForAllUsersData, UserControllerUpdateAppReloadRequiredForAllUsersResponse, UserControllerGetUserProfilePictureResponse, UserControllerUploadUserProfilePictureData, UserControllerUploadUserProfilePictureResponse, UserControllerDeleteUserProfilePictureResponse, UserControllerGetUserProfilePictureByIdData, UserControllerGetUserProfilePictureByIdResponse, UserControllerHydrateUsersToKafkaResponse, TracingControllerTraceErrorData, TracingControllerTraceErrorResponse, SsoControllerGetCompanyStrategiesData, SsoControllerGetCompanyStrategiesResponse, ConsultancyControllerGetAllResponse, ConsultancyControllerCreateData, ConsultancyControllerCreateResponse, ConsultancyControllerGetByIdData, ConsultancyControllerGetByIdResponse, ConsultancyControllerUpdateData, ConsultancyControllerUpdateResponse, ConsultancyControllerDeleteData, ConsultancyControllerDeleteResponse, ConsultancyControllerGetAvailableCompaniesData, ConsultancyControllerGetAvailableCompaniesResponse, ConsultancyControllerAddCompaniesData, ConsultancyControllerAddCompaniesResponse, ConsultancyControllerGetConsultancyUsersData, ConsultancyControllerGetConsultancyUsersResponse, ConsultancyControllerAddUserToConsultancyData, ConsultancyControllerAddUserToConsultancyResponse, ConsultancyControllerRemoveUserFromConsultancyData, ConsultancyControllerRemoveUserFromConsultancyResponse, ConsultancyControllerAttachCompaniesToUserData, ConsultancyControllerAttachCompaniesToUserResponse, ConsultancyControllerGetLogoData, ConsultancyControllerGetLogoResponse, ConsultancyControllerRequestMeterCreationData, ConsultancyControllerRequestMeterCreationResponse, RegionControllerUpsertCompanyRegionData, RegionControllerUpsertCompanyRegionResponse, CompanyControllerGetCompanyRegionsData, CompanyControllerGetCompanyRegionsResponse, RegionControllerDeleteCompanyRegionData, RegionControllerDeleteCompanyRegionResponse, RolesControllerFindAllResponse, ObjectStorageControllerUploadData, ObjectStorageControllerUploadResponse, ObjectStorageControllerDownloadData, ObjectStorageControllerDownloadResponse, ObjectStorageControllerDeleteData, ObjectStorageControllerDeleteResponse, ObjectStorageControllerGetFileMetadataData, ObjectStorageControllerGetFileMetadataResponse, ObjectStorageControllerDownloadConsultantsLoadProfileTemplateData, ObjectStorageControllerDownloadConsultantsLoadProfileTemplateResponse, ObjectStorageV2ControllerUploadData, ObjectStorageV2ControllerUploadResponse, ObjectStorageV2ControllerDownloadByUidData, ObjectStorageV2ControllerDownloadByUidResponse, ObjectStorageV2ControllerDeleteByUidData, ObjectStorageV2ControllerDeleteByUidResponse, ObjectStorageV2ControllerUploadAdminData, ObjectStorageV2ControllerUploadAdminResponse, ObjectStorageV2ControllerDownloadByUidAdminData, ObjectStorageV2ControllerDownloadByUidAdminResponse, ObjectStorageV2ControllerDeleteByUidAdminData, ObjectStorageV2ControllerDeleteByUidAdminResponse, ObjectStorageV2ControllerGetFileMetadataByUidData, ObjectStorageV2ControllerGetFileMetadataByUidResponse, ObjectStorageV2ControllerGetFileMetadataByUidAdminData, ObjectStorageV2ControllerGetFileMetadataByUidAdminResponse, ObjectStorageV2ControllerDownloadConsultantsLoadProfileTemplateData, ObjectStorageV2ControllerDownloadConsultantsLoadProfileTemplateResponse, EmissionsControllerGetEmissionsComparisonData, EmissionsControllerGetEmissionsComparisonResponse, MeterControllerGetAvailableYearsByLocationData, MeterControllerGetAvailableYearsByLocationResponse, MeterControllerGetAvailableYearsByCompanyData, MeterControllerGetAvailableYearsByCompanyResponse, MeterControllerGetBulkInfrastructureSettingsData, MeterControllerGetBulkInfrastructureSettingsResponse, MeterControllerPutBulkInfrastructureSettingsData, MeterControllerPutBulkInfrastructureSettingsResponse, MeterControllerGetInfrastructureSettingsData, MeterControllerGetInfrastructureSettingsResponse, MeterControllerPutInfrastructureSettingsData, MeterControllerPutInfrastructureSettingsResponse, MeterControllerGetPossibleParentMetersData, MeterControllerGetPossibleParentMetersResponse, MeterControllerCreateSlpMeterData, MeterControllerCreateSlpMeterResponse, MeterControllerUpdateSlpMeterData, MeterControllerUpdateSlpMeterResponse, MeterControllerDeleteSlpMeterData, MeterControllerDeleteSlpMeterResponse, MeterControllerGetSlpMeterData, MeterControllerGetSlpMeterResponse, MeterControllerGetMetersData, MeterControllerGetMetersResponse, MeterControllerGetSlpMetersData, MeterControllerGetSlpMetersResponse, MeterControllerGetMetersInfoByAllowedLocationsData, MeterControllerGetMetersInfoByAllowedLocationsResponse, MeterControllerGetMeterEvaluationsData, MeterControllerGetMeterEvaluationsResponse, MeterControllerCreateMeterEvaluationData, MeterControllerCreateMeterEvaluationResponse, MeterControllerDeleteMeterEvaluationData, MeterControllerDeleteMeterEvaluationResponse, MeterControllerGetEnergyEvaluationData, MeterControllerGetEnergyEvaluationResponse, DocumentTemplateControllerCreateData, DocumentTemplateControllerCreateResponse, DocumentTemplateControllerFindAllData, DocumentTemplateControllerFindAllResponse, DocumentTemplateControllerFindOneData, DocumentTemplateControllerFindOneResponse, DocumentTemplateControllerUpdateData, DocumentTemplateControllerUpdateResponse, DocumentTemplateControllerRemoveData, DocumentTemplateControllerRemoveResponse, DocumentTemplateControllerUpdateContentData, DocumentTemplateControllerUpdateContentResponse, UsageAnalyticsControllerTrackEventData, UsageAnalyticsControllerTrackEventResponse, HedgingControllerUploadFileData, HedgingControllerUploadFileResponse, VisualizationControllerGetVisualizationsData, VisualizationControllerGetVisualizationsResponse, VisualizationControllerDeleteVisualizationData, VisualizationControllerDeleteVisualizationResponse, GridFeesControllerGetGridUsageFeesData, GridFeesControllerGetGridUsageFeesResponse, GridFeesControllerUpsertGridUsageFeeData, GridFeesControllerUpsertGridUsageFeeResponse, GridFeesControllerDeleteGridUsageFeeData, GridFeesControllerDeleteGridUsageFeeResponse, GridFeesControllerGetPeakLoadPricesData, GridFeesControllerGetPeakLoadPricesResponse, GridFeesControllerUpsertPeakLoadPriceData, GridFeesControllerUpsertPeakLoadPriceResponse, GridFeesControllerDeletePeakLoadPriceData, GridFeesControllerDeletePeakLoadPriceResponse, IsoChaptersControllerFindAllResponse, IsoChaptersControllerCreateData, IsoChaptersControllerCreateResponse, IsoChaptersControllerUpdateData, IsoChaptersControllerUpdateResponse, IsoChaptersControllerRemoveData, IsoChaptersControllerRemoveResponse, IsoDocumentsControllerFindAllData, IsoDocumentsControllerFindAllResponse, IsoDocumentsControllerCreateData, IsoDocumentsControllerCreateResponse, IsoDocumentsControllerFindOneByIdData, IsoDocumentsControllerFindOneByIdResponse, IsoDocumentsControllerDeleteData, IsoDocumentsControllerDeleteResponse, IsoDocumentsControllerUpdateContentData, IsoDocumentsControllerUpdateContentResponse, IsoDocumentsControllerUpdateMetaDataData, IsoDocumentsControllerUpdateMetaDataResponse, IsoDocumentsControllerUploadFileData, IsoDocumentsControllerUploadFileResponse, IsoDocumentsControllerDeleteUploadDocumentData, IsoDocumentsControllerDeleteUploadDocumentResponse, IsoRiskControllerFindAllData, IsoRiskControllerFindAllResponse, IsoRiskControllerCreateData, IsoRiskControllerCreateResponse, IsoRiskControllerFindOneByIdData, IsoRiskControllerFindOneByIdResponse, IsoRiskControllerUpdateData, IsoRiskControllerUpdateResponse, IsoRiskControllerDeleteData, IsoRiskControllerDeleteResponse, IsoGoalsControllerFindAllData, IsoGoalsControllerFindAllResponse, IsoGoalsControllerCreateData, IsoGoalsControllerCreateResponse, IsoGoalsControllerFindOneByIdData, IsoGoalsControllerFindOneByIdResponse, IsoGoalsControllerUpdateData, IsoGoalsControllerUpdateResponse, IsoGoalsControllerDeleteData, IsoGoalsControllerDeleteResponse, IsoEnpiControllerFindSeuOptionsData, IsoEnpiControllerFindSeuOptionsResponse, IsoEnpiControllerFindSeuOptionsForLocationsData, IsoEnpiControllerFindSeuOptionsForLocationsResponse, IsoEnpiControllerFindAllData, IsoEnpiControllerFindAllResponse, IsoEnpiControllerCreateData, IsoEnpiControllerCreateResponse, IsoEnpiControllerFindOneByIdData, IsoEnpiControllerFindOneByIdResponse, IsoEnpiControllerUpdateData, IsoEnpiControllerUpdateResponse, IsoEnpiControllerDeleteData, IsoEnpiControllerDeleteResponse, IsoEnpiControllerAddCommentData, IsoEnpiControllerAddCommentResponse, IsoEnpiControllerBatchUpdateData, IsoEnpiControllerBatchUpdateResponse, IsoEnpiControllerTriggerDailyUpdateResponse, IsoEnpiControllerRecalculateData, IsoEnpiControllerRecalculateResponse, IsoMeasuresControllerFindAllData, IsoMeasuresControllerFindAllResponse, IsoMeasuresControllerCreateData, IsoMeasuresControllerCreateResponse, IsoMeasuresControllerFindOneByIdData, IsoMeasuresControllerFindOneByIdResponse, IsoMeasuresControllerUpdateData, IsoMeasuresControllerUpdateResponse, IsoMeasuresControllerDeleteData, IsoMeasuresControllerDeleteResponse, IsoMeasuresControllerCreateMeasureDocumentsResponse, IsoMeasuresControllerLinkSuccessMeasurementAnalyticsBaselineData, IsoMeasuresControllerLinkSuccessMeasurementAnalyticsBaselineResponse, IsoMeasuresControllerPatchStatusData, IsoMeasuresControllerPatchStatusResponse, IsoMeasuresControllerValidateStatusData, IsoMeasuresControllerValidateStatusResponse, IsoMeasuresControllerAddCommentData, IsoMeasuresControllerAddCommentResponse, IsoMeasuresControllerCreateMilestoneData, IsoMeasuresControllerCreateMilestoneResponse, IsoMeasuresControllerUpdateMilestoneData, IsoMeasuresControllerUpdateMilestoneResponse, IsoMeasuresControllerDeleteMilestoneData, IsoMeasuresControllerDeleteMilestoneResponse, IsoMeasuresControllerPatchMilestoneStatusData, IsoMeasuresControllerPatchMilestoneStatusResponse, IsoMeasuresControllerUpdateMilestonesOrderData, IsoMeasuresControllerUpdateMilestonesOrderResponse, IsoMeasuresControllerDeleteMeasureSavingsData, IsoMeasuresControllerDeleteMeasureSavingsResponse, IsoMeasuresControllerActivateAutoTrackingData, IsoMeasuresControllerActivateAutoTrackingResponse, IsoControllerGetIsoOverviewData, IsoControllerGetIsoOverviewResponse, IsoChecklistConfigurationControllerFindAllResponse, IsoChecklistConfigurationControllerCreateChecklistResponse, IsoChecklistConfigurationControllerFindOneByIdData, IsoChecklistConfigurationControllerFindOneByIdResponse, IsoChecklistConfigurationControllerDeleteChecklistConfigurationData, IsoChecklistConfigurationControllerDeleteChecklistConfigurationResponse, IsoChecklistConfigurationControllerCopyChecklistData, IsoChecklistConfigurationControllerCopyChecklistResponse, IsoChecklistConfigurationControllerPatchStatusData, IsoChecklistConfigurationControllerPatchStatusResponse, IsoChecklistConfigurationControllerUnFinalizeData, IsoChecklistConfigurationControllerUnFinalizeResponse, IsoChecklistConfigurationControllerPatchLatestData, IsoChecklistConfigurationControllerPatchLatestResponse, IsoChecklistConfigurationControllerAddChecklistChapterData, IsoChecklistConfigurationControllerAddChecklistChapterResponse, IsoChecklistConfigurationControllerUpdateChecklistChapterData, IsoChecklistConfigurationControllerUpdateChecklistChapterResponse, IsoChecklistConfigurationControllerDeleteChecklistChapterData, IsoChecklistConfigurationControllerDeleteChecklistChapterResponse, IsoChecklistConfigurationControllerAddChecklistSubChapterData, IsoChecklistConfigurationControllerAddChecklistSubChapterResponse, IsoChecklistConfigurationControllerUpdateChecklistSubChapterData, IsoChecklistConfigurationControllerUpdateChecklistSubChapterResponse, IsoChecklistConfigurationControllerDeleteChecklistSubChapterData, IsoChecklistConfigurationControllerDeleteChecklistSubChapterResponse, IsoChecklistConfigurationControllerAddTaskData, IsoChecklistConfigurationControllerAddTaskResponse, IsoChecklistConfigurationControllerUpdateTasksData, IsoChecklistConfigurationControllerUpdateTasksResponse, IsoChecklistConfigurationControllerDeleteTaskData, IsoChecklistConfigurationControllerDeleteTaskResponse, IsoChecklistControllerFindByCompanyIdData, IsoChecklistControllerFindByCompanyIdResponse, IsoChecklistControllerCreateChecklistByCompanyData, IsoChecklistControllerCreateChecklistByCompanyResponse, IsoChecklistControllerMarkTaskCompletedData, IsoChecklistControllerMarkTaskCompletedResponse, IsoChecklistControllerMarkTaskOpenData, IsoChecklistControllerMarkTaskOpenResponse, IsoChecklistControllerMarkTaskInProgressData, IsoChecklistControllerMarkTaskInProgressResponse, IsoChecklistControllerLinkDocumentData, IsoChecklistControllerLinkDocumentResponse, IsoChecklistControllerRemoveLinkDocumentData, IsoChecklistControllerRemoveLinkDocumentResponse, ValeriControllerCreateValeriData, ValeriControllerCreateValeriResponse, ValeriControllerUpdateValeriData, ValeriControllerUpdateValeriResponse, ValeriControllerDeleteValeriData, ValeriControllerDeleteValeriResponse, ValeriControllerFindOneByIdData, ValeriControllerFindOneByIdResponse, ValeriControllerGetValeriPositionsData, ValeriControllerGetValeriPositionsResponse, ValeriControllerCreateValeriPositionData, ValeriControllerCreateValeriPositionResponse, ValeriControllerCalculateValeriData, ValeriControllerCalculateValeriResponse, ValeriControllerExportValeriCalculationResultData, ValeriControllerExportValeriCalculationResultResponse, ValeriControllerUpdateValeriPositionData, ValeriControllerUpdateValeriPositionResponse, ValeriControllerDeleteValeriPositionData, ValeriControllerDeleteValeriPositionResponse, ValeriControllerUploadValeriPositionDocumentData, ValeriControllerUploadValeriPositionDocumentResponse, ValeriControllerDeleteValeriPositionDocumentData, ValeriControllerDeleteValeriPositionDocumentResponse, ValeriControllerGetValeriCalculationResultsData, ValeriControllerGetValeriCalculationResultsResponse, ValeriControllerGetValeriByMeasureIdData, ValeriControllerGetValeriByMeasureIdResponse, ValeriControllerLinkValeriToMeasureData, ValeriControllerLinkValeriToMeasureResponse, ValeriControllerGetCompanyDefaultsData, ValeriControllerGetCompanyDefaultsResponse, ValeriControllerUpsertCompanyDefaultsData, ValeriControllerUpsertCompanyDefaultsResponse, CompanyEnergyBaselineConfigControllerGetData, CompanyEnergyBaselineConfigControllerGetResponse, CompanyEnergyBaselineConfigControllerUpsertData, CompanyEnergyBaselineConfigControllerUpsertResponse, BuildingControllerGetBuildingsByLocationData, BuildingControllerGetBuildingsByLocationResponse, BuildingControllerUpsertBuildingData, BuildingControllerUpsertBuildingResponse, BuildingControllerHydrateBuildingsToKafkaResponse, BuildingControllerDeleteBuildingData, BuildingControllerDeleteBuildingResponse, ConsumptionControllerGetConsumptionData, ConsumptionControllerGetConsumptionResponse, ConsumptionControllerGetConsumptionLocationWithGranularityData, ConsumptionControllerGetConsumptionLocationWithGranularityResponse, ConsumptionControllerGetConsumptionWithGranularityData, ConsumptionControllerGetConsumptionWithGranularityResponse, ConsumptionControllerGetLoadProfileData, ConsumptionControllerGetLoadProfileResponse, ConsumptionControllerGetAggregatedConsumptionWithGranularityData, ConsumptionControllerGetAggregatedConsumptionWithGranularityResponse, ConsumptionControllerGetAggregatedConsumptionData, ConsumptionControllerGetAggregatedConsumptionResponse, ConsumptionControllerGetConsumptionSeriesData, ConsumptionControllerGetConsumptionSeriesResponse, LocationTotalSeriesControllerGetLocationTotalSeriesData, LocationTotalSeriesControllerGetLocationTotalSeriesResponse, CompanyControllerGetCompaniesResponse, CompanyControllerUpsertCompanyData, CompanyControllerUpsertCompanyResponse, CompanyControllerPushAllToKafkaResponse, CompanyControllerDeleteCompanyData, CompanyControllerDeleteCompanyResponse, CompanyControllerGetCompanyData, CompanyControllerGetCompanyResponse, CompanyControllerGetPremiumFeaturesData, CompanyControllerGetPremiumFeaturesResponse, CompanyControllerUpdatePremiumFeaturesData, CompanyControllerUpdatePremiumFeaturesResponse, CompanyControllerGetCompanyLogoData, CompanyControllerGetCompanyLogoResponse, CompanyControllerGetCompanyWhiteLabelLogoData, CompanyControllerGetCompanyWhiteLabelLogoResponse, CompanyControllerIsCostEnabledData, CompanyControllerIsCostEnabledResponse, LocationControllerGetLocationsByCompanyData, LocationControllerGetLocationsByCompanyResponse, LocationControllerUpsertLocationData, LocationControllerUpsertLocationResponse, LocationControllerGetLocationsWithBuildingsAndDevicesByCompanyData, LocationControllerGetLocationsWithBuildingsAndDevicesByCompanyResponse, LocationControllerDeleteLocationData, LocationControllerDeleteLocationResponse, LocationControllerGetRegionsByLocationData, LocationControllerGetRegionsByLocationResponse, LocationControllerToggleLocationAssignmentToRegionData, LocationControllerToggleLocationAssignmentToRegionResponse, LocationControllerPushAllToKafkaResponse, TemperatureControllerFindAllData, TemperatureControllerFindAllResponse, TemperatureControllerGetWeatherDataByCityIdData, TemperatureControllerGetWeatherDataByCityIdResponse, TemperatureControllerGetWeatherDataData, TemperatureControllerGetWeatherDataResponse, TemperatureControllerFindOneData, TemperatureControllerFindOneResponse, TemperatureControllerUpdateData, TemperatureControllerUpdateResponse, TemperatureControllerDeleteData, TemperatureControllerDeleteResponse, TemperatureControllerCreateData, TemperatureControllerCreateResponse, TemperatureControllerTriggerSyncResponse, CityControllerGetAllCitiesData, CityControllerGetAllCitiesResponse, CityControllerPreviewGeocodedCityData, CityControllerPreviewGeocodedCityResponse, CityControllerCommitGeocodedCityData, CityControllerCommitGeocodedCityResponse, CityControllerFindAndUpsertCityData, CityControllerFindAndUpsertCityResponse, CustomTimeseriesControllerFindPageData, CustomTimeseriesControllerFindPageResponse, LoadControllerGetAggregatedMonthlyPeakloadsData, LoadControllerGetAggregatedMonthlyPeakloadsResponse, LoadControllerGetAggregatedMonthlyBaseloadsData, LoadControllerGetAggregatedMonthlyBaseloadsResponse, LoadSimulationControllerPopulatePfcResponse, LoadSimulationControllerRecalculateSimulationOfTypeData, LoadSimulationControllerRecalculateSimulationOfTypeResponse, LoadSimulationControllerGetAvailableMainMetersData, LoadSimulationControllerGetAvailableMainMetersResponse, LoadSimulationControllerGetAvailableGenerationLoadProfilesResponse, LoadSimulationControllerFindAllForCompanyIdData, LoadSimulationControllerFindAllForCompanyIdResponse, LoadSimulationControllerCreateSimulationData, LoadSimulationControllerCreateSimulationResponse, LoadSimulationControllerUpdateSimulationByIdData, LoadSimulationControllerUpdateSimulationByIdResponse, LoadSimulationControllerFindSimulationByIdData, LoadSimulationControllerFindSimulationByIdResponse, LoadSimulationControllerDeleteSimulationByIdData, LoadSimulationControllerDeleteSimulationByIdResponse, LoadSimulationControllerRecalculateSimulationByIdData, LoadSimulationControllerRecalculateSimulationByIdResponse, LoadSimulationControllerGetSimulationCsvData, LoadSimulationControllerGetSimulationCsvResponse, GenerationLoadProfileControllerGetLoadProfileData, GenerationLoadProfileControllerGetLoadProfileResponse, GenerationLoadProfileControllerUpdateGenerationLoadProfileData, GenerationLoadProfileControllerUpdateGenerationLoadProfileResponse, GenerationLoadProfileControllerDeleteGenerationLoadProfileData, GenerationLoadProfileControllerDeleteGenerationLoadProfileResponse, GenerationLoadProfileControllerCreateGenerationLoadProfileData, GenerationLoadProfileControllerCreateGenerationLoadProfileResponse, GenerationLoadProfileControllerUpdateLoadDataData, GenerationLoadProfileControllerUpdateLoadDataResponse, SlpConsumptionControllerGetReferencesForDeviceIdData, SlpConsumptionControllerGetReferencesForDeviceIdResponse, SlpConsumptionControllerGetSlpConsumptionData, SlpConsumptionControllerGetSlpConsumptionResponse, SlpConsumptionControllerUpdateSlpConsumptionData, SlpConsumptionControllerUpdateSlpConsumptionResponse, SlpConsumptionControllerDeleteSlpConsumptionData, SlpConsumptionControllerDeleteSlpConsumptionResponse, SlpMeterReadingControllerGetReadingsData, SlpMeterReadingControllerGetReadingsResponse, SlpMeterReadingControllerReplaceReadingsData, SlpMeterReadingControllerReplaceReadingsResponse, SlpMeterReadingControllerCreateReadingData, SlpMeterReadingControllerCreateReadingResponse, SlpMeterReadingControllerUploadFileData, SlpMeterReadingControllerUploadFileResponse, SlpMeterReadingControllerDownloadReadingImageData, SlpMeterReadingControllerDownloadReadingImageResponse, GasCostInformationControllerUpdateGasCostInformationData, GasCostInformationControllerUpdateGasCostInformationResponse, BudgetTrackingControllerGetCostsData, BudgetTrackingControllerGetCostsResponse, ConsumptionTrendsControllerGetConsumptionTrendsByEnergyTypeData, ConsumptionTrendsControllerGetConsumptionTrendsByEnergyTypeResponse, ConsumptionTrendsControllerGetConsumptionHistoryData, ConsumptionTrendsControllerGetConsumptionHistoryResponse, InvoiceCostsControllerGetInvoiceCostsData, InvoiceCostsControllerGetInvoiceCostsResponse, CalculationsControllerRecalculateYearData, CalculationsControllerRecalculateYearResponse, CalculationsControllerRecalculateMonthData, CalculationsControllerRecalculateMonthResponse, CalculationsControllerRecalculateDayData, CalculationsControllerRecalculateDayResponse, CalculationsControllerCalculateEnetCostsData, CalculationsControllerCalculateEnetCostsResponse, CalculationsControllerCalculatePeakloadData, CalculationsControllerCalculatePeakloadResponse, CalculationsControllerCalculateBaseloadData, CalculationsControllerCalculateBaseloadResponse, CalculationsControllerGetLocationsOverviewData, CalculationsControllerGetLocationsOverviewResponse, CalculationsControllerGetLocationsMetricsData, CalculationsControllerGetLocationsMetricsResponse, CalculationsControllerGetLocationsMetricsCsvData, CalculationsControllerGetLocationsMetricsCsvResponse, CalculationsControllerStoreHedgeCostMonthlySummaryData, CalculationsControllerStoreHedgeCostMonthlySummaryResponse, CalculationsControllerRunCostCalculationsResponse, CalculationsControllerRecalculateDeviceMetricsData, CalculationsControllerRecalculateDeviceMetricsResponse, CostsSummaryControllerGetCostsSummaryData, CostsSummaryControllerGetCostsSummaryResponse, LocationControllerGetEnabledModulesForUserData, LocationControllerGetEnabledModulesForUserResponse, LocationControllerUpdateEnabledModulesData, LocationControllerUpdateEnabledModulesResponse, LocationControllerGetLocationEnabledModulesData, LocationControllerGetLocationEnabledModulesResponse, LocationControllerGetLocationData, LocationControllerGetLocationResponse, LocationControllerGetEnergyManagerSettingsData, LocationControllerGetEnergyManagerSettingsResponse, LocationControllerSetEnergyManagerSettingsData, LocationControllerSetEnergyManagerSettingsResponse, LocationControllerSetReportsSettingsData, LocationControllerSetReportsSettingsResponse, PricesControllerGetPricesResponse, PricesControllerGetCurrentPriceResponse, PricesControllerGetAverageYtdPriceResponse, PricesControllerGetElectricityPricesData, PricesControllerGetElectricityPricesResponse, SpotMarketControllerGetPricesData, SpotMarketControllerGetPricesResponse, SpotMarketControllerGetCompanyPricesData, SpotMarketControllerGetCompanyPricesResponse, EmberControllerAskChecklistAssistantData, EmberControllerAskChecklistAssistantResponse, EmberControllerAskDocumentAssistantData, EmberControllerAskDocumentAssistantResponse, EmberControllerGetEmbeddedFilesResponse, EmberControllerCreateEmbeddingsResponse, EmberControllerDeleteEmbeddingsByFileIdData, EmberControllerDeleteEmbeddingsByFileIdResponse, EmberControllerAskChatAssistantData, EmberControllerAskChatAssistantResponse, EmberControllerCancelMessageProcessingData, EmberControllerCancelMessageProcessingResponse, EmberControllerCleanupExpiredThreadsResponse, EmberControllerDeleteAllThreadsResponse, EmberControllerGetThreadStatsResponse, EmberControllerGetProposedQuestionsData, EmberControllerGetProposedQuestionsResponse, EmberControllerGenerateReportModuleConfigData, EmberControllerGenerateReportModuleConfigResponse, EmberControllerVisualizeAgentGraphData, EmberControllerVisualizeAgentGraphResponse, EmberControllerGetCallTranscriptsForCompanyData, EmberControllerGetCallTranscriptsForCompanyResponse, EmberControllerEmbedSingleCallTranscriptData, EmberControllerEmbedSingleCallTranscriptResponse, EmberControllerDeleteSingleCallTranscriptEmbeddingData, EmberControllerDeleteSingleCallTranscriptEmbeddingResponse, EmberControllerSyncCallTranscriptsData, EmberControllerSyncCallTranscriptsResponse, CustomReportControllerGetCustomReportData, CustomReportControllerGetCustomReportResponse, CustomReportControllerUpdateCustomReportData, CustomReportControllerUpdateCustomReportResponse, CustomReportControllerDeleteCustomReportData, CustomReportControllerDeleteCustomReportResponse, CustomReportControllerGetAllCustomReportsData, CustomReportControllerGetAllCustomReportsResponse, CustomReportControllerCreateCustomReportData, CustomReportControllerCreateCustomReportResponse, CustomReportControllerRequestReportingUpgradeResponse, CustomReportControllerGetCustomReportLogoData, CustomReportControllerGetCustomReportLogoResponse, CustomReportControllerGenerateReportManuallyData, CustomReportControllerGenerateReportManuallyResponse, CustomReportControllerGeneratePdfData, CustomReportControllerGeneratePdfResponse, CustomReportControllerValidatePdfTokenData, CustomReportControllerValidatePdfTokenResponse, CustomReportControllerGetModulesForPdfData, CustomReportControllerGetModulesForPdfResponse, CustomReportControllerGetDataCompletenessForPdfData, CustomReportControllerGetDataCompletenessForPdfResponse, CustomReportControllerGetModuleImageForPdfData, CustomReportControllerGetModuleImageForPdfResponse, CustomReportControllerTriggerRecoverySweepResponse, CustomReportControllerGetSentReportsData, CustomReportControllerGetSentReportsResponse, CustomReportControllerGetSentReportData, CustomReportControllerGetSentReportResponse, CustomReportControllerGetSentReportLogoData, CustomReportControllerGetSentReportLogoResponse, CustomReportControllerGetSentReportModulesData, CustomReportControllerGetSentReportModulesResponse, CustomReportControllerGetSentReportModulesWithDataData, CustomReportControllerGetSentReportModulesWithDataResponse, CustomReportControllerGetSentReportModuleWithDataData, CustomReportControllerGetSentReportModuleWithDataResponse, CustomReportControllerGetSentReportModuleImageData, CustomReportControllerGetSentReportModuleImageResponse, CustomReportControllerGetReportModulesData, CustomReportControllerGetReportModulesResponse, CustomReportControllerCreateReportModuleData, CustomReportControllerCreateReportModuleResponse, CustomReportControllerGetModuleData, CustomReportControllerGetModuleResponse, CustomReportControllerUpdateReportModuleData, CustomReportControllerUpdateReportModuleResponse, CustomReportControllerDeleteReportModuleData, CustomReportControllerDeleteReportModuleResponse, CustomReportControllerApplyTemplateData, CustomReportControllerApplyTemplateResponse, CustomReportControllerReorderReportModulesData, CustomReportControllerReorderReportModulesResponse, CustomReportControllerGetModuleImageData, CustomReportControllerGetModuleImageResponse, DataCompletenessControllerGetDataCompletenessData, DataCompletenessControllerGetDataCompletenessResponse, GapsControllerGetGapsData, GapsControllerGetGapsResponse, SeriesControllerListSeriesData, SeriesControllerListSeriesResponse, SeriesControllerCreateOrLinkSeriesData, SeriesControllerCreateOrLinkSeriesResponse, SeriesControllerGetSeriesByIdData, SeriesControllerGetSeriesByIdResponse, SeriesControllerUpdateSeriesData, SeriesControllerUpdateSeriesResponse, SeriesControllerDeleteSeriesData, SeriesControllerDeleteSeriesResponse, MeterSeriesControllerLinkMetersToSeriesData, MeterSeriesControllerLinkMetersToSeriesResponse, MeterSeriesControllerUnlinkMetersFromSeriesData, MeterSeriesControllerUnlinkMetersFromSeriesResponse, MeterSeriesControllerBatchUpdateMeterSeriesTitlesData, MeterSeriesControllerBatchUpdateMeterSeriesTitlesResponse, MeterSeriesControllerGetSeriesForMeterData, MeterSeriesControllerGetSeriesForMeterResponse, MeterSeriesControllerGetMetersForSeriesData, MeterSeriesControllerGetMetersForSeriesResponse, MeterSeriesControllerGetAllSeriesForDeviceWithLinkStatusData, MeterSeriesControllerGetAllSeriesForDeviceWithLinkStatusResponse, MeterSeriesControllerGetAllMetersForDeviceWithLinkStatusData, MeterSeriesControllerGetAllMetersForDeviceWithLinkStatusResponse, SankeyControllerGetSankeyData, SankeyControllerGetSankeyResponse, SankeyControllerGetSankeyCsvData, SankeyControllerGetSankeyCsvResponse, SankeyControllerGetMeterViewSankeyData, SankeyControllerGetMeterViewSankeyResponse, SankeyControllerGetMeterViewSankeyCsvData, SankeyControllerGetMeterViewSankeyCsvResponse, MeterViewControllerFindAllData, MeterViewControllerFindAllResponse, MeterViewControllerCreateData, MeterViewControllerCreateResponse, MeterViewControllerFindByIdData, MeterViewControllerFindByIdResponse, MeterViewControllerUpdateData, MeterViewControllerUpdateResponse, MeterViewControllerDeleteData, MeterViewControllerDeleteResponse, MeterViewControllerCreateNodeData, MeterViewControllerCreateNodeResponse, MeterViewControllerDeleteNodeData, MeterViewControllerDeleteNodeResponse, MeterViewControllerUpdateFolderNameData, MeterViewControllerUpdateFolderNameResponse, MeterViewControllerUpdateNodeParentData, MeterViewControllerUpdateNodeParentResponse, InvoicesControllerBatchCreatePastInvoicesResponse, InvoicesControllerBatchCreateScheduledInvoicesResponse, InvoicesControllerRecreateYearInvoicesForCompanyData, InvoicesControllerRecreateYearInvoicesForCompanyResponse, InvoicesControllerGetInvoicesData, InvoicesControllerGetInvoicesResponse, InvoicesControllerGetProcurementInvoicesData, InvoicesControllerGetProcurementInvoicesResponse, InvoicesControllerUpdateStatusData, InvoicesControllerUpdateStatusResponse, InvoicesControllerUpdateCostDetailsData, InvoicesControllerUpdateCostDetailsResponse, InvoicesControllerUpdateOcrCostDetailsData, InvoicesControllerUpdateOcrCostDetailsResponse, InvoicesControllerUpdateOcrCostVerificationData, InvoicesControllerUpdateOcrCostVerificationResponse, InvoicesControllerUpdateNotesData, InvoicesControllerUpdateNotesResponse, InvoicesControllerUploadExternalInvoiceData, InvoicesControllerUploadExternalInvoiceResponse, InvoicesControllerDeleteInvoiceFileData, InvoicesControllerDeleteInvoiceFileResponse, InvoicesControllerUploadInvoiceToMeterData, InvoicesControllerUploadInvoiceToMeterResponse, InvoicesControllerUploadExternalInvoiceLegacyData, InvoicesControllerUploadExternalInvoiceLegacyResponse, InvoicesControllerDeleteInvoiceData, InvoicesControllerDeleteInvoiceResponse, InvoicesControllerGetInvoiceByIdData, InvoicesControllerGetInvoiceByIdResponse, InvoicesControllerGetProcurementInvoiceByIdData, InvoicesControllerGetProcurementInvoiceByIdResponse, ManualInvoicePositionsControllerFindByLocationAndPeriodData, ManualInvoicePositionsControllerFindByLocationAndPeriodResponse, ManualInvoicePositionsControllerCreateData, ManualInvoicePositionsControllerCreateResponse, ManualInvoicePositionsControllerUpdateData, ManualInvoicePositionsControllerUpdateResponse, ManualInvoicePositionsControllerDeleteData, ManualInvoicePositionsControllerDeleteResponse, InsightsControllerGetInsightsData, InsightsControllerGetInsightsResponse, DataIngesterControllerSendDataFetchCommandData, DataIngesterControllerSendDataFetchCommandResponse, SmaControllerUpdateTokenData, SmaControllerUpdateTokenResponse, EnetControllerGetNetworkCostsData, EnetControllerGetNetworkCostsResponse, EnetControllerGetConcessionFeeData, EnetControllerGetConcessionFeeResponse, EnetControllerGetSpecialGridUsageData, EnetControllerGetSpecialGridUsageResponse, EnetControllerGetEnergyTaxData, EnetControllerGetEnergyTaxResponse, EnetControllerGetGasRlmMeteringData, EnetControllerGetGasRlmMeteringResponse, EnetControllerGetElectricityLeviesData, EnetControllerGetElectricityLeviesResponse, EnetControllerGetGasLeviesData, EnetControllerGetGasLeviesResponse, EnetControllerGetGasRlmEnergyZonesData, EnetControllerGetGasRlmEnergyZonesResponse, EnetControllerGetGasRlmPeakZonesData, EnetControllerGetGasRlmPeakZonesResponse, LogsControllerFindGapLogsByTimestampResponse, LogsControllerFindIngestionLogsData, LogsControllerFindIngestionLogsResponse, ReportsControllerGetReportRecipientsData, ReportsControllerGetReportRecipientsResponse, MultivariateLinearRegressionControllerCreateRegressionData, MultivariateLinearRegressionControllerCreateRegressionResponse, MultivariateLinearRegressionControllerGetAllRegressionsData, MultivariateLinearRegressionControllerGetAllRegressionsResponse, MultivariateLinearRegressionControllerUpdateRegressionData, MultivariateLinearRegressionControllerUpdateRegressionResponse, MultivariateLinearRegressionControllerGetRegressionByIdData, MultivariateLinearRegressionControllerGetRegressionByIdResponse, MultivariateLinearRegressionControllerDeleteRegressionData, MultivariateLinearRegressionControllerDeleteRegressionResponse, MultivariateLinearRegressionControllerGetActualVsModelSeriesData, MultivariateLinearRegressionControllerGetActualVsModelSeriesResponse, BaselineControllerFindAllData, BaselineControllerFindAllResponse, BaselineControllerCreateData, BaselineControllerCreateResponse, BaselineControllerGetAnalysisData, BaselineControllerGetAnalysisResponse, BaselineControllerUpdateData, BaselineControllerUpdateResponse, BaselineControllerDeleteData, BaselineControllerDeleteResponse, FeatureNewsControllerGetFeatureNewsData, FeatureNewsControllerGetFeatureNewsResponse, BudgetControllerGetInvoicesData, BudgetControllerGetInvoicesResponse, BudgetControllerGetInvoicesWithProcurementCostsData, BudgetControllerGetInvoicesWithProcurementCostsResponse, UploadControllerUploadConsumptionFilesData, UploadControllerUploadConsumptionFilesResponse, UploadControllerUploadDemoDevicesResponse, UploadControllerUploadSlpManualConsumptionData, UploadControllerUploadSlpManualConsumptionResponse, ManualMeterUploadControllerTemplateData, ManualMeterUploadControllerTemplateResponse, ManualMeterUploadControllerPreviewData, ManualMeterUploadControllerPreviewResponse, ManualMeterUploadControllerApplyData, ManualMeterUploadControllerApplyResponse, ManualMeterUploadControllerHistoryData, ManualMeterUploadControllerHistoryResponse, ManualMeterUploadControllerDetailData, ManualMeterUploadControllerDetailResponse, ManualMeterUploadControllerOriginalFileData, ManualMeterUploadControllerOriginalFileResponse, ManualMeterUploadControllerRetryData, ManualMeterUploadControllerRetryResponse, NormalizerControllerCheckDevicesHealthData, NormalizerControllerCheckDevicesHealthResponse, NormalizerControllerNormalizeData, NormalizerControllerNormalizeResponse, NormalizerControllerUpdateVirtualsAfterDataNormalizationData, NormalizerControllerUpdateVirtualsAfterDataNormalizationResponse, NormalizerControllerSetupVirtualMetersData, NormalizerControllerSetupVirtualMetersResponse, NormalizerControllerHandleManualNormalizedDataData, NormalizerControllerHandleManualNormalizedDataResponse, MeterOverviewControllerGetOverviewData, MeterOverviewControllerGetOverviewResponse, MeterOverviewControllerGetElectricityBalanceData, MeterOverviewControllerGetElectricityBalanceResponse, MeterOverviewControllerCreateGroupData, MeterOverviewControllerCreateGroupResponse, MeterOverviewControllerRenameGroupData, MeterOverviewControllerRenameGroupResponse, MeterOverviewControllerDeleteGroupData, MeterOverviewControllerDeleteGroupResponse, MeterOverviewControllerSetGroupMembershipData, MeterOverviewControllerSetGroupMembershipResponse, VirtualMeterControllerCreateVirtualDeviceData, VirtualMeterControllerCreateVirtualDeviceResponse, VirtualMeterControllerDeleteVirtualDeviceData, VirtualMeterControllerDeleteVirtualDeviceResponse, VirtualMeterControllerUpdateVirtualDeviceData, VirtualMeterControllerUpdateVirtualDeviceResponse, LocationsInfoControllerGetLocationsInfoData, LocationsInfoControllerGetLocationsInfoResponse, DeviceControllerGetDevicesByBuildingData, DeviceControllerGetDevicesByBuildingResponse, DeviceControllerUpsertDeviceData, DeviceControllerUpsertDeviceResponse, DeviceControllerDeleteDeviceData, DeviceControllerDeleteDeviceResponse, ForecastControllerFindAllData, ForecastControllerFindAllResponse, ForecastControllerCreateData, ForecastControllerCreateResponse, ForecastControllerFindOneByIdData, ForecastControllerFindOneByIdResponse, ForecastControllerGetForecastDataData, ForecastControllerGetForecastDataResponse, ForecastControllerPatchStateData, ForecastControllerPatchStateResponse, ForecastControllerCreateAdjustmentData, ForecastControllerCreateAdjustmentResponse, ForecastControllerUpdateAdjustmentData, ForecastControllerUpdateAdjustmentResponse, ForecastControllerDeleteAdjustmentData, ForecastControllerDeleteAdjustmentResponse, ForecastControllerPatchAdjustmentActiveData, ForecastControllerPatchAdjustmentActiveResponse, ShortTermForecastControllerGetShortTermForecastData, ShortTermForecastControllerGetShortTermForecastResponse, LoadAdjustmentControllerFindAllData, LoadAdjustmentControllerFindAllResponse, LoadAdjustmentControllerCreateData, LoadAdjustmentControllerCreateResponse, LoadAdjustmentControllerFindOneData, LoadAdjustmentControllerFindOneResponse, LoadAdjustmentControllerUpdateData, LoadAdjustmentControllerUpdateResponse, LoadAdjustmentControllerDeleteData, LoadAdjustmentControllerDeleteResponse, LoadAdjustmentControllerActivateData, LoadAdjustmentControllerActivateResponse, LoadAdjustmentControllerDeactivateData, LoadAdjustmentControllerDeactivateResponse, LoadPlanningForecastControllerGetForecastData, LoadPlanningForecastControllerGetForecastResponse, NaceCodeControllerGetAllCodesResponse, MachineCategoryControllerGetAllCategoriesResponse, MeterDocumentControllerGetMeterDocumentsData, MeterDocumentControllerGetMeterDocumentsResponse, MeterDocumentControllerCreateMeterDocumentData, MeterDocumentControllerCreateMeterDocumentResponse, MeterDocumentControllerDeleteMeterDocumentData, MeterDocumentControllerDeleteMeterDocumentResponse, MeterDocumentControllerDownloadData, MeterDocumentControllerDownloadResponse, UiPreferenceControllerGetPreferenceData, UiPreferenceControllerGetPreferenceResponse, UiPreferenceControllerUpdatePreferenceData, UiPreferenceControllerUpdatePreferenceResponse, InsightInboxControllerCreateData, InsightInboxControllerCreateResponse, InsightInboxControllerFindAllData, InsightInboxControllerFindAllResponse, InsightInboxControllerGetDismissalReasonConfigResponse, InsightInboxControllerFindOneData, InsightInboxControllerFindOneResponse, InsightInboxControllerUpdateData, InsightInboxControllerUpdateResponse, InsightInboxControllerDeleteData, InsightInboxControllerDeleteResponse, InsightInboxControllerGetChangeHistoryData, InsightInboxControllerGetChangeHistoryResponse, InsightInboxControllerBulkResolveData, InsightInboxControllerBulkResolveResponse, InsightInboxControllerBulkDismissData, InsightInboxControllerBulkDismissResponse, InsightInboxControllerBulkDismissGroupedData, InsightInboxControllerBulkDismissGroupedResponse, InsightInboxControllerBulkAssignData, InsightInboxControllerBulkAssignResponse, InsightInboxControllerBulkSetVisibilityData, InsightInboxControllerBulkSetVisibilityResponse, InsightInboxControllerSetVisibilityData, InsightInboxControllerSetVisibilityResponse, InsightInboxControllerInvestigateData, InsightInboxControllerInvestigateResponse, InsightInboxControllerConvertData, InsightInboxControllerConvertResponse, InsightInboxControllerResolveData, InsightInboxControllerResolveResponse, InsightInboxControllerDismissData, InsightInboxControllerDismissResponse, InsightInboxControllerAssignData, InsightInboxControllerAssignResponse, InsightInboxControllerMarkViewedData, InsightInboxControllerMarkViewedResponse, InsightInboxManualControllerCreateBaseloadBenchmarkData, InsightInboxManualControllerCreateBaseloadBenchmarkResponse, InsightInboxManualControllerCreateBaseloadTrendData, InsightInboxManualControllerCreateBaseloadTrendResponse, InsightSettingsControllerGetForLocationsData, InsightSettingsControllerGetForLocationsResponse, InsightSettingsControllerGetRecommendationsForLocationsData, InsightSettingsControllerGetRecommendationsForLocationsResponse, InsightSettingsControllerUpsertManyData, InsightSettingsControllerUpsertManyResponse, InsightSettingsControllerApplyRecommendationsData, InsightSettingsControllerApplyRecommendationsResponse, InsightSettingsControllerGetForMeterData, InsightSettingsControllerGetForMeterResponse, InsightSettingsControllerUpsertForMeterData, InsightSettingsControllerUpsertForMeterResponse, InsightSettingsControllerPatchForMeterData, InsightSettingsControllerPatchForMeterResponse, InsightSettingsControllerGetRecommendationForMeterData, InsightSettingsControllerGetRecommendationForMeterResponse, InsightSettingsControllerApplyRecommendationForMeterData, InsightSettingsControllerApplyRecommendationForMeterResponse, LocationProductionScheduleControllerGetForCallerResponse, LocationProductionScheduleControllerUpsertForLocationData, LocationProductionScheduleControllerUpsertForLocationResponse, LocationProductionScheduleControllerBulkUpsertData, LocationProductionScheduleControllerBulkUpsertResponse, InsightsOnboardingControllerGetStateResponse, InsightsOnboardingControllerStartResponse, InsightsOnboardingControllerCompleteResponse, InvitationControllerValidateData, InvitationControllerValidateResponse, InvitationControllerAcceptData, InvitationControllerAcceptResponse, InvitationControllerFindUserManagementPageData, InvitationControllerFindUserManagementPageResponse, InvitationControllerFindAllData, InvitationControllerFindAllResponse, InvitationControllerCreateData, InvitationControllerCreateResponse, InvitationControllerUpdateData, InvitationControllerUpdateResponse, InvitationControllerRevokeData, InvitationControllerRevokeResponse, SavingsFlowControllerCreateMeasureFromInsightData, SavingsFlowControllerCreateMeasureFromInsightResponse, PublicHolidaysControllerFindForLocationData, PublicHolidaysControllerFindForLocationResponse, PublicHolidaysControllerFindByParamsData, PublicHolidaysControllerFindByParamsResponse, SubmeterAttributionControllerGetAttributionData, SubmeterAttributionControllerGetAttributionResponse } from './types.gen';

/**
 * @returns unknown
 * @throws ApiError
 */
export const appControllerGetServiceStatus = (): CancelablePromise<AppControllerGetServiceStatusResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Login credentials
 * @returns AuthDto Returns token and user information upon valid credentials
 * @throws ApiError
 */
export const authControllerLogin = (data: AuthControllerLoginData): CancelablePromise<AuthControllerLoginResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/login',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Login credentials
 * @returns AuthDto Processes SSO login and returns token and user information
 * @returns unknown
 * @throws ApiError
 */
export const authControllerSsoLogin = (data: AuthControllerSsoLoginData): CancelablePromise<AuthControllerSsoLoginResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/login/sso',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Signup credentials
 * @returns AuthDto Processes SSO signup and returns token and user information
 * @returns unknown
 * @throws ApiError
 */
export const authControllerSsoSignup = (data: AuthControllerSsoSignupData): CancelablePromise<AuthControllerSsoSignupResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/signup/sso',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Sends a reset password email to the user
 * @throws ApiError
 */
export const authControllerSendPasswordResetEmail = (data: AuthControllerSendPasswordResetEmailData): CancelablePromise<AuthControllerSendPasswordResetEmailResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/reset-password/email',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Updates user password using a reset token
 * @throws ApiError
 */
export const authControllerUpdatePassword = (data: AuthControllerUpdatePasswordData): CancelablePromise<AuthControllerUpdatePasswordResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/auth/reset-password',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Updates the authenticated user's own password
 * @throws ApiError
 */
export const authControllerSelfUpdatePassword = (data: AuthControllerSelfUpdatePasswordData): CancelablePromise<AuthControllerSelfUpdatePasswordResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/auth/reset-password/me',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.userId
 * @param data.requestBody The new email address
 * @returns unknown Overrides the given user's email address, after verifying it is not already assigned to another user.
 * @throws ApiError
 */
export const authControllerUpdateEmail = (data: AuthControllerUpdateEmailData): CancelablePromise<AuthControllerUpdateEmailResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/auth/update-email/{userId}',
    path: {
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Filter users by company ID
 * @param data.locationId Filter users by location ID
 * @param data.regionId Filter users by region ID
 * @param data.consultancyId Filter users by consultancy ID
 * @param data.email Filter users by email
 * @param data.firebaseId Filter users by firebase ID
 * @param data.locationFirebaseId Filter users by location Firebase ID
 * @returns UserDto List of users in the format the admin view expects. This will become the only interface of returning users in the future.
 * @throws ApiError
 */
export const userControllerGetUsers = (data: UserControllerGetUsersData = {}): CancelablePromise<UserControllerGetUsersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/users',
    query: {
        companyId: data.companyId,
        locationId: data.locationId,
        regionId: data.regionId,
        consultancyId: data.consultancyId,
        email: data.email,
        firebaseId: data.firebaseId,
        locationFirebaseId: data.locationFirebaseId
    },
    errors: {
        400: 'Invalid query parameters'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create User
 * @returns UpsertUserResponseDto User created
 * @throws ApiError
 */
export const userControllerCreate = (data: UserControllerCreateData): CancelablePromise<UserControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/users',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Delete user
 * @returns DeleteUserRequestDto User deleted
 * @throws ApiError
 */
export const userControllerDeleteUser = (data: UserControllerDeleteUserData): CancelablePromise<UserControllerDeleteUserResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/users',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Filter users by company ID
 * @param data.locationId Filter users by location ID
 * @param data.regionId Filter users by region ID
 * @param data.consultancyId Filter users by consultancy ID
 * @param data.email Filter users by email
 * @param data.firebaseId Filter users by firebase ID
 * @param data.locationFirebaseId Filter users by location Firebase ID
 * @returns UserFrontendDto List of users in the format the frontend expects.
 * @throws ApiError
 */
export const userControllerGetFrontendUsers = (data: UserControllerGetFrontendUsersData = {}): CancelablePromise<UserControllerGetFrontendUsersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/users/frontend',
    query: {
        companyId: data.companyId,
        locationId: data.locationId,
        regionId: data.regionId,
        consultancyId: data.consultancyId,
        email: data.email,
        firebaseId: data.firebaseId,
        locationFirebaseId: data.locationFirebaseId
    },
    errors: {
        400: 'Invalid query parameters'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns UserDto User associated with the specified user ID
 * @throws ApiError
 */
export const userControllerGetUserById = (data: UserControllerGetUserByIdData): CancelablePromise<UserControllerGetUserByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/users/{id}',
    path: {
        id: data.id
    },
    errors: {
        400: 'Invalid query parameters'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns UserFrontendDto User associated with the specified user ID formatted for the frontend.
 * @throws ApiError
 */
export const userControllerGetFrontendUserById = (data: UserControllerGetFrontendUserByIdData): CancelablePromise<UserControllerGetFrontendUserByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/users/frontend/{id}',
    path: {
        id: data.id
    },
    errors: {
        400: 'Invalid query parameters'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId Firebase user ID
 * @param data.requestBody Patch User
 * @returns UpsertUserResponseDto User updated
 * @throws ApiError
 */
export const userControllerUpdate = (data: UserControllerUpdateData): CancelablePromise<UserControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/users/{userId}',
    path: {
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.userId
 * @param data.requestBody Patch user locations
 * @returns UpsertUserDto User updated
 * @throws ApiError
 */
export const userControllerUpdateAssignedLocations = (data: UserControllerUpdateAssignedLocationsData): CancelablePromise<UserControllerUpdateAssignedLocationsResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/users/{userId}/locations',
    path: {
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.userId ID of the user
 * @param data.companyId ID of the company to select
 * @returns unknown Company selected successfully
 * @throws ApiError
 */
export const userControllerSelectCompany = (data: UserControllerSelectCompanyData): CancelablePromise<UserControllerSelectCompanyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/users/{userId}/companies/{companyId}/select',
    path: {
        userId: data.userId,
        companyId: data.companyId
    },
    errors: {
        403: 'Forbidden: cannot select company for another user',
        404: 'User or user-company relation not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId User ID
 * @param data.requestBody
 * @returns unknown Company added successfully
 * @returns UserCompanyResponseDto
 * @throws ApiError
 */
export const userControllerAddUserCompany = (data: UserControllerAddUserCompanyData): CancelablePromise<UserControllerAddUserCompanyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/users/{userId}/companies',
    path: {
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request: user is already assigned to this company or other validation error',
        404: 'User not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId User ID
 * @param data.requestBody
 * @returns UserCompanyResponseDto User company assignments synced successfully
 * @throws ApiError
 */
export const userControllerSyncUserCompanies = (data: UserControllerSyncUserCompaniesData): CancelablePromise<UserControllerSyncUserCompaniesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/users/{userId}/companies',
    path: {
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request: the company list is empty or fails validation',
        404: 'User not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId User ID
 * @param data.companyId Company ID
 * @returns unknown Company removed successfully
 * @throws ApiError
 */
export const userControllerRemoveUserCompany = (data: UserControllerRemoveUserCompanyData): CancelablePromise<UserControllerRemoveUserCompanyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/users/{userId}/companies/{companyId}',
    path: {
        userId: data.userId,
        companyId: data.companyId
    },
    errors: {
        400: 'Bad Request: user must remain assigned to at least one company',
        403: 'Forbidden: only admins/consultants may remove another user from a company',
        404: 'User or user-company relation not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId User Firebase ID
 * @param data.requestBody Patch User
 * @returns UserFrontendDto User updated
 * @throws ApiError
 */
export const userControllerPatchUser = (data: UserControllerPatchUserData): CancelablePromise<UserControllerPatchUserResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/users/frontend/{userId}',
    path: {
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Update app reload required flag for all users
 * @returns unknown App reload required flag updated for all users
 * @throws ApiError
 */
export const userControllerUpdateAppReloadRequiredForAllUsers = (data: UserControllerUpdateAppReloadRequiredForAllUsersData): CancelablePromise<UserControllerUpdateAppReloadRequiredForAllUsersResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/users/app-reload-required',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns binary Profile picture image
 * @throws ApiError
 */
export const userControllerGetUserProfilePicture = (): CancelablePromise<UserControllerGetUserProfilePictureResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/users/self/profile-picture',
    errors: {
        404: 'Profile picture not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.formData
 * @returns unknown Profile picture uploaded successfully
 * @throws ApiError
 */
export const userControllerUploadUserProfilePicture = (data: UserControllerUploadUserProfilePictureData): CancelablePromise<UserControllerUploadUserProfilePictureResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/users/self/profile-picture',
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        400: 'Invalid or missing file'
    }
}); };

/**
 * @returns unknown Profile picture deleted successfully
 * @throws ApiError
 */
export const userControllerDeleteUserProfilePicture = (): CancelablePromise<UserControllerDeleteUserProfilePictureResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/users/self/profile-picture',
    errors: {
        404: 'Profile picture not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id ID of the user
 * @returns binary Profile picture image
 * @throws ApiError
 */
export const userControllerGetUserProfilePictureById = (data: UserControllerGetUserProfilePictureByIdData): CancelablePromise<UserControllerGetUserProfilePictureByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/users/{id}/profile-picture',
    path: {
        id: data.id
    },
    errors: {
        404: 'User or profile picture not found'
    }
}); };

/**
 * @returns unknown Successfully hydrated user data to Kafka
 * @throws ApiError
 */
export const userControllerHydrateUsersToKafka = (): CancelablePromise<UserControllerHydrateUsersToKafkaResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/users/hydrate-queue'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Trace Error
 * @returns unknown
 * @throws ApiError
 */
export const tracingControllerTraceError = (data: TracingControllerTraceErrorData): CancelablePromise<TracingControllerTraceErrorResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/tracing/trace-error',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.slug
 * @returns StrategyResponseDto
 * @throws ApiError
 */
export const ssoControllerGetCompanyStrategies = (data: SsoControllerGetCompanyStrategiesData): CancelablePromise<SsoControllerGetCompanyStrategiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/auth/sso/strategies/{slug}',
    path: {
        slug: data.slug
    }
}); };

/**
 * Get all consultancies
 * @returns ConsultancyDto
 * @throws ApiError
 */
export const consultancyControllerGetAll = (): CancelablePromise<ConsultancyControllerGetAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consultancies'
}); };

/**
 * Create consultancy
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ConsultancyDto
 * @throws ApiError
 */
export const consultancyControllerCreate = (data: ConsultancyControllerCreateData): CancelablePromise<ConsultancyControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/consultancies',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get consultancy by id
 * @param data The data for the request.
 * @param data.id
 * @returns ConsultancyDto
 * @throws ApiError
 */
export const consultancyControllerGetById = (data: ConsultancyControllerGetByIdData): CancelablePromise<ConsultancyControllerGetByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consultancies/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * Update consultancy
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns ConsultancyDto
 * @throws ApiError
 */
export const consultancyControllerUpdate = (data: ConsultancyControllerUpdateData): CancelablePromise<ConsultancyControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/consultancies/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Delete consultancy
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerDelete = (data: ConsultancyControllerDeleteData): CancelablePromise<ConsultancyControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/consultancies/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * Get the list of companies attached to the consultancy, or available to be attached
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerGetAvailableCompanies = (data: ConsultancyControllerGetAvailableCompaniesData): CancelablePromise<ConsultancyControllerGetAvailableCompaniesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consultancies/{id}/companies',
    path: {
        id: data.id
    }
}); };

/**
 * Add company to consultancy
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerAddCompanies = (data: ConsultancyControllerAddCompaniesData): CancelablePromise<ConsultancyControllerAddCompaniesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/consultancies/{id}/companies',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Add user to consultancy (sync user companies)
 * @param data The data for the request.
 * @param data.id
 * @returns User
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerGetConsultancyUsers = (data: ConsultancyControllerGetConsultancyUsersData): CancelablePromise<ConsultancyControllerGetConsultancyUsersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consultancies/{id}/users',
    path: {
        id: data.id
    }
}); };

/**
 * Add user to consultancy (sync user companies)
 * @param data The data for the request.
 * @param data.id
 * @param data.userId
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerAddUserToConsultancy = (data: ConsultancyControllerAddUserToConsultancyData): CancelablePromise<ConsultancyControllerAddUserToConsultancyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/consultancies/{id}/users/{userId}',
    path: {
        id: data.id,
        userId: data.userId
    }
}); };

/**
 * Remove user from consultancy (sync user companies)
 * @param data The data for the request.
 * @param data.id
 * @param data.userId
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerRemoveUserFromConsultancy = (data: ConsultancyControllerRemoveUserFromConsultancyData): CancelablePromise<ConsultancyControllerRemoveUserFromConsultancyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/consultancies/{id}/users/{userId}',
    path: {
        id: data.id,
        userId: data.userId
    }
}); };

/**
 * Attach a list of companies to a consultant
 * @param data The data for the request.
 * @param data.id
 * @param data.userId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerAttachCompaniesToUser = (data: ConsultancyControllerAttachCompaniesToUserData): CancelablePromise<ConsultancyControllerAttachCompaniesToUserResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/consultancies/{id}/users/{userId}/companies',
    path: {
        id: data.id,
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerGetLogo = (data: ConsultancyControllerGetLogoData): CancelablePromise<ConsultancyControllerGetLogoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consultancies/{id}/logo',
    path: {
        id: data.id
    }
}); };

/**
 * Request meter creation - sends emails to operations and consultant
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const consultancyControllerRequestMeterCreation = (data: ConsultancyControllerRequestMeterCreationData): CancelablePromise<ConsultancyControllerRequestMeterCreationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/consultancies/request-meter-creation',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Upsert company region
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Upsert company region
 * @throws ApiError
 */
export const regionControllerUpsertCompanyRegion = (data: RegionControllerUpsertCompanyRegionData): CancelablePromise<RegionControllerUpsertCompanyRegionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/companies/{companyId}/regions',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get company regions
 * @param data The data for the request.
 * @param data.companyId
 * @returns unknown[] Get company regions
 * @throws ApiError
 */
export const companyControllerGetCompanyRegions = (data: CompanyControllerGetCompanyRegionsData): CancelablePromise<CompanyControllerGetCompanyRegionsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/regions',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * Delete company region
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.regionId Region ID
 * @returns unknown Delete company region
 * @throws ApiError
 */
export const regionControllerDeleteCompanyRegion = (data: RegionControllerDeleteCompanyRegionData): CancelablePromise<RegionControllerDeleteCompanyRegionResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/companies/{companyId}/regions/{regionId}',
    path: {
        companyId: data.companyId,
        regionId: data.regionId
    }
}); };

/**
 * @returns Role
 * @throws ApiError
 */
export const rolesControllerFindAll = (): CancelablePromise<RolesControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/roles'
}); };

/**
 * @param data The data for the request.
 * @param data.formData Upload files to object storage
 * @returns ObjectStoragePostResponseDto Files uploaded successfully
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageControllerUpload = (data: ObjectStorageControllerUploadData): CancelablePromise<ObjectStorageControllerUploadResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/object-storage',
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.fileId
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageControllerDownload = (data: ObjectStorageControllerDownloadData): CancelablePromise<ObjectStorageControllerDownloadResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/object-storage',
    query: {
        fileId: data.fileId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.fileId
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageControllerDelete = (data: ObjectStorageControllerDeleteData): CancelablePromise<ObjectStorageControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/object-storage',
    query: {
        fileId: data.fileId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.fileId
 * @returns ObjectStorageDto Successful response
 * @throws ApiError
 */
export const objectStorageControllerGetFileMetadata = (data: ObjectStorageControllerGetFileMetadataData): CancelablePromise<ObjectStorageControllerGetFileMetadataResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/object-storage/metadata',
    query: {
        fileId: data.fileId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageControllerDownloadConsultantsLoadProfileTemplate = (data: ObjectStorageControllerDownloadConsultantsLoadProfileTemplateData): CancelablePromise<ObjectStorageControllerDownloadConsultantsLoadProfileTemplateResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/object-storage/consultants/load-profile-template',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.formData Upload files to object storage
 * @returns ObjectStorageV2PostResponseDto Files uploaded successfully
 * @throws ApiError
 */
export const objectStorageV2ControllerUpload = (data: ObjectStorageV2ControllerUploadData): CancelablePromise<ObjectStorageV2ControllerUploadResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/object-storage',
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.uid
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageV2ControllerDownloadByUid = (data: ObjectStorageV2ControllerDownloadByUidData): CancelablePromise<ObjectStorageV2ControllerDownloadByUidResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/object-storage',
    query: {
        uid: data.uid
    }
}); };

/**
 * @param data The data for the request.
 * @param data.uid
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageV2ControllerDeleteByUid = (data: ObjectStorageV2ControllerDeleteByUidData): CancelablePromise<ObjectStorageV2ControllerDeleteByUidResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/object-storage',
    query: {
        uid: data.uid
    }
}); };

/**
 * @param data The data for the request.
 * @param data.formData Upload files to object storage
 * @param data.companyId Company ID for cross-tenant upload
 * @returns ObjectStorageV2PostResponseDto Files uploaded successfully
 * @throws ApiError
 */
export const objectStorageV2ControllerUploadAdmin = (data: ObjectStorageV2ControllerUploadAdminData): CancelablePromise<ObjectStorageV2ControllerUploadAdminResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/object-storage/admin',
    query: {
        companyId: data.companyId
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.uid
 * @param data.companyId
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageV2ControllerDownloadByUidAdmin = (data: ObjectStorageV2ControllerDownloadByUidAdminData): CancelablePromise<ObjectStorageV2ControllerDownloadByUidAdminResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/object-storage/admin',
    query: {
        uid: data.uid,
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.uid
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageV2ControllerDeleteByUidAdmin = (data: ObjectStorageV2ControllerDeleteByUidAdminData): CancelablePromise<ObjectStorageV2ControllerDeleteByUidAdminResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/object-storage/admin',
    query: {
        uid: data.uid
    }
}); };

/**
 * @param data The data for the request.
 * @param data.uid
 * @returns ObjectStorageV2MetadataDto Successful response
 * @throws ApiError
 */
export const objectStorageV2ControllerGetFileMetadataByUid = (data: ObjectStorageV2ControllerGetFileMetadataByUidData): CancelablePromise<ObjectStorageV2ControllerGetFileMetadataByUidResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/object-storage/metadata',
    query: {
        uid: data.uid
    }
}); };

/**
 * @param data The data for the request.
 * @param data.uid File UID
 * @param data.companyId Company ID for cross-tenant lookup
 * @returns ObjectStorageV2MetadataDto Successful response
 * @throws ApiError
 */
export const objectStorageV2ControllerGetFileMetadataByUidAdmin = (data: ObjectStorageV2ControllerGetFileMetadataByUidAdminData): CancelablePromise<ObjectStorageV2ControllerGetFileMetadataByUidAdminResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/object-storage/metadata/admin',
    query: {
        uid: data.uid,
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @returns unknown
 * @throws ApiError
 */
export const objectStorageV2ControllerDownloadConsultantsLoadProfileTemplate = (data: ObjectStorageV2ControllerDownloadConsultantsLoadProfileTemplateData): CancelablePromise<ObjectStorageV2ControllerDownloadConsultantsLoadProfileTemplateResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/object-storage/consultants/load-profile-template',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @param data.years
 * @param data.buildingId
 * @returns EmissionsComparisonDto Yearly comparison of emission
 * @throws ApiError
 */
export const emissionsControllerGetEmissionsComparison = (data: EmissionsControllerGetEmissionsComparisonData): CancelablePromise<EmissionsControllerGetEmissionsComparisonResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/emissions/{locationId}/yearly-comparison',
    path: {
        locationId: data.locationId
    },
    query: {
        years: data.years,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @returns AvailableMeterYearsDto List of available years for the meters in a location
 * @throws ApiError
 */
export const meterControllerGetAvailableYearsByLocation = (data: MeterControllerGetAvailableYearsByLocationData): CancelablePromise<MeterControllerGetAvailableYearsByLocationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/locations/{locationId}/available-years',
    path: {
        locationId: data.locationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns AvailableMeterYearsDto List of available years for the meters in a company
 * @throws ApiError
 */
export const meterControllerGetAvailableYearsByCompany = (data: MeterControllerGetAvailableYearsByCompanyData): CancelablePromise<MeterControllerGetAvailableYearsByCompanyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/companies/{companyId}/available-years',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationIds Locations whose meters are returned.
 * @returns MeterInfrastructureSettingsListDto Infrastructure settings of every meter of the given locations.
 * @throws ApiError
 */
export const meterControllerGetBulkInfrastructureSettings = (data: MeterControllerGetBulkInfrastructureSettingsData): CancelablePromise<MeterControllerGetBulkInfrastructureSettingsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/infrastructure-settings',
    query: {
        locationIds: data.locationIds
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns MeterInfrastructureSettingsListDto Updates aggregation level, asset purpose and asset type for many meters at once.
 * @throws ApiError
 */
export const meterControllerPutBulkInfrastructureSettings = (data: MeterControllerPutBulkInfrastructureSettingsData): CancelablePromise<MeterControllerPutBulkInfrastructureSettingsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/meters/infrastructure-settings/bulk',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.buildingId
 * @returns InfrastructureSettingsSelectOneResponseDto Get infrastructure settings for given device.
 * @throws ApiError
 */
export const meterControllerGetInfrastructureSettings = (data: MeterControllerGetInfrastructureSettingsData): CancelablePromise<MeterControllerGetInfrastructureSettingsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/infrastructure-settings/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    query: {
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.buildingId
 * @param data.requestBody
 * @returns InfrastructureSettingsUpdateOneResponseDto Create or updates infrastructure settings for given device.
 * @throws ApiError
 */
export const meterControllerPutInfrastructureSettings = (data: MeterControllerPutInfrastructureSettingsData): CancelablePromise<MeterControllerPutInfrastructureSettingsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/meters/infrastructure-settings/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    query: {
        buildingId: data.buildingId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Cyclic reference detected in meter hierarchy or other validation errors.'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.buildingId
 * @returns PossibleParentMetersResponseDto Return possible parent meters for given device.
 * @throws ApiError
 */
export const meterControllerGetPossibleParentMeters = (data: MeterControllerGetPossibleParentMetersData): CancelablePromise<MeterControllerGetPossibleParentMetersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/{deviceId}/possible-parent-meters',
    path: {
        deviceId: data.deviceId
    },
    query: {
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SlpMeterDto Create a new meter
 * @throws ApiError
 */
export const meterControllerCreateSlpMeter = (data: MeterControllerCreateSlpMeterData): CancelablePromise<MeterControllerCreateSlpMeterResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/meters/slp',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.requestBody
 * @returns SlpMeterDto Update meter based on deviceId
 * @throws ApiError
 */
export const meterControllerUpdateSlpMeter = (data: MeterControllerUpdateSlpMeterData): CancelablePromise<MeterControllerUpdateSlpMeterResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/meters/slp/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.buildingId
 * @returns unknown Delete a meter based on deviceId and buildingId
 * @throws ApiError
 */
export const meterControllerDeleteSlpMeter = (data: MeterControllerDeleteSlpMeterData): CancelablePromise<MeterControllerDeleteSlpMeterResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/meters/slp/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    query: {
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.buildingId
 * @returns SlpMeterDto Return SLP meter details based on deviceId and buildingId
 * @throws ApiError
 */
export const meterControllerGetSlpMeter = (data: MeterControllerGetSlpMeterData): CancelablePromise<MeterControllerGetSlpMeterResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/slp/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    query: {
        buildingId: data.buildingId
    },
    errors: {
        401: 'User does not have access to the location',
        404: 'Meter not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.buildingId Building ID
 * @param data.locationId Location ID
 * @param data.regionId Region ID
 * @param data.deviceIds Devices
 * @param data.includeTimeframeTotalConsumption Include YTD consumption data (peakloadYtd, totalConsumptionYtd)
 * @param data.includeYtdTotalConsumption Include YTD consumption (totalConsumptionYtd) unitl the end of the current day
 * @param data.includeYtdTotalConsumptionUntilEndOfMonth Include YTD consumption (totalConsumptionYtd) until the end of the current month
 * @param data.from Start date for data filtering (YYYY-MM-DD)
 * @param data.to End date for data filtering (YYYY-MM-DD)
 * @param data.includeFullSeries Include data series with kW and kWh values (requires from and to)
 * @param data.granularity Granularity to display the consumptiondata series
 * @param data.includeTimeframePeakloadAndBaseload Include peakload and baseload in timeframe
 * @param data.includeYtdPeakloadAndBaseload Include YTD peakload and baseload
 * @returns MeterResponseDto List of meters
 * @throws ApiError
 */
export const meterControllerGetMeters = (data: MeterControllerGetMetersData): CancelablePromise<MeterControllerGetMetersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters',
    query: {
        companyId: data.companyId,
        buildingId: data.buildingId,
        locationId: data.locationId,
        regionId: data.regionId,
        deviceIds: data.deviceIds,
        includeTimeframeTotalConsumption: data.includeTimeframeTotalConsumption,
        includeYtdTotalConsumption: data.includeYtdTotalConsumption,
        includeYtdTotalConsumptionUntilEndOfMonth: data.includeYtdTotalConsumptionUntilEndOfMonth,
        from: data.from,
        to: data.to,
        includeFullSeries: data.includeFullSeries,
        granularity: data.granularity,
        includeTimeframePeakloadAndBaseload: data.includeTimeframePeakloadAndBaseload,
        includeYtdPeakloadAndBaseload: data.includeYtdPeakloadAndBaseload
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.buildingId Building ID
 * @param data.locationId Location ID
 * @param data.regionId Region ID
 * @param data.deviceIds Devices
 * @param data.slpDataSource Data source of the SLP meter
 * @returns SlpMeterResponseDto List of SLP meters
 * @throws ApiError
 */
export const meterControllerGetSlpMeters = (data: MeterControllerGetSlpMetersData): CancelablePromise<MeterControllerGetSlpMetersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/slps',
    query: {
        companyId: data.companyId,
        buildingId: data.buildingId,
        locationId: data.locationId,
        regionId: data.regionId,
        deviceIds: data.deviceIds,
        slpDataSource: data.slpDataSource
    }
}); };

/**
 * @param data The data for the request.
 * @param data.buildingId Building ID
 * @param data.companyId Company ID
 * @param data.deviceIds Device IDs to filter
 * @param data.energyTypes Energy types to filter
 * @param data.granularity Time granularity
 * @param data.isMain Filter main meters only
 * @param data.isVirtual Filter virtual meters only
 * @param data.locationId Location ID
 * @param data.regionId Region ID
 * @param data.source API provider source
 * @param data.valueType Value type
 * @returns MeterInfoResponseDto List of meters information without consumption data
 * @throws ApiError
 */
export const meterControllerGetMetersInfoByAllowedLocations = (data: MeterControllerGetMetersInfoByAllowedLocationsData = {}): CancelablePromise<MeterControllerGetMetersInfoByAllowedLocationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/info',
    query: {
        buildingId: data.buildingId,
        companyId: data.companyId,
        deviceIds: data.deviceIds,
        energyTypes: data.energyTypes,
        granularity: data.granularity,
        isMain: data.isMain,
        isVirtual: data.isVirtual,
        locationId: data.locationId,
        regionId: data.regionId,
        source: data.source,
        valueType: data.valueType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Filter by company ID
 * @param data.locationId Filter by location ID
 * @param data.buildingId Filter by building ID
 * @returns MeterEvaluationResponseDto List of meter evaluation records from database. Use /meters/energy-evaluation for calculated scores.
 * @throws ApiError
 */
export const meterControllerGetMeterEvaluations = (data: MeterControllerGetMeterEvaluationsData = {}): CancelablePromise<MeterControllerGetMeterEvaluationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/evaluations',
    query: {
        companyId: data.companyId,
        locationId: data.locationId,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Meter evaluation created successfully
 * @throws ApiError
 */
export const meterControllerCreateMeterEvaluation = (data: MeterControllerCreateMeterEvaluationData): CancelablePromise<MeterControllerCreateMeterEvaluationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/meters/evaluations',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'Meter not found',
        409: 'Evaluation already exists for this meter'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.meterId
 * @returns unknown Meter evaluation deleted successfully
 * @throws ApiError
 */
export const meterControllerDeleteMeterEvaluation = (data: MeterControllerDeleteMeterEvaluationData): CancelablePromise<MeterControllerDeleteMeterEvaluationResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/meters/evaluations/{meterId}',
    path: {
        meterId: data.meterId
    },
    errors: {
        400: 'Cannot delete evaluation for meters marked as Significant Energy Consumer (SEU)',
        404: 'Evaluation not found for this meter'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.buildingId Building ID
 * @param data.locationId Location ID
 * @param data.regionId Region ID
 * @param data.from Start date for data filtering (YYYY-MM-DD)
 * @param data.to End date for data filtering (YYYY-MM-DD)
 * @returns MeterEvaluationDto List of meters with energy evaluation scores. Automatically includes all meters marked as Significant Energy Consumers (isSignificantEnergyConsumer = true). Newly marked SEU meters are automatically added on the next call. Use POST /meters/evaluations to manually add more meters or DELETE /meters/evaluations/:meterId to remove meters from evaluation.
 * @throws ApiError
 */
export const meterControllerGetEnergyEvaluation = (data: MeterControllerGetEnergyEvaluationData): CancelablePromise<MeterControllerGetEnergyEvaluationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/energy-evaluation',
    query: {
        companyId: data.companyId,
        buildingId: data.buildingId,
        locationId: data.locationId,
        regionId: data.regionId,
        from: data.from,
        to: data.to
    }
}); };

/**
 * Create a new document template
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DocumentTemplateDto The document template has been successfully created.
 * @throws ApiError
 */
export const documentTemplateControllerCreate = (data: DocumentTemplateControllerCreateData): CancelablePromise<DocumentTemplateControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/document-templates',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad request.'
    }
}); };

/**
 * Get all document templates
 * @param data The data for the request.
 * @param data.isStatic
 * @param data.isSuggested
 * @returns DocumentTemplateDtoList List of all document templates.
 * @throws ApiError
 */
export const documentTemplateControllerFindAll = (data: DocumentTemplateControllerFindAllData = {}): CancelablePromise<DocumentTemplateControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/document-templates',
    query: {
        isStatic: data.isStatic,
        isSuggested: data.isSuggested
    }
}); };

/**
 * Get a document template by ID
 * @param data The data for the request.
 * @param data.id
 * @returns DocumentTemplateDto The document template with the specified ID.
 * @throws ApiError
 */
export const documentTemplateControllerFindOne = (data: DocumentTemplateControllerFindOneData): CancelablePromise<DocumentTemplateControllerFindOneResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/document-templates/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Document template not found.'
    }
}); };

/**
 * Update a document template by ID
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns DocumentTemplateDto The document template has been successfully updated.
 * @throws ApiError
 */
export const documentTemplateControllerUpdate = (data: DocumentTemplateControllerUpdateData): CancelablePromise<DocumentTemplateControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/document-templates/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'Document template not found.'
    }
}); };

/**
 * Delete a document template by ID
 * @param data The data for the request.
 * @param data.id
 * @returns void The document template has been successfully deleted.
 * @throws ApiError
 */
export const documentTemplateControllerRemove = (data: DocumentTemplateControllerRemoveData): CancelablePromise<DocumentTemplateControllerRemoveResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/document-templates/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Document template not found.'
    }
}); };

/**
 * Update a document template content by ID
 * @param data The data for the request.
 * @param data.id
 * @returns unknown The document template has been successfully updated.
 * @returns void
 * @throws ApiError
 */
export const documentTemplateControllerUpdateContent = (data: DocumentTemplateControllerUpdateContentData): CancelablePromise<DocumentTemplateControllerUpdateContentResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/document-templates/{id}/content',
    path: {
        id: data.id
    },
    errors: {
        404: 'Document template not found.'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Registers usage analytics events
 * @throws ApiError
 */
export const usageAnalyticsControllerTrackEvent = (data: UsageAnalyticsControllerTrackEventData): CancelablePromise<UsageAnalyticsControllerTrackEventResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/usage-analytics/event',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @param data.formData Upload hedging CSV for a given location
 * @returns unknown Upload hedging CSV for a given location
 * @throws ApiError
 */
export const hedgingControllerUploadFile = (data: HedgingControllerUploadFileData): CancelablePromise<HedgingControllerUploadFileResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/cost/hedging',
    query: {
        locationId: data.locationId
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID to filter visualizations. Required if locationId is not provided.
 * @param data.locationId Location ID to filter visualizations. Required if companyId is not provided.
 * @param data.page The page number for pagination. Must be greater than or equal to 1.
 * @param data.limit The number of results per page. Must be greater than or equal to 1.
 * @param data.sortBy Field to sort the results by.
 * @param data.sortOrder Sort order for the results.
 * @returns Visualization
 * @throws ApiError
 */
export const visualizationControllerGetVisualizations = (data: VisualizationControllerGetVisualizationsData = {}): CancelablePromise<VisualizationControllerGetVisualizationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/analytics/visualization',
    query: {
        companyId: data.companyId,
        locationId: data.locationId,
        page: data.page,
        limit: data.limit,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id ID of the visualization to delete
 * @returns unknown Visualization deleted successfully
 * @throws ApiError
 */
export const visualizationControllerDeleteVisualization = (data: VisualizationControllerDeleteVisualizationData): CancelablePromise<VisualizationControllerDeleteVisualizationResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/analytics/visualization/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Visualization not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Location ID
 * @param data.companyId Company ID
 * @returns ApiGridUsagePriceResponseDto List of grid usage fees for location
 * @throws ApiError
 */
export const gridFeesControllerGetGridUsageFees = (data: GridFeesControllerGetGridUsageFeesData): CancelablePromise<GridFeesControllerGetGridUsageFeesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/grid-fees/locations/{locationId}/grid-usage',
    path: {
        locationId: data.locationId
    },
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GenericResponseDto Grid usage fee created/updated successfully
 * @throws ApiError
 */
export const gridFeesControllerUpsertGridUsageFee = (data: GridFeesControllerUpsertGridUsageFeeData): CancelablePromise<GridFeesControllerUpsertGridUsageFeeResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/grid-fees/grid-usage',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Location ID
 * @param data.year Year
 * @param data.month Month (1-12)
 * @param data.companyId Company ID
 * @returns GenericResponseDto Grid usage fee deleted successfully
 * @throws ApiError
 */
export const gridFeesControllerDeleteGridUsageFee = (data: GridFeesControllerDeleteGridUsageFeeData): CancelablePromise<GridFeesControllerDeleteGridUsageFeeResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/grid-fees/grid-usage/{locationId}/{year}/{month}',
    path: {
        locationId: data.locationId,
        year: data.year,
        month: data.month
    },
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Location ID
 * @param data.companyId Company ID
 * @returns ApiPeakLoadPriceResponseDto List of peak load prices for location
 * @throws ApiError
 */
export const gridFeesControllerGetPeakLoadPrices = (data: GridFeesControllerGetPeakLoadPricesData): CancelablePromise<GridFeesControllerGetPeakLoadPricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/grid-fees/locations/{locationId}/peak-load',
    path: {
        locationId: data.locationId
    },
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GenericResponseDto Peak load price created/updated successfully
 * @throws ApiError
 */
export const gridFeesControllerUpsertPeakLoadPrice = (data: GridFeesControllerUpsertPeakLoadPriceData): CancelablePromise<GridFeesControllerUpsertPeakLoadPriceResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/grid-fees/peak-load',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Location ID
 * @param data.year Year
 * @param data.month Month (1-12)
 * @param data.companyId Company ID
 * @returns GenericResponseDto Peak load price deleted successfully
 * @throws ApiError
 */
export const gridFeesControllerDeletePeakLoadPrice = (data: GridFeesControllerDeletePeakLoadPriceData): CancelablePromise<GridFeesControllerDeletePeakLoadPriceResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/grid-fees/peak-load/{locationId}/{year}/{month}',
    path: {
        locationId: data.locationId,
        year: data.year,
        month: data.month
    },
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @returns IsoChapterListResponseDto Fetch all ISO chapters
 * @throws ApiError
 */
export const isoChaptersControllerFindAll = (): CancelablePromise<IsoChaptersControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/chapters'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns IsoChapterResponseDto Create a new ISO chapter
 * @throws ApiError
 */
export const isoChaptersControllerCreate = (data: IsoChaptersControllerCreateData): CancelablePromise<IsoChaptersControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/chapters',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns IsoChapterResponseDto Update an ISO chapter by ID
 * @throws ApiError
 */
export const isoChaptersControllerUpdate = (data: IsoChaptersControllerUpdateData): CancelablePromise<IsoChaptersControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/chapters/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @returns IsoChapterResponseDto Delete an ISO chapter by ID
 * @throws ApiError
 */
export const isoChaptersControllerRemove = (data: IsoChaptersControllerRemoveData): CancelablePromise<IsoChaptersControllerRemoveResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/chapters/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @param data.chapterId Filter by chapter ID
 * @param data.measureId Filter by ISO Measure ID
 * @returns IsoDocumentResponseListDto Requested Document
 * @throws ApiError
 */
export const isoDocumentsControllerFindAll = (data: IsoDocumentsControllerFindAllData = {}): CancelablePromise<IsoDocumentsControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/documents',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        chapterId: data.chapterId,
        measureId: data.measureId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create Document
 * @returns IsoDocumentResponseDto Document created
 * @throws ApiError
 */
export const isoDocumentsControllerCreate = (data: IsoDocumentsControllerCreateData): CancelablePromise<IsoDocumentsControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/documents',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoDocumentFetchOneResponseDto Requested Document
 * @throws ApiError
 */
export const isoDocumentsControllerFindOneById = (data: IsoDocumentsControllerFindOneByIdData): CancelablePromise<IsoDocumentsControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/documents/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @returns void Document deleted
 * @throws ApiError
 */
export const isoDocumentsControllerDelete = (data: IsoDocumentsControllerDeleteData): CancelablePromise<IsoDocumentsControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/documents/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Document content
 * @returns unknown
 * @returns void Document content updated
 * @throws ApiError
 */
export const isoDocumentsControllerUpdateContent = (data: IsoDocumentsControllerUpdateContentData): CancelablePromise<IsoDocumentsControllerUpdateContentResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/documents/{id}/content',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Document meta data
 * @returns unknown
 * @returns void Document meta data updated
 * @throws ApiError
 */
export const isoDocumentsControllerUpdateMetaData = (data: IsoDocumentsControllerUpdateMetaDataData): CancelablePromise<IsoDocumentsControllerUpdateMetaDataResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/documents/{id}/meta-data',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @returns void Document file uploaded
 * @throws ApiError
 */
export const isoDocumentsControllerUploadFile = (data: IsoDocumentsControllerUploadFileData): CancelablePromise<IsoDocumentsControllerUploadFileResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/documents/{id}/upload-document',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @returns void Uploaded Document deleted
 * @throws ApiError
 */
export const isoDocumentsControllerDeleteUploadDocument = (data: IsoDocumentsControllerDeleteUploadDocumentData): CancelablePromise<IsoDocumentsControllerDeleteUploadDocumentResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/documents/{id}/upload-document',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns IsoRiskFetchResponseListDto Requested Risks
 * @throws ApiError
 */
export const isoRiskControllerFindAll = (data: IsoRiskControllerFindAllData): CancelablePromise<IsoRiskControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/risks',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create Risk
 * @returns IsoRiskFetchOneResponseDto Risk created
 * @throws ApiError
 */
export const isoRiskControllerCreate = (data: IsoRiskControllerCreateData): CancelablePromise<IsoRiskControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/risks',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoRiskFetchOneResponseDto Requested Risk
 * @throws ApiError
 */
export const isoRiskControllerFindOneById = (data: IsoRiskControllerFindOneByIdData): CancelablePromise<IsoRiskControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/risks/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Risk
 * @returns IsoRiskFetchOneResponseDto Risk created
 * @throws ApiError
 */
export const isoRiskControllerUpdate = (data: IsoRiskControllerUpdateData): CancelablePromise<IsoRiskControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/risks/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Risk deleted
 * @throws ApiError
 */
export const isoRiskControllerDelete = (data: IsoRiskControllerDeleteData): CancelablePromise<IsoRiskControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/risks/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns IsoGoalFetchResponseListDto Requested Goals
 * @throws ApiError
 */
export const isoGoalsControllerFindAll = (data: IsoGoalsControllerFindAllData): CancelablePromise<IsoGoalsControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/goals',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create Goal
 * @returns IsoGoalFetchResponseDto Goal created
 * @throws ApiError
 */
export const isoGoalsControllerCreate = (data: IsoGoalsControllerCreateData): CancelablePromise<IsoGoalsControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/goals',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoGoalFetchResponseDto Requested Goal
 * @throws ApiError
 */
export const isoGoalsControllerFindOneById = (data: IsoGoalsControllerFindOneByIdData): CancelablePromise<IsoGoalsControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/goals/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Goal
 * @returns IsoGoalFetchResponseDto Goal updated
 * @throws ApiError
 */
export const isoGoalsControllerUpdate = (data: IsoGoalsControllerUpdateData): CancelablePromise<IsoGoalsControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/goals/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Goal deleted
 * @throws ApiError
 */
export const isoGoalsControllerDelete = (data: IsoGoalsControllerDeleteData): CancelablePromise<IsoGoalsControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/goals/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @returns FetchEnpiSeuOptionsDto Available EnPI SEU options for a location
 * @throws ApiError
 */
export const isoEnpiControllerFindSeuOptions = (data: IsoEnpiControllerFindSeuOptionsData): CancelablePromise<IsoEnpiControllerFindSeuOptionsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/enpis/seu-options',
    query: {
        locationId: data.locationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FetchEnpiSeuOptionsDto Available EnPI SEU options for locations
 * @throws ApiError
 */
export const isoEnpiControllerFindSeuOptionsForLocations = (data: IsoEnpiControllerFindSeuOptionsForLocationsData): CancelablePromise<IsoEnpiControllerFindSeuOptionsForLocationsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/enpis/seu-options/batch',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns FetchEnpiListDto Requested ENPIs
 * @throws ApiError
 */
export const isoEnpiControllerFindAll = (data: IsoEnpiControllerFindAllData): CancelablePromise<IsoEnpiControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/enpis',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create ENPI
 * @returns FetchOneEnpiDto ENPI created
 * @throws ApiError
 */
export const isoEnpiControllerCreate = (data: IsoEnpiControllerCreateData): CancelablePromise<IsoEnpiControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/enpis',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns FetchOneEnpiDto Requested ENPI
 * @throws ApiError
 */
export const isoEnpiControllerFindOneById = (data: IsoEnpiControllerFindOneByIdData): CancelablePromise<IsoEnpiControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/enpis/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update ENPI
 * @returns FetchOneEnpiDto ENPI updated
 * @throws ApiError
 */
export const isoEnpiControllerUpdate = (data: IsoEnpiControllerUpdateData): CancelablePromise<IsoEnpiControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/enpis/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void ENPI deleted
 * @throws ApiError
 */
export const isoEnpiControllerDelete = (data: IsoEnpiControllerDeleteData): CancelablePromise<IsoEnpiControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/enpis/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Add comment
 * @returns void Comment added
 * @throws ApiError
 */
export const isoEnpiControllerAddComment = (data: IsoEnpiControllerAddCommentData): CancelablePromise<IsoEnpiControllerAddCommentResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/enpis/{id}/comments',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.interval
 * @returns unknown Batch ENPI update triggered
 * @throws ApiError
 */
export const isoEnpiControllerBatchUpdate = (data: IsoEnpiControllerBatchUpdateData): CancelablePromise<IsoEnpiControllerBatchUpdateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/enpis/batch-update',
    query: {
        interval: data.interval
    }
}); };

/**
 * Trigger daily EnPI update (filtered)
 * @returns unknown Daily EnPI update started; it runs in the background
 * @throws ApiError
 */
export const isoEnpiControllerTriggerDailyUpdate = (): CancelablePromise<IsoEnpiControllerTriggerDailyUpdateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/enpis/daily-update'
}); };

/**
 * Recalculate EnPI
 * @param data The data for the request.
 * @param data.id
 * @returns void EnPI recalculated
 * @throws ApiError
 */
export const isoEnpiControllerRecalculate = (data: IsoEnpiControllerRecalculateData): CancelablePromise<IsoEnpiControllerRecalculateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/enpis/{id}/recalculate',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @param data.statuses
 * @returns IsoMeasureFetchResponseListDto Requested Measures
 * @throws ApiError
 */
export const isoMeasuresControllerFindAll = (data: IsoMeasuresControllerFindAllData = {}): CancelablePromise<IsoMeasuresControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/measures',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        statuses: data.statuses
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create Measure
 * @returns FetchOneIsoMeasureDto Measure created
 * @throws ApiError
 */
export const isoMeasuresControllerCreate = (data: IsoMeasuresControllerCreateData): CancelablePromise<IsoMeasuresControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/measures',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns FetchOneDetailIsoMeasureDto Requested Measure
 * @throws ApiError
 */
export const isoMeasuresControllerFindOneById = (data: IsoMeasuresControllerFindOneByIdData): CancelablePromise<IsoMeasuresControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/measures/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Measure
 * @returns FetchOneIsoMeasureDto Measure updated
 * @throws ApiError
 */
export const isoMeasuresControllerUpdate = (data: IsoMeasuresControllerUpdateData): CancelablePromise<IsoMeasuresControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/measures/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Measure deleted
 * @throws ApiError
 */
export const isoMeasuresControllerDelete = (data: IsoMeasuresControllerDeleteData): CancelablePromise<IsoMeasuresControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/measures/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const isoMeasuresControllerCreateMeasureDocuments = (): CancelablePromise<IsoMeasuresControllerCreateMeasureDocumentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/measures/create-documents'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns FetchOneDetailIsoMeasureDto Linked analytics baseline to the measure for Erfolgsmessung
 * @throws ApiError
 */
export const isoMeasuresControllerLinkSuccessMeasurementAnalyticsBaseline = (data: IsoMeasuresControllerLinkSuccessMeasurementAnalyticsBaselineData): CancelablePromise<IsoMeasuresControllerLinkSuccessMeasurementAnalyticsBaselineResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/measures/{id}/success-measurement/analytics-baseline',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Measure status
 * @returns FetchOneIsoMeasureDto Measure status updated
 * @throws ApiError
 */
export const isoMeasuresControllerPatchStatus = (data: IsoMeasuresControllerPatchStatusData): CancelablePromise<IsoMeasuresControllerPatchStatusResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/measures/{id}/status',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Validate Measure status update
 * @returns IsoMeasureStatusValidationResultDto Measure status update validation result
 * @throws ApiError
 */
export const isoMeasuresControllerValidateStatus = (data: IsoMeasuresControllerValidateStatusData): CancelablePromise<IsoMeasuresControllerValidateStatusResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/measures/{id}/status/validate',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Add comment
 * @returns void Comment added
 * @throws ApiError
 */
export const isoMeasuresControllerAddComment = (data: IsoMeasuresControllerAddCommentData): CancelablePromise<IsoMeasuresControllerAddCommentResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/measures/{id}/comments',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Create Measure Milestone
 * @returns IsoMilestoneFetchOneDto Milestone created
 * @throws ApiError
 */
export const isoMeasuresControllerCreateMilestone = (data: IsoMeasuresControllerCreateMilestoneData): CancelablePromise<IsoMeasuresControllerCreateMilestoneResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/measures/{id}/milestones',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.milestoneId
 * @param data.requestBody Update Measure Milestone
 * @returns IsoMilestoneFetchOneDto Milestone updated
 * @throws ApiError
 */
export const isoMeasuresControllerUpdateMilestone = (data: IsoMeasuresControllerUpdateMilestoneData): CancelablePromise<IsoMeasuresControllerUpdateMilestoneResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/measures/{id}/milestones/{milestoneId}',
    path: {
        id: data.id,
        milestoneId: data.milestoneId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.milestoneId
 * @returns IsoMilestoneFetchOneDto Milestone deleted
 * @throws ApiError
 */
export const isoMeasuresControllerDeleteMilestone = (data: IsoMeasuresControllerDeleteMilestoneData): CancelablePromise<IsoMeasuresControllerDeleteMilestoneResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/measures/{id}/milestones/{milestoneId}',
    path: {
        id: data.id,
        milestoneId: data.milestoneId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.milestoneId
 * @param data.requestBody Patch Milestone status
 * @returns IsoMilestoneFetchOneDto Milestone status updated created
 * @throws ApiError
 */
export const isoMeasuresControllerPatchMilestoneStatus = (data: IsoMeasuresControllerPatchMilestoneStatusData): CancelablePromise<IsoMeasuresControllerPatchMilestoneStatusResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/measures/{id}/milestones/{milestoneId}/status',
    path: {
        id: data.id,
        milestoneId: data.milestoneId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Milestone order
 * @returns unknown Milestone order updated
 * @throws ApiError
 */
export const isoMeasuresControllerUpdateMilestonesOrder = (data: IsoMeasuresControllerUpdateMilestonesOrderData): CancelablePromise<IsoMeasuresControllerUpdateMilestonesOrderResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/measures/{id}/milestones-order',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoMilestoneFetchOneDto Milestone deleted
 * @throws ApiError
 */
export const isoMeasuresControllerDeleteMeasureSavings = (data: IsoMeasuresControllerDeleteMeasureSavingsData): CancelablePromise<IsoMeasuresControllerDeleteMeasureSavingsResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/measures/{id}/clear-savings',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns FetchOneDetailIsoMeasureDto Measure auto-tracking activated
 * @throws ApiError
 */
export const isoMeasuresControllerActivateAutoTracking = (data: IsoMeasuresControllerActivateAutoTrackingData): CancelablePromise<IsoMeasuresControllerActivateAutoTrackingResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/measures/{id}/activate-auto-tracking',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId user id (email) of the respective user
 * @param data.companyId
 * @returns IsoOverviewModelDto Get ISO Overview for specific user
 * @throws ApiError
 */
export const isoControllerGetIsoOverview = (data: IsoControllerGetIsoOverviewData): CancelablePromise<IsoControllerGetIsoOverviewResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/overview',
    query: {
        userId: data.userId,
        companyId: data.companyId
    }
}); };

/**
 * @returns IsoChecklistConfigurationFetchListDto Get all ISO checklist configurations
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerFindAll = (): CancelablePromise<IsoChecklistConfigurationControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/checklist-configurations'
}); };

/**
 * @returns IsoChecklistConfigurationFetchDto Created iso checklist configurations
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerCreateChecklist = (): CancelablePromise<IsoChecklistConfigurationControllerCreateChecklistResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/checklist-configurations'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoChecklistConfigurationFetchDto Requested checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerFindOneById = (data: IsoChecklistConfigurationControllerFindOneByIdData): CancelablePromise<IsoChecklistConfigurationControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/checklist-configurations/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Delete checklist
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerDeleteChecklistConfiguration = (data: IsoChecklistConfigurationControllerDeleteChecklistConfigurationData): CancelablePromise<IsoChecklistConfigurationControllerDeleteChecklistConfigurationResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/checklist-configurations/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoChecklistConfigurationFetchDto Copies checklist by given id
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerCopyChecklist = (data: IsoChecklistConfigurationControllerCopyChecklistData): CancelablePromise<IsoChecklistConfigurationControllerCopyChecklistResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/checklist-configurations/{id}/copy',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoChecklistConfigurationFetchDto Set finalize status of checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerPatchStatus = (data: IsoChecklistConfigurationControllerPatchStatusData): CancelablePromise<IsoChecklistConfigurationControllerPatchStatusResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/checklist-configurations/{id}/finalize',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoChecklistConfigurationFetchDto Set finalize status of checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerUnFinalize = (data: IsoChecklistConfigurationControllerUnFinalizeData): CancelablePromise<IsoChecklistConfigurationControllerUnFinalizeResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/checklist-configurations/{id}/un-finalize',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns IsoChecklistConfigurationFetchDto Set checklist configuration to be latest
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerPatchLatest = (data: IsoChecklistConfigurationControllerPatchLatestData): CancelablePromise<IsoChecklistConfigurationControllerPatchLatestResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/checklist-configurations/{id}/set-latest',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Chapter Create
 * @returns IsoChecklistConfigurationFetchDto Adds chapter to checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerAddChecklistChapter = (data: IsoChecklistConfigurationControllerAddChecklistChapterData): CancelablePromise<IsoChecklistConfigurationControllerAddChecklistChapterResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/checklist-configurations/{id}/chapters',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @param data.requestBody Chapter Update
 * @returns IsoChecklistConfigurationFetchDto Updates chapter to checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerUpdateChecklistChapter = (data: IsoChecklistConfigurationControllerUpdateChecklistChapterData): CancelablePromise<IsoChecklistConfigurationControllerUpdateChecklistChapterResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}',
    path: {
        id: data.id,
        chapterId: data.chapterId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @returns IsoChecklistConfigurationFetchDto Deletes chapter from the checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerDeleteChecklistChapter = (data: IsoChecklistConfigurationControllerDeleteChecklistChapterData): CancelablePromise<IsoChecklistConfigurationControllerDeleteChecklistChapterResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}',
    path: {
        id: data.id,
        chapterId: data.chapterId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @param data.requestBody Sub Chapter Create
 * @returns IsoChecklistConfigurationFetchDto Adds sub chapter to chapter configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerAddChecklistSubChapter = (data: IsoChecklistConfigurationControllerAddChecklistSubChapterData): CancelablePromise<IsoChecklistConfigurationControllerAddChecklistSubChapterResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters',
    path: {
        id: data.id,
        chapterId: data.chapterId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @param data.subChapterId
 * @param data.requestBody Chapter Update
 * @returns IsoChecklistConfigurationFetchDto Updates sub chapter to chapter configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerUpdateChecklistSubChapter = (data: IsoChecklistConfigurationControllerUpdateChecklistSubChapterData): CancelablePromise<IsoChecklistConfigurationControllerUpdateChecklistSubChapterResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}',
    path: {
        id: data.id,
        chapterId: data.chapterId,
        subChapterId: data.subChapterId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @param data.subChapterId
 * @returns IsoChecklistConfigurationFetchDto Deletes chapter from the checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerDeleteChecklistSubChapter = (data: IsoChecklistConfigurationControllerDeleteChecklistSubChapterData): CancelablePromise<IsoChecklistConfigurationControllerDeleteChecklistSubChapterResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}',
    path: {
        id: data.id,
        chapterId: data.chapterId,
        subChapterId: data.subChapterId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @param data.subChapterId
 * @param data.requestBody Task Create
 * @returns IsoChecklistConfigurationFetchDto Adds task to sub chapter configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerAddTask = (data: IsoChecklistConfigurationControllerAddTaskData): CancelablePromise<IsoChecklistConfigurationControllerAddTaskResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}/tasks',
    path: {
        id: data.id,
        chapterId: data.chapterId,
        subChapterId: data.subChapterId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @param data.subChapterId
 * @param data.taskId
 * @param data.requestBody Tasks Update
 * @returns IsoChecklistConfigurationFetchDto Updates task to  sub chapter configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerUpdateTasks = (data: IsoChecklistConfigurationControllerUpdateTasksData): CancelablePromise<IsoChecklistConfigurationControllerUpdateTasksResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}/tasks/{taskId}',
    path: {
        id: data.id,
        chapterId: data.chapterId,
        subChapterId: data.subChapterId,
        taskId: data.taskId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.chapterId
 * @param data.subChapterId
 * @param data.taskId
 * @returns IsoChecklistConfigurationFetchDto Deletes task from the checklist configuration
 * @throws ApiError
 */
export const isoChecklistConfigurationControllerDeleteTask = (data: IsoChecklistConfigurationControllerDeleteTaskData): CancelablePromise<IsoChecklistConfigurationControllerDeleteTaskResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}/tasks/{taskId}',
    path: {
        id: data.id,
        chapterId: data.chapterId,
        subChapterId: data.subChapterId,
        taskId: data.taskId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns IsoChecklistFetchDto Find currently valid iso checklist by company
 * @throws ApiError
 */
export const isoChecklistControllerFindByCompanyId = (data: IsoChecklistControllerFindByCompanyIdData): CancelablePromise<IsoChecklistControllerFindByCompanyIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/checklists',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns IsoChecklistFetchDto Create checklist for a given company
 * @throws ApiError
 */
export const isoChecklistControllerCreateChecklistByCompany = (data: IsoChecklistControllerCreateChecklistByCompanyData): CancelablePromise<IsoChecklistControllerCreateChecklistByCompanyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/checklists',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.taskId
 * @returns IsoChecklistFetchDto Set tasks completed
 * @throws ApiError
 */
export const isoChecklistControllerMarkTaskCompleted = (data: IsoChecklistControllerMarkTaskCompletedData): CancelablePromise<IsoChecklistControllerMarkTaskCompletedResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/checklists/{id}/tasks/{taskId}/completed',
    path: {
        id: data.id,
        taskId: data.taskId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.taskId
 * @returns IsoChecklistFetchDto Set task open
 * @throws ApiError
 */
export const isoChecklistControllerMarkTaskOpen = (data: IsoChecklistControllerMarkTaskOpenData): CancelablePromise<IsoChecklistControllerMarkTaskOpenResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/checklists/{id}/tasks/{taskId}/open',
    path: {
        id: data.id,
        taskId: data.taskId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.taskId
 * @returns IsoChecklistFetchDto Set task in progress
 * @throws ApiError
 */
export const isoChecklistControllerMarkTaskInProgress = (data: IsoChecklistControllerMarkTaskInProgressData): CancelablePromise<IsoChecklistControllerMarkTaskInProgressResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/checklists/{id}/tasks/{taskId}/in-progress',
    path: {
        id: data.id,
        taskId: data.taskId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.taskId
 * @param data.requestBody Document to link
 * @returns IsoChecklistFetchDto Document linked
 * @throws ApiError
 */
export const isoChecklistControllerLinkDocument = (data: IsoChecklistControllerLinkDocumentData): CancelablePromise<IsoChecklistControllerLinkDocumentResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/checklists/{id}/tasks/{taskId}/documents',
    path: {
        id: data.id,
        taskId: data.taskId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.taskId
 * @param data.documentId
 * @returns IsoChecklistFetchDto Document linked
 * @throws ApiError
 */
export const isoChecklistControllerRemoveLinkDocument = (data: IsoChecklistControllerRemoveLinkDocumentData): CancelablePromise<IsoChecklistControllerRemoveLinkDocumentResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/checklists/{id}/tasks/{taskId}/documents/{documentId}',
    path: {
        id: data.id,
        taskId: data.taskId,
        documentId: data.documentId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create Valeri
 * @returns FetchOneValeriDto Valeri created
 * @throws ApiError
 */
export const valeriControllerCreateValeri = (data: ValeriControllerCreateValeriData): CancelablePromise<ValeriControllerCreateValeriResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/valeri',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update Valeri
 * @returns FetchOneValeriDto Valeri updated
 * @throws ApiError
 */
export const valeriControllerUpdateValeri = (data: ValeriControllerUpdateValeriData): CancelablePromise<ValeriControllerUpdateValeriResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/valeri/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Valeri deleted
 * @throws ApiError
 */
export const valeriControllerDeleteValeri = (data: ValeriControllerDeleteValeriData): CancelablePromise<ValeriControllerDeleteValeriResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/valeri/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns FetchOneValeriDto Requested Valeri
 * @throws ApiError
 */
export const valeriControllerFindOneById = (data: ValeriControllerFindOneByIdData): CancelablePromise<ValeriControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/valeri/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ValeriPositionsListDto Valeri Positions
 * @throws ApiError
 */
export const valeriControllerGetValeriPositions = (data: ValeriControllerGetValeriPositionsData): CancelablePromise<ValeriControllerGetValeriPositionsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/valeri/{id}/positions',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Create Valeri Position
 * @returns FetchOneValeriDto Valeri created
 * @throws ApiError
 */
export const valeriControllerCreateValeriPosition = (data: ValeriControllerCreateValeriPositionData): CancelablePromise<ValeriControllerCreateValeriPositionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/valeri/{id}/positions',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ValeriCalculationResultSummaryDto Valeri Result calculated
 * @throws ApiError
 */
export const valeriControllerCalculateValeri = (data: ValeriControllerCalculateValeriData): CancelablePromise<ValeriControllerCalculateValeriResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/iso/valeri/{id}/calculate-valeri',
    path: {
        id: data.id
    }
}); };

/**
 * Export a stub empty .xlsx file
 * @param data The data for the request.
 * @param data.id
 * @returns binary Returns valeri calculation result .xlsx file
 * @throws ApiError
 */
export const valeriControllerExportValeriCalculationResult = (data: ValeriControllerExportValeriCalculationResultData): CancelablePromise<ValeriControllerExportValeriCalculationResultResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/valeri/{id}/calculation-result/export',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.positionId
 * @param data.requestBody Update Valeri Position
 * @returns FetchOneValeriDto Valeri updated
 * @throws ApiError
 */
export const valeriControllerUpdateValeriPosition = (data: ValeriControllerUpdateValeriPositionData): CancelablePromise<ValeriControllerUpdateValeriPositionResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/valeri/{id}/positions/{positionId}',
    path: {
        id: data.id,
        positionId: data.positionId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.positionId
 * @returns void Valeri Position deleted
 * @throws ApiError
 */
export const valeriControllerDeleteValeriPosition = (data: ValeriControllerDeleteValeriPositionData): CancelablePromise<ValeriControllerDeleteValeriPositionResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/valeri/{id}/positions/{positionId}',
    path: {
        id: data.id,
        positionId: data.positionId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.positionId
 * @returns ValeriPositionDto
 * @returns void Invoice file uploaded
 * @throws ApiError
 */
export const valeriControllerUploadValeriPositionDocument = (data: ValeriControllerUploadValeriPositionDocumentData): CancelablePromise<ValeriControllerUploadValeriPositionDocumentResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/valeri/{id}/positions/{positionId}/document',
    path: {
        id: data.id,
        positionId: data.positionId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.positionId
 * @returns void Valeri Position deleted
 * @throws ApiError
 */
export const valeriControllerDeleteValeriPositionDocument = (data: ValeriControllerDeleteValeriPositionDocumentData): CancelablePromise<ValeriControllerDeleteValeriPositionDocumentResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/iso/valeri/{id}/positions/{positionId}/document',
    path: {
        id: data.id,
        positionId: data.positionId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.locationId
 * @param data.measureId
 * @returns GetValeriCalculationResultsDto Get VALERI list for specific user
 * @throws ApiError
 */
export const valeriControllerGetValeriCalculationResults = (data: ValeriControllerGetValeriCalculationResultsData = {}): CancelablePromise<ValeriControllerGetValeriCalculationResultsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/valeri/calculation-results',
    query: {
        companyId: data.companyId,
        locationId: data.locationId,
        measureId: data.measureId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.measureId
 * @returns FetchOneValeriDto Returns a Valeri for the given measureId, or null if not found
 * @throws ApiError
 */
export const valeriControllerGetValeriByMeasureId = (data: ValeriControllerGetValeriByMeasureIdData): CancelablePromise<ValeriControllerGetValeriByMeasureIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/valeri/by-measure/{measureId}',
    path: {
        measureId: data.measureId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns FetchOneValeriDto Valeri with the latest attached measurement ID
 * @throws ApiError
 */
export const valeriControllerLinkValeriToMeasure = (data: ValeriControllerLinkValeriToMeasureData): CancelablePromise<ValeriControllerLinkValeriToMeasureResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/iso/valeri/{id}/measures',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns ResponseCompanyValeriDefaultsDto Company Valeri defaults (can be null if not set)
 * @throws ApiError
 */
export const valeriControllerGetCompanyDefaults = (data: ValeriControllerGetCompanyDefaultsData): CancelablePromise<ValeriControllerGetCompanyDefaultsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/valeri/company/{companyId}/defaults',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.requestBody Create or update company Valeri defaults
 * @returns ResponseCompanyValeriDefaultsDto Upserted company Valeri defaults
 * @throws ApiError
 */
export const valeriControllerUpsertCompanyDefaults = (data: ValeriControllerUpsertCompanyDefaultsData): CancelablePromise<ValeriControllerUpsertCompanyDefaultsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/valeri/company/{companyId}/defaults',
    path: {
        companyId: data.companyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns ResponseCompanyEnergyBaselineConfigDto Company energy baseline configuration (can be null if not set)
 * @throws ApiError
 */
export const companyEnergyBaselineConfigControllerGet = (data: CompanyEnergyBaselineConfigControllerGetData): CancelablePromise<CompanyEnergyBaselineConfigControllerGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/iso/company/{companyId}/energy-baseline-config',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.requestBody Create or update company energy baseline configuration
 * @returns ResponseCompanyEnergyBaselineConfigDto Upserted company energy baseline configuration
 * @throws ApiError
 */
export const companyEnergyBaselineConfigControllerUpsert = (data: CompanyEnergyBaselineConfigControllerUpsertData): CancelablePromise<CompanyEnergyBaselineConfigControllerUpsertResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/iso/company/{companyId}/energy-baseline-config',
    path: {
        companyId: data.companyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @returns unknown
 * @throws ApiError
 */
export const buildingControllerGetBuildingsByLocation = (data: BuildingControllerGetBuildingsByLocationData): CancelablePromise<BuildingControllerGetBuildingsByLocationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/locations/{locationId}/buildings',
    path: {
        companyId: data.companyId,
        locationId: data.locationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const buildingControllerUpsertBuilding = (data: BuildingControllerUpsertBuildingData): CancelablePromise<BuildingControllerUpsertBuildingResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/companies/{companyId}/locations/{locationId}/buildings',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns unknown Successfully hydrated building data to Kafka
 * @throws ApiError
 */
export const buildingControllerHydrateBuildingsToKafka = (): CancelablePromise<BuildingControllerHydrateBuildingsToKafkaResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/companies/buildings/hydrate-queue'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @param data.buildingId Building ID
 * @returns unknown
 * @throws ApiError
 */
export const buildingControllerDeleteBuilding = (data: BuildingControllerDeleteBuildingData): CancelablePromise<BuildingControllerDeleteBuildingResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/companies/{companyId}/locations/{locationId}/buildings/{buildingId}',
    path: {
        companyId: data.companyId,
        locationId: data.locationId,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from
 * @param data.to
 * @param data.locationId
 * @param data.deviceId
 * @param data.source
 * @param data.aggregationTimeframe
 * @returns ConsumptionResponseDto Get Energy Consumption in KWH for a given time period.
 * @throws ApiError
 */
export const consumptionControllerGetConsumption = (data: ConsumptionControllerGetConsumptionData): CancelablePromise<ConsumptionControllerGetConsumptionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consumption',
    query: {
        from: data.from,
        to: data.to,
        locationId: data.locationId,
        deviceId: data.deviceId,
        source: data.source,
        aggregationTimeframe: data.aggregationTimeframe
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from Start date for data
 * @param data.to End date for data
 * @param data.locationId
 * @param data.locationIds Comma-seperate list of location ids
 * @param data.buildingIds Comma-separated list of building ids. When provided, only consumption from meters in these buildings is returned.
 * @param data.meterType Filter meters by their measurement type. "rlm" (default) returns registered/measured meters (everything except SLP); "slp" returns only standard-load-profile meters.
 * @param data.energyType Energy type to filter by
 * @param data.includeLocationId When true, each series item is annotated with the locationId of the meter it belongs to
 * @returns unknown[] Get energy consumption for a locations by granularity
 * @throws ApiError
 */
export const consumptionControllerGetConsumptionLocationWithGranularity = (data: ConsumptionControllerGetConsumptionLocationWithGranularityData): CancelablePromise<ConsumptionControllerGetConsumptionLocationWithGranularityResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consumption/locations/{locationId}',
    path: {
        locationId: data.locationId
    },
    query: {
        locationIds: data.locationIds,
        buildingIds: data.buildingIds,
        meterType: data.meterType,
        from: data.from,
        to: data.to,
        energyType: data.energyType,
        includeLocationId: data.includeLocationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from Start date for data
 * @param data.to End date for data
 * @param data.companyId
 * @param data.locationIds Comma-seperate list of location ids
 * @param data.buildingIds Comma-separated list of building ids. When provided, only consumption from meters in these buildings is returned.
 * @param data.meterType Filter meters by their measurement type. "rlm" (default) returns registered/measured meters (everything except SLP); "slp" returns only standard-load-profile meters.
 * @param data.energyType Energy type to filter by
 * @param data.includeLocationId When true, each series item is annotated with the locationId of the meter it belongs to
 * @returns unknown[] Get energy consumption for multiple locations by granularity
 * @throws ApiError
 */
export const consumptionControllerGetConsumptionWithGranularity = (data: ConsumptionControllerGetConsumptionWithGranularityData): CancelablePromise<ConsumptionControllerGetConsumptionWithGranularityResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consumption/company/{companyId}',
    path: {
        companyId: data.companyId
    },
    query: {
        locationIds: data.locationIds,
        buildingIds: data.buildingIds,
        meterType: data.meterType,
        from: data.from,
        to: data.to,
        energyType: data.energyType,
        includeLocationId: data.includeLocationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from Start date for data
 * @param data.to End date for data
 * @param data.companyId
 * @param data.locationIds Comma-seperate list of location ids
 * @param data.buildingIds Comma-separated list of building ids. When provided, only consumption from meters in these buildings is returned.
 * @param data.meterType Filter meters by their measurement type. "rlm" (default) returns registered/measured meters (everything except SLP); "slp" returns only standard-load-profile meters.
 * @param data.energyType Energy type to filter by
 * @param data.includeLocationId When true, each series item is annotated with the locationId of the meter it belongs to
 * @returns unknown[] Get aggregated energy consumption for multiple locations by granularity
 * @throws ApiError
 */
export const consumptionControllerGetLoadProfile = (data: ConsumptionControllerGetLoadProfileData): CancelablePromise<ConsumptionControllerGetLoadProfileResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consumption/company/{companyId}/aggregated',
    path: {
        companyId: data.companyId
    },
    query: {
        locationIds: data.locationIds,
        buildingIds: data.buildingIds,
        meterType: data.meterType,
        from: data.from,
        to: data.to,
        energyType: data.energyType,
        includeLocationId: data.includeLocationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceIds
 * @param data.from
 * @param data.to
 * @returns LoadProfileResponseDto Get load profile
 * @throws ApiError
 */
export const consumptionControllerGetAggregatedConsumptionWithGranularity = (data: ConsumptionControllerGetAggregatedConsumptionWithGranularityData): CancelablePromise<ConsumptionControllerGetAggregatedConsumptionWithGranularityResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/details/load-profile',
    query: {
        deviceIds: data.deviceIds,
        from: data.from,
        to: data.to
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from Start date
 * @param data.to End date
 * @param data.buildingId Building ID
 * @param data.locationId Location ID
 * @param data.regionId Region ID
 * @param data.companyId Company ID
 * @param data.coerceNullToZero Fill missing data gaps with zeros instead of null
 * @returns LoadProfileResponseDto Get load profile
 * @throws ApiError
 */
export const consumptionControllerGetAggregatedConsumption = (data: ConsumptionControllerGetAggregatedConsumptionData): CancelablePromise<ConsumptionControllerGetAggregatedConsumptionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/energy-data/aggregated',
    query: {
        buildingId: data.buildingId,
        locationId: data.locationId,
        regionId: data.regionId,
        companyId: data.companyId,
        from: data.from,
        to: data.to,
        coerceNullToZero: data.coerceNullToZero
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ConsumptionSeriesDto Get consumption series for device IDs or series UUIDs
 * @throws ApiError
 */
export const consumptionControllerGetConsumptionSeries = (data: ConsumptionControllerGetConsumptionSeriesData): CancelablePromise<ConsumptionControllerGetConsumptionSeriesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/consumption/series',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Resolve location-total metadata and, when requested, its calculated data.
 * @throws ApiError
 */
export const locationTotalSeriesControllerGetLocationTotalSeries = (data: LocationTotalSeriesControllerGetLocationTotalSeriesData): CancelablePromise<LocationTotalSeriesControllerGetLocationTotalSeriesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/consumption/series/location-total',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const companyControllerGetCompanies = (): CancelablePromise<CompanyControllerGetCompaniesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const companyControllerUpsertCompany = (data: CompanyControllerUpsertCompanyData): CancelablePromise<CompanyControllerUpsertCompanyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/companies',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const companyControllerPushAllToKafka = (): CancelablePromise<CompanyControllerPushAllToKafkaResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/companies'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @returns unknown
 * @throws ApiError
 */
export const companyControllerDeleteCompany = (data: CompanyControllerDeleteCompanyData): CancelablePromise<CompanyControllerDeleteCompanyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/companies/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyDto List of all document templates.
 * @throws ApiError
 */
export const companyControllerGetCompany = (data: CompanyControllerGetCompanyData): CancelablePromise<CompanyControllerGetCompanyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * Get company premium features
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyPremiumFeaturesResponseDto
 * @throws ApiError
 */
export const companyControllerGetPremiumFeatures = (data: CompanyControllerGetPremiumFeaturesData): CancelablePromise<CompanyControllerGetPremiumFeaturesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/premium-features',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * Update company premium features
 * @param data The data for the request.
 * @param data.companyId
 * @param data.requestBody
 * @returns CompanyPremiumFeaturesResponseDto
 * @throws ApiError
 */
export const companyControllerUpdatePremiumFeatures = (data: CompanyControllerUpdatePremiumFeaturesData): CancelablePromise<CompanyControllerUpdatePremiumFeaturesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/companies/{companyId}/premium-features',
    path: {
        companyId: data.companyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns unknown
 * @throws ApiError
 */
export const companyControllerGetCompanyLogo = (data: CompanyControllerGetCompanyLogoData): CancelablePromise<CompanyControllerGetCompanyLogoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/logo',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns unknown
 * @throws ApiError
 */
export const companyControllerGetCompanyWhiteLabelLogo = (data: CompanyControllerGetCompanyWhiteLabelLogoData): CancelablePromise<CompanyControllerGetCompanyWhiteLabelLogoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/white-label-logo',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @returns unknown
 * @throws ApiError
 */
export const companyControllerIsCostEnabled = (data: CompanyControllerIsCostEnabledData): CancelablePromise<CompanyControllerIsCostEnabledResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/cost/status',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @returns unknown
 * @throws ApiError
 */
export const locationControllerGetLocationsByCompany = (data: LocationControllerGetLocationsByCompanyData): CancelablePromise<LocationControllerGetLocationsByCompanyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/locations',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const locationControllerUpsertLocation = (data: LocationControllerUpsertLocationData): CancelablePromise<LocationControllerUpsertLocationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/companies/{companyId}/locations',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @returns LocationTreeDto
 * @throws ApiError
 */
export const locationControllerGetLocationsWithBuildingsAndDevicesByCompany = (data: LocationControllerGetLocationsWithBuildingsAndDevicesByCompanyData): CancelablePromise<LocationControllerGetLocationsWithBuildingsAndDevicesByCompanyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/locations-with-buildings-and-devices',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @returns unknown
 * @throws ApiError
 */
export const locationControllerDeleteLocation = (data: LocationControllerDeleteLocationData): CancelablePromise<LocationControllerDeleteLocationResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/companies/{companyId}/locations/{locationId}',
    path: {
        companyId: data.companyId,
        locationId: data.locationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @returns unknown
 * @throws ApiError
 */
export const locationControllerGetRegionsByLocation = (data: LocationControllerGetRegionsByLocationData): CancelablePromise<LocationControllerGetRegionsByLocationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/locations/{locationId}/regions',
    path: {
        companyId: data.companyId,
        locationId: data.locationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @param data.regionId Region ID
 * @returns unknown
 * @throws ApiError
 */
export const locationControllerToggleLocationAssignmentToRegion = (data: LocationControllerToggleLocationAssignmentToRegionData): CancelablePromise<LocationControllerToggleLocationAssignmentToRegionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/companies/{companyId}/locations/{locationId}/regions/{regionId}',
    path: {
        companyId: data.companyId,
        locationId: data.locationId,
        regionId: data.regionId
    }
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const locationControllerPushAllToKafka = (): CancelablePromise<LocationControllerPushAllToKafkaResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/companies/locations'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns TemperatureResponseDto Get all temperature locations
 * @throws ApiError
 */
export const temperatureControllerFindAll = (data: TemperatureControllerFindAllData): CancelablePromise<TemperatureControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/weather/temperature/company/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.cityId
 * @param data.from Start date for weather data in YYYY-MM-DD format
 * @param data.to End date for weather data in YYYY-MM-DD format
 * @param data.granularity Granularity to aggregate weather data by
 * @returns WeatherDataResponseDto Get weather data for temperature location by city ID with date range
 * @throws ApiError
 */
export const temperatureControllerGetWeatherDataByCityId = (data: TemperatureControllerGetWeatherDataByCityIdData): CancelablePromise<TemperatureControllerGetWeatherDataByCityIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/weather/temperature/city/{cityId}',
    path: {
        cityId: data.cityId
    },
    query: {
        from: data.from,
        to: data.to,
        granularity: data.granularity
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.from Start date for weather data in YYYY-MM-DD format
 * @param data.to End date for weather data in YYYY-MM-DD format
 * @param data.granularity Granularity to aggregate weather data by
 * @returns WeatherDataResponseDto Get weather data for temperature location by ID with date range
 * @throws ApiError
 */
export const temperatureControllerGetWeatherData = (data: TemperatureControllerGetWeatherDataData): CancelablePromise<TemperatureControllerGetWeatherDataResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/weather/temperature/{id}/data',
    path: {
        id: data.id
    },
    query: {
        from: data.from,
        to: data.to,
        granularity: data.granularity
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns TemperatureResponseDto Get temperature location by ID
 * @throws ApiError
 */
export const temperatureControllerFindOne = (data: TemperatureControllerFindOneData): CancelablePromise<TemperatureControllerFindOneResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/weather/temperature/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns TemperatureResponseDto Update temperature location
 * @throws ApiError
 */
export const temperatureControllerUpdate = (data: TemperatureControllerUpdateData): CancelablePromise<TemperatureControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/weather/temperature/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Temperature location deleted
 * @throws ApiError
 */
export const temperatureControllerDelete = (data: TemperatureControllerDeleteData): CancelablePromise<TemperatureControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/weather/temperature/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns TemperatureResponseDto Create a new temperature location
 * @throws ApiError
 */
export const temperatureControllerCreate = (data: TemperatureControllerCreateData): CancelablePromise<TemperatureControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/weather/temperature',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns unknown Trigger temperature sync (geocode missing cities + create missing entries)
 * @throws ApiError
 */
export const temperatureControllerTriggerSync = (): CancelablePromise<TemperatureControllerTriggerSyncResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/weather/temperature/sync'
}); };

/**
 * @param data The data for the request.
 * @param data.page Page number (1-based). Omit or set to 0 to fetch all cities.
 * @returns CityDto
 * @throws ApiError
 */
export const cityControllerGetAllCities = (data: CityControllerGetAllCitiesData = {}): CancelablePromise<CityControllerGetAllCitiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/cities',
    query: {
        page: data.page
    }
}); };

/**
 * Shadow-resolve a city via strict geocoding (no DB write).
 * Resolves coordinates for the given search name, disambiguated by optional state/district/municipality filters. Returns exactly what committing would persist, without writing.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CityGeocodePreviewDto Unique match resolved.
 * @throws ApiError
 */
export const cityControllerPreviewGeocodedCity = (data: CityControllerPreviewGeocodedCityData): CancelablePromise<CityControllerPreviewGeocodedCityResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/cities/geocode/preview',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'No city matched the search name and filters.',
        409: 'Ambiguous: more than one candidate matched. Refine the filters.'
    }
}); };

/**
 * Resolve a city via strict geocoding and persist it.
 * Re-runs the identical resolution as the preview endpoint, then upserts the city (by display name) and ensures its weather-station entry. Idempotent by display name.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CityDto City resolved and persisted.
 * @throws ApiError
 */
export const cityControllerCommitGeocodedCity = (data: CityControllerCommitGeocodedCityData): CancelablePromise<CityControllerCommitGeocodedCityResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/cities/geocode/commit',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'No city matched the search name and filters.',
        409: 'Ambiguous match, or resolved coordinates already belong to another city.'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.name
 * @returns unknown
 * @throws ApiError
 */
export const cityControllerFindAndUpsertCity = (data: CityControllerFindAndUpsertCityData): CancelablePromise<CityControllerFindAndUpsertCityResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/cities/{name}',
    path: {
        name: data.name
    }
}); };

/**
 * List custom time-series metadata with pagination, search, and sorting
 * @param data The data for the request.
 * @param data.locationPgId Location ID to filter custom time series
 * @param data.companyId Company ID to filter custom time series
 * @param data.regionId Region ID to filter a company-scoped custom time-series list
 * @param data.search Search by name, location, granularity, or unit. Name matches are ranked before location matches.
 * @param data.sortBy
 * @param data.sortOrder
 * @returns CustomTimeseriesListResponseDto Paginated custom time-series metadata
 * @throws ApiError
 */
export const customTimeseriesControllerFindPage = (data: CustomTimeseriesControllerFindPageData = {}): CancelablePromise<CustomTimeseriesControllerFindPageResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/analytics/data-management/meta',
    query: {
        locationPgId: data.locationPgId,
        companyId: data.companyId,
        regionId: data.regionId,
        search: data.search,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder
    }
}); };

/**
 * @param data The data for the request.
 * @param data.years Array of years for comparison
 * @param data.years Array of years for comparison
 * @param data.buildingId The ID of the building (optional)
 * @param data.locationId The ID of the location (optional)
 * @param data.regionId The ID of the region (optional)
 * @param data.companyId The ID of the company (optional)
 * @param data.buildingId The ID of the building (optional)
 * @param data.locationId The ID of the location (optional)
 * @param data.regionId The ID of the region (optional)
 * @param data.companyId The ID of the company (optional)
 * @returns AggregatedMonthlyPeakloadsResponseDto Aggregated monthly of peakloads by year for a set of main meters given the passed hiearchy params (companyId, regionId, locationId, buildingId)
 * @throws ApiError
 */
export const loadControllerGetAggregatedMonthlyPeakloads = (data: LoadControllerGetAggregatedMonthlyPeakloadsData): CancelablePromise<LoadControllerGetAggregatedMonthlyPeakloadsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load/peakload/monthly/aggregated',
    query: {
        years: data.years,
        buildingId: data.buildingId,
        locationId: data.locationId,
        regionId: data.regionId,
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.years Array of years for comparison
 * @param data.years Array of years for comparison
 * @param data.buildingId The ID of the building (optional)
 * @param data.locationId The ID of the location (optional)
 * @param data.regionId The ID of the region (optional)
 * @param data.companyId The ID of the company (optional)
 * @param data.buildingId The ID of the building (optional)
 * @param data.locationId The ID of the location (optional)
 * @param data.regionId The ID of the region (optional)
 * @param data.companyId The ID of the company (optional)
 * @returns AggregatedMonthlyBaseloadsResponseDto Aggregated monthly of baseloads by year for a set of main meters given the passed hiearchy params (companyId, regionId, locationId, buildingId)
 * @throws ApiError
 */
export const loadControllerGetAggregatedMonthlyBaseloads = (data: LoadControllerGetAggregatedMonthlyBaseloadsData): CancelablePromise<LoadControllerGetAggregatedMonthlyBaseloadsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load/baseload/monthly/aggregated',
    query: {
        years: data.years,
        buildingId: data.buildingId,
        locationId: data.locationId,
        regionId: data.regionId,
        companyId: data.companyId
    }
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const loadSimulationControllerPopulatePfc = (): CancelablePromise<LoadSimulationControllerPopulatePfcResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/load-simulation/admin/store-pfc-lookup'
}); };

/**
 * @param data The data for the request.
 * @param data.simulationType
 * @returns unknown
 * @throws ApiError
 */
export const loadSimulationControllerRecalculateSimulationOfType = (data: LoadSimulationControllerRecalculateSimulationOfTypeData): CancelablePromise<LoadSimulationControllerRecalculateSimulationOfTypeResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/load-simulation/admin/recalculate-simulation-type',
    query: {
        'simulation-type': data.simulationType
    }
}); };

/**
 * Get available main meters for the given company
 * Returns a list of main meters for the given company
 * @param data The data for the request.
 * @param data.companyId The id of the company the load simulations should be retrieved for
 * @param data.canBeIncludedInLoadPlanning Filter to only return simulations that are allowed for load planning inclusion
 * @returns AvailableMainMeterDto
 * @throws ApiError
 */
export const loadSimulationControllerGetAvailableMainMeters = (data: LoadSimulationControllerGetAvailableMainMetersData): CancelablePromise<LoadSimulationControllerGetAvailableMainMetersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-simulation/available-main-meters',
    query: {
        companyId: data.companyId,
        canBeIncludedInLoadPlanning: data.canBeIncludedInLoadPlanning
    }
}); };

/**
 * Get available generation load profiles
 * Returns a list of all generation‑load profile records
 * @returns GenerationLoadProfileDto
 * @throws ApiError
 */
export const loadSimulationControllerGetAvailableGenerationLoadProfiles = (): CancelablePromise<LoadSimulationControllerGetAvailableGenerationLoadProfilesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-simulation/available-generation-load-profiles'
}); };

/**
 * Retrieve all load‑simulation records for a certain company
 * Returns an array of simulations. Each element is one of the three concrete payloads:
 * - **EfficiencyImprovementSimulationDto**
 * - **OnsiteGenerationSimulationDto**
 * - **FlexibilitySimulationDto**
 *
 * The discriminator field `simulationType` tells the consumer which schema applies.
 * @param data The data for the request.
 * @param data.companyId The id of the company the load simulations should be retrieved for
 * @param data.canBeIncludedInLoadPlanning Filter to only return simulations that are allowed for load planning inclusion
 * @returns unknown Array of simulations (mixed types).
 * @throws ApiError
 */
export const loadSimulationControllerFindAllForCompanyId = (data: LoadSimulationControllerFindAllForCompanyIdData): CancelablePromise<LoadSimulationControllerFindAllForCompanyIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-simulation',
    query: {
        companyId: data.companyId,
        canBeIncludedInLoadPlanning: data.canBeIncludedInLoadPlanning
    }
}); };

/**
 * Create a simulation
 * @param data The data for the request.
 * @param data.requestBody Payload containing one simulation definition
 * @returns unknown Simulation successfully created
 * @throws ApiError
 */
export const loadSimulationControllerCreateSimulation = (data: LoadSimulationControllerCreateSimulationData): CancelablePromise<LoadSimulationControllerCreateSimulationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/load-simulation',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed – see error details'
    }
}); };

/**
 * Update a single load‑simulation record by its ID
 * Returns the simulation matching the supplied `id`. The response shape follows the same discriminated union as the “find all” endpoint – one of:
 * - **EfficiencyImprovementSimulationDto**
 * - **OnsiteGenerationSimulationDto**
 * - **FlexibilitySimulationDto**
 *
 * If no record exists for the given ID, a 404 error is returned.
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown Single simulation (mixed type).
 * @throws ApiError
 */
export const loadSimulationControllerUpdateSimulationById = (data: LoadSimulationControllerUpdateSimulationByIdData): CancelablePromise<LoadSimulationControllerUpdateSimulationByIdResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/load-simulation/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'No simulation found for the provided ID.'
    }
}); };

/**
 * Retrieve a single load‑simulation record by its ID
 * Returns the simulation matching the supplied `id`. The response shape follows the same discriminated union as the “find all” endpoint – one of:
 * - **EfficiencyImprovementSimulationDto**
 * - **OnsiteGenerationSimulationDto**
 * - **FlexibilitySimulationDto**
 *
 * If no record exists for the given ID, a 404 error is returned.
 * @param data The data for the request.
 * @param data.id
 * @param data.from The start of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
 * @param data.to The end of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
 * @returns unknown Single simulation (mixed type).
 * @throws ApiError
 */
export const loadSimulationControllerFindSimulationById = (data: LoadSimulationControllerFindSimulationByIdData): CancelablePromise<LoadSimulationControllerFindSimulationByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-simulation/{id}',
    path: {
        id: data.id
    },
    query: {
        from: data.from,
        to: data.to
    },
    errors: {
        404: 'No simulation found for the provided ID.'
    }
}); };

/**
 * Delete a simulation by its id
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const loadSimulationControllerDeleteSimulationById = (data: LoadSimulationControllerDeleteSimulationByIdData): CancelablePromise<LoadSimulationControllerDeleteSimulationByIdResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/load-simulation/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'No simulation found for the provided ID.'
    }
}); };

/**
 * Update the simulation calculation of a single load‑simulation record by its ID
 * Returns the simulation matching the supplied `id`. The response shape follows the same discriminated union as the “find all” endpoint – one of:
 * - **EfficiencyImprovementSimulationDto**
 * - **OnsiteGenerationSimulationDto**
 * - **FlexibilitySimulationDto**
 *
 * If no record exists for the given ID, a 404 error is returned.
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Single simulation (mixed type).
 * @throws ApiError
 */
export const loadSimulationControllerRecalculateSimulationById = (data: LoadSimulationControllerRecalculateSimulationByIdData): CancelablePromise<LoadSimulationControllerRecalculateSimulationByIdResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/load-simulation/{id}/recalculate',
    path: {
        id: data.id
    },
    errors: {
        404: 'No simulation found for the provided ID.'
    }
}); };

/**
 * Export load simulation graph data as CSV
 * @param data The data for the request.
 * @param data.id
 * @param data.from The start of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
 * @param data.to The end of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
 * @returns unknown CSV export with columns timestamp, valueKw, simulatedkw, deltaKw
 * @throws ApiError
 */
export const loadSimulationControllerGetSimulationCsv = (data: LoadSimulationControllerGetSimulationCsvData): CancelablePromise<LoadSimulationControllerGetSimulationCsvResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-simulation/{id}/csv',
    path: {
        id: data.id
    },
    query: {
        from: data.from,
        to: data.to
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns GenerationLoadProfileDto
 * @throws ApiError
 */
export const generationLoadProfileControllerGetLoadProfile = (data: GenerationLoadProfileControllerGetLoadProfileData): CancelablePromise<GenerationLoadProfileControllerGetLoadProfileResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/generation-load-profile/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns GenerationLoadProfileDto
 * @throws ApiError
 */
export const generationLoadProfileControllerUpdateGenerationLoadProfile = (data: GenerationLoadProfileControllerUpdateGenerationLoadProfileData): CancelablePromise<GenerationLoadProfileControllerUpdateGenerationLoadProfileResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/generation-load-profile/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const generationLoadProfileControllerDeleteGenerationLoadProfile = (data: GenerationLoadProfileControllerDeleteGenerationLoadProfileData): CancelablePromise<GenerationLoadProfileControllerDeleteGenerationLoadProfileResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/generation-load-profile/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GenerationLoadProfileDto
 * @throws ApiError
 */
export const generationLoadProfileControllerCreateGenerationLoadProfile = (data: GenerationLoadProfileControllerCreateGenerationLoadProfileData): CancelablePromise<GenerationLoadProfileControllerCreateGenerationLoadProfileResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/generation-load-profile',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const generationLoadProfileControllerUpdateLoadData = (data: GenerationLoadProfileControllerUpdateLoadDataData): CancelablePromise<GenerationLoadProfileControllerUpdateLoadDataResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/generation-load-profile/{id}/load-data',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @returns DeviceReferencesResponseDto Get references for a deviceId from visualizations and ENPI.
 * @throws ApiError
 */
export const slpConsumptionControllerGetReferencesForDeviceId = (data: SlpConsumptionControllerGetReferencesForDeviceIdData): CancelablePromise<SlpConsumptionControllerGetReferencesForDeviceIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consumption/slp/{deviceId}/references',
    path: {
        deviceId: data.deviceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.to
 * @param data.from
 * @returns SlpConsumptionResponseDto This API endpoint returns the consumption of a slp meter. The response includes:
 *
 * consumption: A list of all consumption across months in the selected timeframe.
 * @throws ApiError
 */
export const slpConsumptionControllerGetSlpConsumption = (data: SlpConsumptionControllerGetSlpConsumptionData): CancelablePromise<SlpConsumptionControllerGetSlpConsumptionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/consumption/slp/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    query: {
        to: data.to,
        from: data.from
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.requestBody
 * @returns unknown Update slp consumption for given device.
 * @throws ApiError
 */
export const slpConsumptionControllerUpdateSlpConsumption = (data: SlpConsumptionControllerUpdateSlpConsumptionData): CancelablePromise<SlpConsumptionControllerUpdateSlpConsumptionResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/consumption/slp/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @deprecated
 * Delete the consumption for given device.
 * DEPRECATED It doesn't make sense to have a separate deletion endpoint for just the consumption, that gets called after a meter has already been deleted.
 * @param data The data for the request.
 * @param data.deviceId
 * @returns unknown Delete slp consumption for given device.
 * @throws ApiError
 */
export const slpConsumptionControllerDeleteSlpConsumption = (data: SlpConsumptionControllerDeleteSlpConsumptionData): CancelablePromise<SlpConsumptionControllerDeleteSlpConsumptionResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/consumption/slp/{deviceId}',
    path: {
        deviceId: data.deviceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @returns SlpMeterReadingResponseDto Get all SLP meter readings for a device
 * @throws ApiError
 */
export const slpMeterReadingControllerGetReadings = (data: SlpMeterReadingControllerGetReadingsData): CancelablePromise<SlpMeterReadingControllerGetReadingsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/slp/{deviceId}/readings',
    path: {
        deviceId: data.deviceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.requestBody Array of SLP meter readings to save
 * @returns SlpMeterReadingResponseDto Receives the list of readings of a SLP and saves it
 * @throws ApiError
 */
export const slpMeterReadingControllerReplaceReadings = (data: SlpMeterReadingControllerReplaceReadingsData): CancelablePromise<SlpMeterReadingControllerReplaceReadingsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/meters/slp/{deviceId}/readings',
    path: {
        deviceId: data.deviceId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'When new reading does not pass validation'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.requestBody
 * @returns SlpMeterReadingResponseDto Create or update SLP meter readings for a device id. Upsert is based on the deviceId and timestamp match.
 * @throws ApiError
 */
export const slpMeterReadingControllerCreateReading = (data: SlpMeterReadingControllerCreateReadingData): CancelablePromise<SlpMeterReadingControllerCreateReadingResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/meters/slp/{deviceId}/reading',
    path: {
        deviceId: data.deviceId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'When new reading does not pass validation'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.formData
 * @returns UploadSlpImageResponseDto Image uploaded and meter reading extracted successfully
 * @throws ApiError
 */
export const slpMeterReadingControllerUploadFile = (data: SlpMeterReadingControllerUploadFileData): CancelablePromise<SlpMeterReadingControllerUploadFileResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/meters/slp/{deviceId}/reading/upload-image',
    path: {
        deviceId: data.deviceId
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.id
 * @returns unknown Download the image of a meter reading
 * @throws ApiError
 */
export const slpMeterReadingControllerDownloadReadingImage = (data: SlpMeterReadingControllerDownloadReadingImageData): CancelablePromise<SlpMeterReadingControllerDownloadReadingImageResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meters/slp/{deviceId}/reading/{id}/image',
    path: {
        deviceId: data.deviceId,
        id: data.id
    },
    errors: {
        404: 'Device, reading, or image not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @param data.requestBody Full gas cost information object keyed by year (replaces the stored value entirely)
 * @returns GasCostInformationResponseDto Updated gas cost information for a location
 * @throws ApiError
 */
export const gasCostInformationControllerUpdateGasCostInformation = (data: GasCostInformationControllerUpdateGasCostInformationData): CancelablePromise<GasCostInformationControllerUpdateGasCostInformationResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/cost/gas-costs-information',
    query: {
        locationId: data.locationId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.year Year
 * @param data.companyId Company ID to filter locations data.
 * @param data.regionId Region ID to filter locations data.
 * @param data.locationId Location ID to filter locations data.
 * @param data.buildingId Building ID to filter locations data.
 * @returns BudgetTrackingResponseDto Returns budget and costs
 * @throws ApiError
 */
export const budgetTrackingControllerGetCosts = (data: BudgetTrackingControllerGetCostsData): CancelablePromise<BudgetTrackingControllerGetCostsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v3/budget/tracking',
    query: {
        companyId: data.companyId,
        regionId: data.regionId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        year: data.year
    }
}); };

/**
 * @param data The data for the request.
 * @param data.startDate
 * @param data.endDate
 * @param data.companyId Company ID to filter locations data.
 * @param data.regionId Region ID to filter locations data.
 * @param data.locationId Location ID to filter locations data.
 * @param data.buildingId Building ID to filter locations data.
 * @param data.energyTypes Energy types to filter the consumption data.
 * @returns ConsumptionTrendsResponseDto This API endpoint returns the electricity consumption trends data by energy types. The response includes:
 *
 * totalConsumptionYtdKWh: Total consumption year-to-date in kWh.
 * totalConsumptionPastMonthKWh: Total consumption for the past month in kWh.
 * trend: Consumption trend indicator, which can be a number or null.
 * monthlyData: Optional array of monthly consumption data, which can be null if no data is available.
 *
 * The endpoint provides a quick overview of the electricity consumption patterns and trends.
 * @throws ApiError
 */
export const consumptionTrendsControllerGetConsumptionTrendsByEnergyType = (data: ConsumptionTrendsControllerGetConsumptionTrendsByEnergyTypeData): CancelablePromise<ConsumptionTrendsControllerGetConsumptionTrendsByEnergyTypeResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v3/trends/consumption',
    query: {
        companyId: data.companyId,
        regionId: data.regionId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        energyTypes: data.energyTypes,
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * @param data The data for the request.
 * @param data.years Comma-seperate list of years
 * @param data.buildingId Building ID
 * @param data.companyId Company Firebase ID
 * @param data.regionId Region ID
 * @param data.locationId Location Firebase ID
 * @param data.energyTypes
 * @returns ConsumptionHistoryResponseDto Get consumption history trends
 * @throws ApiError
 */
export const consumptionTrendsControllerGetConsumptionHistory = (data: ConsumptionTrendsControllerGetConsumptionHistoryData): CancelablePromise<ConsumptionTrendsControllerGetConsumptionHistoryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/trends/consumption-history',
    query: {
        years: data.years,
        buildingId: data.buildingId,
        companyId: data.companyId,
        regionId: data.regionId,
        locationId: data.locationId,
        energyTypes: data.energyTypes
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from
 * @param data.to
 * @param data.locationId
 * @param data.deviceId
 * @returns unknown Total costs for a device in a location within a given time period
 * @throws ApiError
 */
export const invoiceCostsControllerGetInvoiceCosts = (data: InvoiceCostsControllerGetInvoiceCostsData): CancelablePromise<InvoiceCostsControllerGetInvoiceCostsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/cost/invoice',
    query: {
        from: data.from,
        to: data.to,
        locationId: data.locationId,
        deviceId: data.deviceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.year
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerRecalculateYear = (data: CalculationsControllerRecalculateYearData): CancelablePromise<CalculationsControllerRecalculateYearResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/calculations/devices/{deviceId}/year/{year}',
    path: {
        deviceId: data.deviceId,
        year: data.year
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @param data.month
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerRecalculateMonth = (data: CalculationsControllerRecalculateMonthData): CancelablePromise<CalculationsControllerRecalculateMonthResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/calculations/locations/{locationId}/devices/{deviceId}/month/{month}',
    path: {
        deviceId: data.deviceId,
        month: data.month
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @param data.deviceId
 * @param data.date
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerRecalculateDay = (data: CalculationsControllerRecalculateDayData): CancelablePromise<CalculationsControllerRecalculateDayResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/calculations/locations/{locationId}/devices/{deviceId}/date/{date}',
    path: {
        locationId: data.locationId,
        deviceId: data.deviceId,
        date: data.date
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerCalculateEnetCosts = (data: CalculationsControllerCalculateEnetCostsData): CancelablePromise<CalculationsControllerCalculateEnetCostsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/calculations/enet-costs',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerCalculatePeakload = (data: CalculationsControllerCalculatePeakloadData): CancelablePromise<CalculationsControllerCalculatePeakloadResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/calculations/peakload-daily',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerCalculateBaseload = (data: CalculationsControllerCalculateBaseloadData): CancelablePromise<CalculationsControllerCalculateBaseloadResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/calculations/baseload-ytd',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.year Year to filter locations data.
 * @param data.companyId Company ID to filter locations data.
 * @param data.regionId Region ID to filter locations data.
 * @param data.locationId Location ID to filter locations data.
 * @param data.buildingId Building ID to filter locations data.
 * @param data.page The page number for pagination. Must be greater than or equal to 1.
 * @param data.limit The number of results per page. Must be greater than or equal to 1.
 * @param data.sortBy Field to sort the results by.
 * @param data.sortOrder Sort order for the results.
 * @param data.energyType Energy type to filter locations data.
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerGetLocationsOverview = (data: CalculationsControllerGetLocationsOverviewData): CancelablePromise<CalculationsControllerGetLocationsOverviewResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/calculations/locations',
    query: {
        year: data.year,
        companyId: data.companyId,
        regionId: data.regionId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        page: data.page,
        limit: data.limit,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder,
        energyType: data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.year Year to filter locations data.
 * @param data.companyId Company ID to filter locations data.
 * @param data.year Year to filter locations data.
 * @param data.companyId Company ID to filter locations data.
 * @param data.regionId Region ID to filter locations data.
 * @param data.locationId Location ID to filter locations data.
 * @param data.buildingId Building ID to filter locations data.
 * @param data.page The page number for pagination. Must be greater than or equal to 1.
 * @param data.limit The number of results per page. Must be greater than or equal to 1.
 * @param data.sortBy Field to sort the results by.
 * @param data.sortOrder Sort order for the results.
 * @param data.energyType Energy type to filter locations data.
 * @param data.regionId Region ID to filter locations data.
 * @param data.locationId Location ID to filter locations data.
 * @param data.buildingId Building ID to filter locations data.
 * @param data.page The page number for pagination. Must be greater than or equal to 1.
 * @param data.limit The number of results per page. Must be greater than or equal to 1.
 * @param data.sortBy Field to sort the results by.
 * @param data.sortOrder Sort order for the results.
 * @param data.energyType Energy type to filter locations data.
 * @returns LocationEnergyPerformanceMetricsResponseDto Get locations metrics
 * @throws ApiError
 */
export const calculationsControllerGetLocationsMetrics = (data: CalculationsControllerGetLocationsMetricsData): CancelablePromise<CalculationsControllerGetLocationsMetricsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/calculations/metrics',
    query: {
        year: data.year,
        companyId: data.companyId,
        regionId: data.regionId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        page: data.page,
        limit: data.limit,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder,
        energyType: data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.year Year to filter locations data.
 * @param data.companyId Company ID to filter locations data.
 * @param data.year Year to filter locations data.
 * @param data.companyId Company ID to filter locations data.
 * @param data.regionId Region ID to filter locations data.
 * @param data.locationId Location ID to filter locations data.
 * @param data.buildingId Building ID to filter locations data.
 * @param data.page The page number for pagination. Must be greater than or equal to 1.
 * @param data.limit The number of results per page. Must be greater than or equal to 1.
 * @param data.sortBy Field to sort the results by.
 * @param data.sortOrder Sort order for the results.
 * @param data.energyType Energy type to filter locations data.
 * @param data.regionId Region ID to filter locations data.
 * @param data.locationId Location ID to filter locations data.
 * @param data.buildingId Building ID to filter locations data.
 * @param data.page The page number for pagination. Must be greater than or equal to 1.
 * @param data.limit The number of results per page. Must be greater than or equal to 1.
 * @param data.sortBy Field to sort the results by.
 * @param data.sortOrder Sort order for the results.
 * @param data.energyType Energy type to filter locations data.
 * @returns unknown Get locations metrics
 * @throws ApiError
 */
export const calculationsControllerGetLocationsMetricsCsv = (data: CalculationsControllerGetLocationsMetricsCsvData): CancelablePromise<CalculationsControllerGetLocationsMetricsCsvResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/calculations/metrics/csv',
    query: {
        year: data.year,
        companyId: data.companyId,
        regionId: data.regionId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        page: data.page,
        limit: data.limit,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder,
        energyType: data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const calculationsControllerStoreHedgeCostMonthlySummary = (data: CalculationsControllerStoreHedgeCostMonthlySummaryData): CancelablePromise<CalculationsControllerStoreHedgeCostMonthlySummaryResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/calculations/hedge-costs-monthly-summary',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns void
 * @throws ApiError
 */
export const calculationsControllerRunCostCalculations = (): CancelablePromise<CalculationsControllerRunCostCalculationsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/calculations/run-cost-calculation'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const calculationsControllerRecalculateDeviceMetrics = (data: CalculationsControllerRecalculateDeviceMetricsData): CancelablePromise<CalculationsControllerRecalculateDeviceMetricsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/calculations/recalculate-device-metrics',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @returns CostsSummaryResponseDto Get Costs Summary for given year.
 * @throws ApiError
 */
export const costsSummaryControllerGetCostsSummary = (data: CostsSummaryControllerGetCostsSummaryData): CancelablePromise<CostsSummaryControllerGetCostsSummaryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/calculations/costs-summary/{year}',
    path: {
        year: data.year
    },
    query: {
        locationId: data.locationId,
        companyId: data.companyId
    }
}); };

/**
 * Get enabled modules for a user location
 * @param data The data for the request.
 * @param data.userId User ID to get enabled modules for
 * @param data.companyId Company ID to get enabled modules for
 * @returns LocationModulesResponseDto Returns the enabled modules for the location
 * @throws ApiError
 */
export const locationControllerGetEnabledModulesForUser = (data: LocationControllerGetEnabledModulesForUserData): CancelablePromise<LocationControllerGetEnabledModulesForUserResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/locations/enabled-modules',
    query: {
        userId: data.userId,
        companyId: data.companyId
    }
}); };

/**
 * Update enabled modules for a location
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @returns void Modules updated successfully
 * @throws ApiError
 */
export const locationControllerUpdateEnabledModules = (data: LocationControllerUpdateEnabledModulesData): CancelablePromise<LocationControllerUpdateEnabledModulesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/locations/{id}/enabled-modules',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * get enabled modules for a location
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Modules updated successfully
 * @throws ApiError
 */
export const locationControllerGetLocationEnabledModules = (data: LocationControllerGetLocationEnabledModulesData): CancelablePromise<LocationControllerGetLocationEnabledModulesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/locations/{id}/enabled-modules',
    path: {
        id: data.id
    }
}); };

/**
 * Get location
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @returns LocationDto Get location
 * @throws ApiError
 */
export const locationControllerGetLocation = (data: LocationControllerGetLocationData): CancelablePromise<LocationControllerGetLocationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/locations/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @returns unknown Get energy manager pro settings
 * @throws ApiError
 */
export const locationControllerGetEnergyManagerSettings = (data: LocationControllerGetEnergyManagerSettingsData): CancelablePromise<LocationControllerGetEnergyManagerSettingsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/locations/energy-manager-settings',
    query: {
        locationId: data.locationId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Set energy manager pro settings
 * @throws ApiError
 */
export const locationControllerSetEnergyManagerSettings = (data: LocationControllerSetEnergyManagerSettingsData): CancelablePromise<LocationControllerSetEnergyManagerSettingsResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/locations/energy-manager-settings',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @param data.requestBody
 * @returns unknown Set reports settings
 * @throws ApiError
 */
export const locationControllerSetReportsSettings = (data: LocationControllerSetReportsSettingsData): CancelablePromise<LocationControllerSetReportsSettingsResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/locations/{locationId}/reports',
    path: {
        locationId: data.locationId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns PricesResponseDto Spot market prices for the given time period
 * @throws ApiError
 */
export const pricesControllerGetPrices = (): CancelablePromise<PricesControllerGetPricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/procurement/prices'
}); };

/**
 * @returns CurrentPriceResponseDto Current spot market price
 * @throws ApiError
 */
export const pricesControllerGetCurrentPrice = (): CancelablePromise<PricesControllerGetCurrentPriceResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/procurement/prices/current'
}); };

/**
 * @returns AveragePriceResponseDto Average year to date spot market price
 * @throws ApiError
 */
export const pricesControllerGetAverageYtdPrice = (): CancelablePromise<PricesControllerGetAverageYtdPriceResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/procurement/prices/average-year-to-date'
}); };

/**
 * @deprecated
 * Deprecated electricity price KPIs for legacy clients.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Electricity prices
 * @throws ApiError
 */
export const pricesControllerGetElectricityPrices = (data: PricesControllerGetElectricityPricesData): CancelablePromise<PricesControllerGetElectricityPricesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/prices/electricity',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.startDate Start date (ISO 8601 string)
 * @param data.endDate End date (ISO 8601 string)
 * @param data.energyType Which spot market to read. Defaults to electricity.
 * @param data.source Gas price series to read (only applies when energyType=gas). Defaults to EGSI.
 * @returns SpotMarketPriceResponseDto Spot market prices for the given time period
 * @throws ApiError
 */
export const spotMarketControllerGetPrices = (data: SpotMarketControllerGetPricesData): CancelablePromise<SpotMarketControllerGetPricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/spot-market',
    query: {
        startDate: data.startDate,
        endDate: data.endDate,
        energyType: data.energyType,
        source: data.source
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.startDate Start date (ISO 8601 string)
 * @param data.endDate End date (ISO 8601 string)
 * @param data.energyType Which spot market to read. Defaults to electricity.
 * @returns SpotMarketPriceResponseDto Spot market prices resolved from the company gas price source configuration
 * @throws ApiError
 */
export const spotMarketControllerGetCompanyPrices = (data: SpotMarketControllerGetCompanyPricesData): CancelablePromise<SpotMarketControllerGetCompanyPricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/spot-market/{companyId}',
    path: {
        companyId: data.companyId
    },
    query: {
        startDate: data.startDate,
        endDate: data.endDate,
        energyType: data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EmberChecklistAgentResponse Request accepted and is being processed
 * @throws ApiError
 */
export const emberControllerAskChecklistAssistant = (data: EmberControllerAskChecklistAssistantData): CancelablePromise<EmberControllerAskChecklistAssistantResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/checklist',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EmberDocumentAgentResponse Request accepted and is being processed
 * @throws ApiError
 */
export const emberControllerAskDocumentAssistant = (data: EmberControllerAskDocumentAssistantData): CancelablePromise<EmberControllerAskDocumentAssistantResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/document',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Lists all already embedded files
 * Returns the filenames and database IDs (e.g. for later delete) of embedded files
 * @returns GetEmbeddedFilesDTO List of all embedded files
 * @throws ApiError
 */
export const emberControllerGetEmbeddedFiles = (): CancelablePromise<EmberControllerGetEmbeddedFilesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/ember/embeddings'
}); };

/**
 * Embeds the uploaded files
 * Creates or updates vector embeddings and writes them into a vectorstore
 * @returns EmbeddingResultDTO Results of the file embedding operations
 * @throws ApiError
 */
export const emberControllerCreateEmbeddings = (): CancelablePromise<EmberControllerCreateEmbeddingsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/embeddings'
}); };

/**
 * Deletes embeddings for file with given ID
 * Deletes all embedding chunks associated with a file and deletes the file reference
 * @param data The data for the request.
 * @param data.id ID of the embedding file to delete
 * @returns unknown
 * @returns void File and its corresponding embeddings deleted successfully
 * @throws ApiError
 */
export const emberControllerDeleteEmbeddingsByFileId = (data: EmberControllerDeleteEmbeddingsByFileIdData): CancelablePromise<EmberControllerDeleteEmbeddingsByFileIdResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/ember/embeddings/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EmberChatAgentResponse Request accepted and is being processed
 * @throws ApiError
 */
export const emberControllerAskChatAssistant = (data: EmberControllerAskChatAssistantData): CancelablePromise<EmberControllerAskChatAssistantResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/chat',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @returns void Message processing aborted
 * @throws ApiError
 */
export const emberControllerCancelMessageProcessing = (data: EmberControllerCancelMessageProcessingData): CancelablePromise<EmberControllerCancelMessageProcessingResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/cancel',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Manually trigger thread cleanup
 * Manually triggers the cleanup of expired thread checkpoints and lifecycle records
 * @returns EmberThreadCleanupResultDto Thread cleanup completed
 * @returns unknown
 * @throws ApiError
 */
export const emberControllerCleanupExpiredThreads = (): CancelablePromise<EmberControllerCleanupExpiredThreadsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/threads/cleanup'
}); };

/**
 * 🚨 DESTRUCTIVE: Delete ALL threads
 * Deletes ALL thread lifecycle records and their corresponding Langchain checkpoints. This operation cannot be undone.
 * @returns EmberThreadDeleteResultDto All threads deleted successfully
 * @throws ApiError
 */
export const emberControllerDeleteAllThreads = (): CancelablePromise<EmberControllerDeleteAllThreadsResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/ember/threads/all'
}); };

/**
 * Get thread lifecycle statistics
 * Returns statistics about active and expired threads
 * @returns EmberThreadStatsDto Thread statistics
 * @throws ApiError
 */
export const emberControllerGetThreadStats = (): CancelablePromise<EmberControllerGetThreadStatsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/ember/threads/stats'
}); };

/**
 * Get proposed follow-up questions
 * Returns two suggested questions based on the last user message and assistant type
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ProposedQuestionsResponseDto Proposed questions
 * @throws ApiError
 */
export const emberControllerGetProposedQuestions = (data: EmberControllerGetProposedQuestionsData): CancelablePromise<EmberControllerGetProposedQuestionsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/propose',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Ask ember to generate a module configuration (can be a create or and update action)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ResponseReportModuleDto A report module DTO with AI-generated values
 * @throws ApiError
 */
export const emberControllerGenerateReportModuleConfig = (data: EmberControllerGenerateReportModuleConfigData): CancelablePromise<EmberControllerGenerateReportModuleConfigResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/ember/reports/generate-module',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed',
        401: 'Unauthorized'
    }
}); };

/**
 * Returns a visualization of the agent graph as a PNG
 * @param data The data for the request.
 * @param data.agent Name of the agent to be visualized
 * @returns unknown Visualization of the agent graph as a PNG
 * @throws ApiError
 */
export const emberControllerVisualizeAgentGraph = (data: EmberControllerVisualizeAgentGraphData): CancelablePromise<EmberControllerVisualizeAgentGraphResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/ember/agent-graph',
    query: {
        agent: data.agent
    }
}); };

/**
 * Returns all embedded call transcripts. Can be filtered by fireflies ID or company ID.
 * @param data The data for the request.
 * @param data.firefliesId
 * @param data.companyId
 * @returns GetEmbeddedCallTranscriptsDTO Returns a list of call transcripts
 * @throws ApiError
 */
export const emberControllerGetCallTranscriptsForCompany = (data: EmberControllerGetCallTranscriptsForCompanyData): CancelablePromise<EmberControllerGetCallTranscriptsForCompanyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/ember/call-transcripts',
    query: {
        firefliesId: data.firefliesId,
        companyId: data.companyId
    }
}); };

/**
 * Triggers the embedding of one particular Fireflies call transcript
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @returns EmbeddingResultDTO
 * @throws ApiError
 */
export const emberControllerEmbedSingleCallTranscript = (data: EmberControllerEmbedSingleCallTranscriptData): CancelablePromise<EmberControllerEmbedSingleCallTranscriptResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/call-transcripts',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Deletes embeddings associated with the given call transcript ID
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const emberControllerDeleteSingleCallTranscriptEmbedding = (data: EmberControllerDeleteSingleCallTranscriptEmbeddingData): CancelablePromise<EmberControllerDeleteSingleCallTranscriptEmbeddingResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/ember/call-transcripts',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Triggers the embedding of all call transcripts from all companies into the Ember vectorstore
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const emberControllerSyncCallTranscripts = (data: EmberControllerSyncCallTranscriptsData): CancelablePromise<EmberControllerSyncCallTranscriptsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/ember/call-transcripts/sync',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get a single custom report by ID
 * @param data The data for the request.
 * @param data.id
 * @returns ResponseCustomReportDto Custom report retrieved
 * @throws ApiError
 */
export const customReportControllerGetCustomReport = (data: CustomReportControllerGetCustomReportData): CancelablePromise<CustomReportControllerGetCustomReportResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{id}',
    path: {
        id: data.id
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden: user has no access to this report',
        404: 'Custom report not found'
    }
}); };

/**
 * Update an existing custom report
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns ResponseCustomReportDto Custom report updated
 * @throws ApiError
 */
export const customReportControllerUpdateCustomReport = (data: CustomReportControllerUpdateCustomReportData): CancelablePromise<CustomReportControllerUpdateCustomReportResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/custom-reports/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed',
        401: 'Unauthorized',
        403: 'Forbidden: user has no access to this report',
        404: 'Custom report not found'
    }
}); };

/**
 * Delete a custom report
 * @param data The data for the request.
 * @param data.id
 * @returns void Custom report deleted
 * @throws ApiError
 */
export const customReportControllerDeleteCustomReport = (data: CustomReportControllerDeleteCustomReportData): CancelablePromise<CustomReportControllerDeleteCustomReportResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/custom-reports/{id}',
    path: {
        id: data.id
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden: user has no access to this report',
        404: 'Custom report not found'
    }
}); };

/**
 * Get all custom reports for a specific company
 * @param data The data for the request.
 * @param data.companyId
 * @returns ResponseCustomReportDto List of custom reports
 * @throws ApiError
 */
export const customReportControllerGetAllCustomReports = (data: CustomReportControllerGetAllCustomReportsData): CancelablePromise<CustomReportControllerGetAllCustomReportsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports',
    query: {
        companyId: data.companyId
    },
    errors: {
        401: 'Unauthorized'
    }
}); };

/**
 * Create a new custom report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ResponseCustomReportDto Custom report created
 * @throws ApiError
 */
export const customReportControllerCreateCustomReport = (data: CustomReportControllerCreateCustomReportData): CancelablePromise<CustomReportControllerCreateCustomReportResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed',
        401: 'Unauthorized'
    }
}); };

/**
 * Request a reporting plan upgrade (notifies Customer Success)
 * @returns unknown Upgrade request sent
 * @throws ApiError
 */
export const customReportControllerRequestReportingUpgrade = (): CancelablePromise<CustomReportControllerRequestReportingUpgradeResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports/request-reporting-upgrade',
    errors: {
        401: 'Unauthorized'
    }
}); };

/**
 * Download the logo for a custom report
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Logo file returned
 * @throws ApiError
 */
export const customReportControllerGetCustomReportLogo = (data: CustomReportControllerGetCustomReportLogoData): CancelablePromise<CustomReportControllerGetCustomReportLogoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{id}/logo',
    path: {
        id: data.id
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden: user has no access to this report',
        404: 'Logo not found'
    }
}); };

/**
 * Manually trigger report generation
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown Report generated successfully
 * @throws ApiError
 */
export const customReportControllerGenerateReportManually = (data: CustomReportControllerGenerateReportManuallyData): CancelablePromise<CustomReportControllerGenerateReportManuallyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports/{id}/generate',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Report has no frequency configuration',
        401: 'Unauthorized',
        404: 'Report not found'
    }
}); };

/**
 * Generate PDF for report (POC)
 * @param data The data for the request.
 * @param data.id
 * @returns unknown PDF generated successfully
 * @throws ApiError
 */
export const customReportControllerGeneratePdf = (data: CustomReportControllerGeneratePdfData): CancelablePromise<CustomReportControllerGeneratePdfResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports/{id}/generate-pdf',
    path: {
        id: data.id
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Report not found'
    }
}); };

/**
 * Validate PDF access token
 * @param data The data for the request.
 * @param data.token
 * @returns unknown Token is valid
 * @throws ApiError
 */
export const customReportControllerValidatePdfToken = (data: CustomReportControllerValidatePdfTokenData): CancelablePromise<CustomReportControllerValidatePdfTokenResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/pdf-access/validate',
    query: {
        token: data.token
    },
    errors: {
        401: 'Invalid or expired token'
    }
}); };

/**
 * Get report with modules for PDF generation
 * @param data The data for the request.
 * @param data.token
 * @param data.reportId
 * @returns ResponseReportWithModulesForPdfDto Report with modules data
 * @throws ApiError
 */
export const customReportControllerGetModulesForPdf = (data: CustomReportControllerGetModulesForPdfData): CancelablePromise<CustomReportControllerGetModulesForPdfResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/pdf-access/report/{reportId}/modules',
    path: {
        reportId: data.reportId
    },
    query: {
        token: data.token
    },
    errors: {
        401: 'Invalid PDF token',
        404: 'Report not found'
    }
}); };

/**
 * Get data completeness for PDF generation
 * @param data The data for the request.
 * @param data.token
 * @param data.reportId
 * @param data.startDate Range start for completeness calculation.
 * @param data.endDate Range end for completeness calculation. Must be on or after startDate.
 * @param data.deviceIds Meter device IDs. Explicit ids are additive with customTimeseriesIds and take precedence over hierarchy filters.
 * @param data.customTimeseriesIds Custom time series IDs. Pass explicitly to include custom time series; hierarchy filters do not automatically include them.
 * @param data.includeElectricitySpotPrices When true, include electricity spot market prices in the scoped calculation.
 * @param data.companyId Company ID. Used when explicit ids or narrower hierarchy filters are omitted.
 * @param data.locationIds Location IDs. Used when explicit ids or buildingIds are omitted; takes precedence over companyId.
 * @param data.buildingIds Building IDs. Used when deviceIds are omitted; takes precedence over locationIds and companyId.
 * @param data.energyType Energy type filter (e.g. electricity, gas). Omit to return all types.
 * @param data.onlyMainMeters When true, return data only for legacy meters marked as main. Linked sidecar series are excluded. Omit or false for all meters and series matching the scope filter.
 * @param data.itemLevel When set to timeSeries, hierarchy scopes return one item per legacy meter stream or linked sidecar series. Omit to preserve scope-level grouping.
 * @param data.entityType Limit a timeSeries-level request to one storage namespace. Omit to include legacy meters and linked sidecar series; with deviceIds, one meter device ID can therefore return both the meter and its sidecars.
 * @param data.includeIntervals Include per-interval details in each item. Defaults to true for backward compatibility.
 * @returns GetDataCompletenessResponseDto Data completeness returned
 * @throws ApiError
 */
export const customReportControllerGetDataCompletenessForPdf = (data: CustomReportControllerGetDataCompletenessForPdfData): CancelablePromise<CustomReportControllerGetDataCompletenessForPdfResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/pdf-access/report/{reportId}/data-completeness',
    path: {
        reportId: data.reportId
    },
    query: {
        token: data.token,
        deviceIds: data.deviceIds,
        customTimeseriesIds: data.customTimeseriesIds,
        includeElectricitySpotPrices: data.includeElectricitySpotPrices,
        companyId: data.companyId,
        locationIds: data.locationIds,
        buildingIds: data.buildingIds,
        energyType: data.energyType,
        onlyMainMeters: data.onlyMainMeters,
        itemLevel: data.itemLevel,
        entityType: data.entityType,
        includeIntervals: data.includeIntervals,
        startDate: data.startDate,
        endDate: data.endDate
    },
    errors: {
        401: 'Invalid PDF token'
    }
}); };

/**
 * Get module image for PDF generation
 * @param data The data for the request.
 * @param data.token
 * @param data.reportId
 * @param data.moduleId
 * @returns unknown Image file returned
 * @throws ApiError
 */
export const customReportControllerGetModuleImageForPdf = (data: CustomReportControllerGetModuleImageForPdfData): CancelablePromise<CustomReportControllerGetModuleImageForPdfResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/pdf-access/report/{reportId}/module/{moduleId}/images',
    path: {
        reportId: data.reportId,
        moduleId: data.moduleId
    },
    query: {
        token: data.token
    },
    errors: {
        401: 'Invalid PDF token',
        404: 'Image not found'
    }
}); };

/**
 * Manually trigger recovery sweep for missed reports (for testing)
 * @returns unknown Recovery sweep completed
 * @throws ApiError
 */
export const customReportControllerTriggerRecoverySweep = (): CancelablePromise<CustomReportControllerTriggerRecoverySweepResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports/scheduler/trigger-recovery',
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden — platform admin access required'
    }
}); };

/**
 * Get all sent reports generated from a report
 * @param data The data for the request.
 * @param data.reportId
 * @returns ResponseSentReportDto List of sent reports
 * @throws ApiError
 */
export const customReportControllerGetSentReports = (data: CustomReportControllerGetSentReportsData): CancelablePromise<CustomReportControllerGetSentReportsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/sent-reports',
    path: {
        reportId: data.reportId
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Report not found'
    }
}); };

/**
 * Get a single sent report by ID
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sentReportId
 * @returns ResponseSentReportDto Sent report retrieved
 * @throws ApiError
 */
export const customReportControllerGetSentReport = (data: CustomReportControllerGetSentReportData): CancelablePromise<CustomReportControllerGetSentReportResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/sent-reports/{sentReportId}',
    path: {
        reportId: data.reportId,
        sentReportId: data.sentReportId
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Sent report not found'
    }
}); };

/**
 * Download the logo for a sent report
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sentReportId
 * @returns unknown Logo file returned
 * @throws ApiError
 */
export const customReportControllerGetSentReportLogo = (data: CustomReportControllerGetSentReportLogoData): CancelablePromise<CustomReportControllerGetSentReportLogoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/sent-reports/{sentReportId}/logo',
    path: {
        reportId: data.reportId,
        sentReportId: data.sentReportId
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden: user has no access to this report',
        404: 'Logo not found'
    }
}); };

/**
 * Get all modules captured in a sent report
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sentReportId
 * @returns ResponseSentReportModuleDto List of sent report modules
 * @throws ApiError
 */
export const customReportControllerGetSentReportModules = (data: CustomReportControllerGetSentReportModulesData): CancelablePromise<CustomReportControllerGetSentReportModulesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules',
    path: {
        reportId: data.reportId,
        sentReportId: data.sentReportId
    },
    errors: {
        400: 'Validation failed or report mismatch',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Sent report not found'
    }
}); };

/**
 * Get all sent report modules along with their data series
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sentReportId
 * @returns ResponseSentReportModuleWithDataDto List of sent report modules with data
 * @throws ApiError
 */
export const customReportControllerGetSentReportModulesWithData = (data: CustomReportControllerGetSentReportModulesWithDataData): CancelablePromise<CustomReportControllerGetSentReportModulesWithDataResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules-with-data',
    path: {
        reportId: data.reportId,
        sentReportId: data.sentReportId
    },
    errors: {
        400: 'Validation failed or report mismatch',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Sent report not found'
    }
}); };

/**
 * Get a single sent report module with its data series
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sentReportId
 * @param data.moduleId
 * @returns ResponseSentReportModuleWithDataDto Sent report module with data
 * @throws ApiError
 */
export const customReportControllerGetSentReportModuleWithData = (data: CustomReportControllerGetSentReportModuleWithDataData): CancelablePromise<CustomReportControllerGetSentReportModuleWithDataResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules/{moduleId}',
    path: {
        reportId: data.reportId,
        sentReportId: data.sentReportId,
        moduleId: data.moduleId
    },
    errors: {
        400: 'Validation failed or report mismatch',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Module not found'
    }
}); };

/**
 * Download the image for a sent report image module
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sentReportId
 * @param data.moduleId
 * @returns unknown Image file returned
 * @throws ApiError
 */
export const customReportControllerGetSentReportModuleImage = (data: CustomReportControllerGetSentReportModuleImageData): CancelablePromise<CustomReportControllerGetSentReportModuleImageResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules/{moduleId}/image',
    path: {
        reportId: data.reportId,
        sentReportId: data.sentReportId,
        moduleId: data.moduleId
    },
    errors: {
        400: 'Validation failed or report mismatch',
        401: 'Unauthorized',
        403: 'Forbidden: user has no access to this report',
        404: 'Image not found'
    }
}); };

/**
 * Get all modules for a report
 * @param data The data for the request.
 * @param data.reportId
 * @returns ResponseReportModuleDto List of report modules
 * @throws ApiError
 */
export const customReportControllerGetReportModules = (data: CustomReportControllerGetReportModulesData): CancelablePromise<CustomReportControllerGetReportModulesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/modules',
    path: {
        reportId: data.reportId
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Report not found'
    }
}); };

/**
 * Create a new report module
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns ResponseReportModuleDto Report module created
 * @throws ApiError
 */
export const customReportControllerCreateReportModule = (data: CustomReportControllerCreateReportModuleData): CancelablePromise<CustomReportControllerCreateReportModuleResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports/{reportId}/modules',
    path: {
        reportId: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed',
        401: 'Unauthorized',
        403: 'Forbidden'
    }
}); };

/**
 * Get a single module with its data series
 * @param data The data for the request.
 * @param data.reportId
 * @param data.moduleId
 * @param data.limit Maximum number of data series to include
 * @returns ResponseReportModuleWithDataDto Report module with data
 * @throws ApiError
 */
export const customReportControllerGetModule = (data: CustomReportControllerGetModuleData): CancelablePromise<CustomReportControllerGetModuleResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/modules/{moduleId}',
    path: {
        reportId: data.reportId,
        moduleId: data.moduleId
    },
    query: {
        limit: data.limit
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Module not found'
    }
}); };

/**
 * Update a report module
 * @param data The data for the request.
 * @param data.reportId
 * @param data.moduleId
 * @param data.requestBody
 * @returns ResponseReportModuleDto Report module updated
 * @throws ApiError
 */
export const customReportControllerUpdateReportModule = (data: CustomReportControllerUpdateReportModuleData): CancelablePromise<CustomReportControllerUpdateReportModuleResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/custom-reports/{reportId}/modules/{moduleId}',
    path: {
        reportId: data.reportId,
        moduleId: data.moduleId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Module not found'
    }
}); };

/**
 * Delete a report module
 * @param data The data for the request.
 * @param data.reportId
 * @param data.moduleId
 * @returns void Report module deleted
 * @throws ApiError
 */
export const customReportControllerDeleteReportModule = (data: CustomReportControllerDeleteReportModuleData): CancelablePromise<CustomReportControllerDeleteReportModuleResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/custom-reports/{reportId}/modules/{moduleId}',
    path: {
        reportId: data.reportId,
        moduleId: data.moduleId
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Module not found'
    }
}); };

/**
 * Insert the modules of a predefined template into a report
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns ResponseReportModuleDto Template modules created
 * @throws ApiError
 */
export const customReportControllerApplyTemplate = (data: CustomReportControllerApplyTemplateData): CancelablePromise<CustomReportControllerApplyTemplateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports/{reportId}/apply-template',
    path: {
        reportId: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed',
        401: 'Unauthorized',
        403: 'Forbidden'
    }
}); };

/**
 * Reorder report modules via drag-and-drop
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns ResponseReportModuleDto Modules reordered successfully
 * @throws ApiError
 */
export const customReportControllerReorderReportModules = (data: CustomReportControllerReorderReportModulesData): CancelablePromise<CustomReportControllerReorderReportModulesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/custom-reports/{reportId}/modules/reorder',
    path: {
        reportId: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation failed or invalid module IDs',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Report not found'
    }
}); };

/**
 * Download the image for an image module
 * @param data The data for the request.
 * @param data.reportId
 * @param data.moduleId
 * @returns unknown Image file returned
 * @throws ApiError
 */
export const customReportControllerGetModuleImage = (data: CustomReportControllerGetModuleImageData): CancelablePromise<CustomReportControllerGetModuleImageResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/custom-reports/{reportId}/modules/{moduleId}/image',
    path: {
        reportId: data.reportId,
        moduleId: data.moduleId
    },
    errors: {
        400: 'Module is not an image module',
        401: 'Unauthorized',
        403: 'Forbidden: user has no access to this report',
        404: 'Image not found'
    }
}); };

/**
 * Get data completeness by scope item (device, building, location, or company)
 * @param data The data for the request.
 * @param data.startDate Range start for completeness calculation.
 * @param data.endDate Range end for completeness calculation. Must be on or after startDate.
 * @param data.deviceIds Meter device IDs. Explicit ids are additive with customTimeseriesIds and take precedence over hierarchy filters.
 * @param data.customTimeseriesIds Custom time series IDs. Pass explicitly to include custom time series; hierarchy filters do not automatically include them.
 * @param data.includeElectricitySpotPrices When true, include electricity spot market prices in the scoped calculation.
 * @param data.companyId Company ID. Used when explicit ids or narrower hierarchy filters are omitted.
 * @param data.locationIds Location IDs. Used when explicit ids or buildingIds are omitted; takes precedence over companyId.
 * @param data.buildingIds Building IDs. Used when deviceIds are omitted; takes precedence over locationIds and companyId.
 * @param data.energyType Energy type filter (e.g. electricity, gas). Omit to return all types.
 * @param data.onlyMainMeters When true, return data only for legacy meters marked as main. Linked sidecar series are excluded. Omit or false for all meters and series matching the scope filter.
 * @param data.itemLevel When set to timeSeries, hierarchy scopes return one item per legacy meter stream or linked sidecar series. Omit to preserve scope-level grouping.
 * @param data.entityType Limit a timeSeries-level request to one storage namespace. Omit to include legacy meters and linked sidecar series; with deviceIds, one meter device ID can therefore return both the meter and its sidecars.
 * @param data.includeIntervals Include per-interval details in each item. Defaults to true for backward compatibility.
 * @returns GetDataCompletenessResponseDto Scope items with item-level and per-period completeness plus global completenessPercentage rollup
 * @throws ApiError
 */
export const dataCompletenessControllerGetDataCompleteness = (data: DataCompletenessControllerGetDataCompletenessData): CancelablePromise<DataCompletenessControllerGetDataCompletenessResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/data-completeness',
    query: {
        deviceIds: data.deviceIds,
        customTimeseriesIds: data.customTimeseriesIds,
        includeElectricitySpotPrices: data.includeElectricitySpotPrices,
        companyId: data.companyId,
        locationIds: data.locationIds,
        buildingIds: data.buildingIds,
        energyType: data.energyType,
        onlyMainMeters: data.onlyMainMeters,
        itemLevel: data.itemLevel,
        entityType: data.entityType,
        includeIntervals: data.includeIntervals,
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * Get device data gaps by device, building, location, or company
 * @param data The data for the request.
 * @param data.deviceIds Meter device IDs. Explicit ids are additive with customTimeseriesIds and take precedence over hierarchy filters.
 * @param data.customTimeseriesIds Custom time series IDs. Pass explicitly to include custom time series; hierarchy filters do not automatically include them.
 * @param data.includeElectricitySpotPrices When true, include electricity spot market prices in the scoped calculation.
 * @param data.companyId Company ID. Used when explicit ids or narrower hierarchy filters are omitted.
 * @param data.locationIds Location IDs. Used when explicit ids or buildingIds are omitted; takes precedence over companyId.
 * @param data.buildingIds Building IDs. Used when deviceIds are omitted; takes precedence over locationIds and companyId.
 * @param data.energyType Energy type filter (e.g. electricity, gas). Omit to return all types.
 * @param data.onlyMainMeters When true, return data only for legacy meters marked as main. Linked sidecar series are excluded. Omit or false for all meters and series matching the scope filter.
 * @param data.entityType Limit energy gaps to legacy meters or sidecar series. Omit to preserve the combined result.
 * @param data.includeSeries Include linked sidecar-series gaps in addition to legacy meter gaps.
 * @param data.startDate Include gaps that overlap this range start (optional).
 * @param data.endDate Include gaps that overlap this range end (optional). Must be on or after startDate when both are set.
 * @returns GetGapsResponseDto Get device data gaps filtered by scope and optional date range
 * @throws ApiError
 */
export const gapsControllerGetGaps = (data: GapsControllerGetGapsData = {}): CancelablePromise<GapsControllerGetGapsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/gaps',
    query: {
        deviceIds: data.deviceIds,
        customTimeseriesIds: data.customTimeseriesIds,
        includeElectricitySpotPrices: data.includeElectricitySpotPrices,
        companyId: data.companyId,
        locationIds: data.locationIds,
        buildingIds: data.buildingIds,
        energyType: data.energyType,
        onlyMainMeters: data.onlyMainMeters,
        entityType: data.entityType,
        includeSeries: data.includeSeries,
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * List series by hierarchy
 * Get series filtered by deviceIds, buildingId, locationId, or companyId. At least one parameter must be provided.
 * @param data The data for the request.
 * @param data.deviceIds Filter by device IDs (comma-separated)
 * @param data.buildingId Filter by building ID
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @returns SeriesResponseDto Series list retrieved
 * @throws ApiError
 */
export const seriesControllerListSeries = (data: SeriesControllerListSeriesData = {}): CancelablePromise<SeriesControllerListSeriesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/series',
    query: {
        deviceIds: data.deviceIds,
        buildingId: data.buildingId,
        locationId: data.locationId,
        companyId: data.companyId
    },
    errors: {
        400: 'At least one filter parameter is required',
        401: 'Unauthorized'
    }
}); };

/**
 * Create a new series or link to existing if provider identifiers match
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CreateOrLinkSeriesResponseDto Series created or linked successfully
 * @throws ApiError
 */
export const seriesControllerCreateOrLinkSeries = (data: SeriesControllerCreateOrLinkSeriesData): CancelablePromise<SeriesControllerCreateOrLinkSeriesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/series',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input',
        401: 'Unauthorized'
    }
}); };

/**
 * Get series by ID
 * @param data The data for the request.
 * @param data.id Series UUID
 * @returns SeriesResponseDto Series found
 * @throws ApiError
 */
export const seriesControllerGetSeriesById = (data: SeriesControllerGetSeriesByIdData): CancelablePromise<SeriesControllerGetSeriesByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/series/{id}',
    path: {
        id: data.id
    },
    errors: {
        401: 'Unauthorized',
        404: 'Series not found'
    }
}); };

/**
 * Update series
 * @param data The data for the request.
 * @param data.id Series UUID
 * @param data.requestBody
 * @returns SeriesResponseDto Series updated successfully
 * @throws ApiError
 */
export const seriesControllerUpdateSeries = (data: SeriesControllerUpdateSeriesData): CancelablePromise<SeriesControllerUpdateSeriesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v2/series/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input',
        401: 'Unauthorized',
        404: 'Series not found'
    }
}); };

/**
 * Delete series
 * @param data The data for the request.
 * @param data.id Series UUID
 * @returns void Series deleted successfully
 * @throws ApiError
 */
export const seriesControllerDeleteSeries = (data: SeriesControllerDeleteSeriesData): CancelablePromise<SeriesControllerDeleteSeriesResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/series/{id}',
    path: {
        id: data.id
    },
    errors: {
        401: 'Unauthorized',
        404: 'Series not found'
    }
}); };

/**
 * Link meters to series
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Meters linked to series successfully
 * @throws ApiError
 */
export const meterSeriesControllerLinkMetersToSeries = (data: MeterSeriesControllerLinkMetersToSeriesData): CancelablePromise<MeterSeriesControllerLinkMetersToSeriesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/meter-series',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'DeviceId mismatch',
        401: 'Unauthorized',
        404: 'Meter or series not found'
    }
}); };

/**
 * Unlink meters from series
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void Meters unlinked from series successfully
 * @throws ApiError
 */
export const meterSeriesControllerUnlinkMetersFromSeries = (data: MeterSeriesControllerUnlinkMetersFromSeriesData): CancelablePromise<MeterSeriesControllerUnlinkMetersFromSeriesResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/meter-series',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        401: 'Unauthorized'
    }
}); };

/**
 * Batch update display titles for meter-series links
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void Titles updated successfully
 * @throws ApiError
 */
export const meterSeriesControllerBatchUpdateMeterSeriesTitles = (data: MeterSeriesControllerBatchUpdateMeterSeriesTitlesData): CancelablePromise<MeterSeriesControllerBatchUpdateMeterSeriesTitlesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/meter-series/titles',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        401: 'Unauthorized',
        404: 'Meter-series link not found'
    }
}); };

/**
 * Get all series linked to a meter
 * Returns all series linked to a meter. Access is resolved from the meter itself: non-admin users must be assigned to the location the meter belongs to.
 * @param data The data for the request.
 * @param data.meterId Meter ID
 * @returns SeriesResponseDto Series list retrieved
 * @throws ApiError
 */
export const meterSeriesControllerGetSeriesForMeter = (data: MeterSeriesControllerGetSeriesForMeterData): CancelablePromise<MeterSeriesControllerGetSeriesForMeterResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/meter-series/meter/{meterId}',
    path: {
        meterId: data.meterId
    },
    errors: {
        401: 'Unauthorized',
        403: 'Meter belongs to a location the caller is not assigned to',
        404: 'Meter not found'
    }
}); };

/**
 * Get all meters linked to a series (with company/location/building context)
 * @param data The data for the request.
 * @param data.seriesId Series UUID
 * @returns MeterInfoDto Meters list retrieved
 * @throws ApiError
 */
export const meterSeriesControllerGetMetersForSeries = (data: MeterSeriesControllerGetMetersForSeriesData): CancelablePromise<MeterSeriesControllerGetMetersForSeriesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/meter-series/series/{seriesId}',
    path: {
        seriesId: data.seriesId
    },
    errors: {
        401: 'Unauthorized'
    }
}); };

/**
 * Get all series for a device with link status for a specific meter
 * Returns all series linked to any meter with the same deviceId, with a flag indicating if each series is linked to the specified meter
 * @param data The data for the request.
 * @param data.deviceId Device ID
 * @param data.meterId Meter ID to check link status against
 * @returns unknown Series list with link status retrieved
 * @throws ApiError
 */
export const meterSeriesControllerGetAllSeriesForDeviceWithLinkStatus = (data: MeterSeriesControllerGetAllSeriesForDeviceWithLinkStatusData): CancelablePromise<MeterSeriesControllerGetAllSeriesForDeviceWithLinkStatusResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/meter-series/device/{deviceId}/meter/{meterId}',
    path: {
        deviceId: data.deviceId,
        meterId: data.meterId
    },
    errors: {
        401: 'Unauthorized'
    }
}); };

/**
 * Get all meters for a device with link status for a specific series
 * Returns all meters with the same deviceId, with a flag indicating if each meter is linked to the specified series. Used for the visibility modal.
 * @param data The data for the request.
 * @param data.deviceId Device ID
 * @param data.seriesId Series UUID to check link status against
 * @returns unknown Meters list with link status retrieved
 * @throws ApiError
 */
export const meterSeriesControllerGetAllMetersForDeviceWithLinkStatus = (data: MeterSeriesControllerGetAllMetersForDeviceWithLinkStatusData): CancelablePromise<MeterSeriesControllerGetAllMetersForDeviceWithLinkStatusResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/meter-series/device/{deviceId}/series/{seriesId}/meters',
    path: {
        deviceId: data.deviceId,
        seriesId: data.seriesId
    },
    errors: {
        401: 'Unauthorized'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from Start time
 * @param data.to End time
 * @param data.from Start time
 * @param data.to End time
 * @param data.locationId Location ID (optional – one of locationId/buildingId required)
 * @param data.buildingId Building ID (optional – one of locationId/buildingId required)
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @param data.calculationMode Opt in to the canonical location energy-balance classification and formula.
 * @param data.locationId Location ID (optional – one of locationId/buildingId required)
 * @param data.buildingId Building ID (optional – one of locationId/buildingId required)
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @param data.calculationMode Opt in to the canonical location energy-balance classification and formula.
 * @returns SankeyGetResponseDto Sankey-Graph data of given building.
 * @throws ApiError
 */
export const sankeyControllerGetSankey = (data: SankeyControllerGetSankeyData): CancelablePromise<SankeyControllerGetSankeyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/sankey',
    query: {
        from: data.from,
        to: data.to,
        locationId: data.locationId,
        buildingId: data.buildingId,
        lang: data.lang,
        calculationMode: data.calculationMode
    },
    errors: {
        400: 'Cyclic tree detected in sankey data generation.'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from Start time
 * @param data.to End time
 * @param data.from Start time
 * @param data.to End time
 * @param data.requestBody
 * @param data.locationId Location ID (optional – one of locationId/buildingId required)
 * @param data.buildingId Building ID (optional – one of locationId/buildingId required)
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @param data.calculationMode Opt in to the canonical location energy-balance classification and formula.
 * @param data.locationId Location ID (optional – one of locationId/buildingId required)
 * @param data.buildingId Building ID (optional – one of locationId/buildingId required)
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @param data.calculationMode Opt in to the canonical location energy-balance classification and formula.
 * @returns unknown CSV export of sankey nodes for either location or building
 * @throws ApiError
 */
export const sankeyControllerGetSankeyCsv = (data: SankeyControllerGetSankeyCsvData): CancelablePromise<SankeyControllerGetSankeyCsvResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/sankey/csv',
    query: {
        from: data.from,
        to: data.to,
        locationId: data.locationId,
        buildingId: data.buildingId,
        lang: data.lang,
        calculationMode: data.calculationMode
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'CSV export not available or invalid parameters'
    }
}); };

/**
 * Get sankey diagram data for a meter view
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.from Start date for consumption data (ISO string)
 * @param data.to End date for consumption data (ISO string)
 * @param data.from Start date for consumption data (ISO string)
 * @param data.to End date for consumption data (ISO string)
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @returns SankeyGetResponseDto Sankey diagram data with nodes and links
 * @throws ApiError
 */
export const sankeyControllerGetMeterViewSankey = (data: SankeyControllerGetMeterViewSankeyData): CancelablePromise<SankeyControllerGetMeterViewSankeyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/sankey/meter-views/{id}',
    path: {
        id: data.id
    },
    query: {
        from: data.from,
        to: data.to,
        lang: data.lang
    },
    errors: {
        404: 'Meter view not found'
    }
}); };

/**
 * Export sankey diagram data as CSV for a meter view
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.from Start date for consumption data (ISO string)
 * @param data.to End date for consumption data (ISO string)
 * @param data.from Start date for consumption data (ISO string)
 * @param data.to End date for consumption data (ISO string)
 * @param data.requestBody
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @param data.lang Language for localized Sankey labels. Defaults to German.
 * @returns unknown CSV export of sankey nodes with consumption data
 * @throws ApiError
 */
export const sankeyControllerGetMeterViewSankeyCsv = (data: SankeyControllerGetMeterViewSankeyCsvData): CancelablePromise<SankeyControllerGetMeterViewSankeyCsvResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/sankey/meter-views/{id}/csv',
    path: {
        id: data.id
    },
    query: {
        from: data.from,
        to: data.to,
        lang: data.lang
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'Meter view not found'
    }
}); };

/**
 * Get all meter views for a company
 * @param data The data for the request.
 * @param data.companyId Filter by company ID
 * @param data.companyId Filter by company ID
 * @returns MeterViewListResponseDto List of meter views
 * @throws ApiError
 */
export const meterViewControllerFindAll = (data: MeterViewControllerFindAllData): CancelablePromise<MeterViewControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meter-views',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * Create a new meter view
 * @param data The data for the request.
 * @param data.requestBody Meter view creation data
 * @returns MeterViewDto Meter view created successfully
 * @throws ApiError
 */
export const meterViewControllerCreate = (data: MeterViewControllerCreateData): CancelablePromise<MeterViewControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/meter-views',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input data'
    }
}); };

/**
 * Get a meter view by ID with full hierarchy
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.from Start date for consumption data (ISO string)
 * @param data.to End date for consumption data (ISO string)
 * @param data.from Start date for consumption data (ISO string)
 * @param data.to End date for consumption data (ISO string)
 * @returns MeterViewDto Meter view with nodes
 * @throws ApiError
 */
export const meterViewControllerFindById = (data: MeterViewControllerFindByIdData): CancelablePromise<MeterViewControllerFindByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meter-views/{id}',
    path: {
        id: data.id
    },
    query: {
        from: data.from,
        to: data.to
    },
    errors: {
        404: 'Meter view not found'
    }
}); };

/**
 * Update a meter view
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.requestBody Meter view update data
 * @returns MeterViewDto Meter view updated successfully
 * @throws ApiError
 */
export const meterViewControllerUpdate = (data: MeterViewControllerUpdateData): CancelablePromise<MeterViewControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/meter-views/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'Meter view not found'
    }
}); };

/**
 * Delete a meter view
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @returns void Meter view deleted successfully
 * @throws ApiError
 */
export const meterViewControllerDelete = (data: MeterViewControllerDeleteData): CancelablePromise<MeterViewControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/meter-views/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Meter view not found'
    }
}); };

/**
 * Add a new node to a meter view
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.requestBody Node creation data
 * @returns ViewNodeDto Node created successfully
 * @throws ApiError
 */
export const meterViewControllerCreateNode = (data: MeterViewControllerCreateNodeData): CancelablePromise<MeterViewControllerCreateNodeResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/meter-views/{id}/nodes',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input data',
        404: 'Meter view not found'
    }
}); };

/**
 * Delete a node
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.nodeId Node ID
 * @returns void Node deleted successfully
 * @throws ApiError
 */
export const meterViewControllerDeleteNode = (data: MeterViewControllerDeleteNodeData): CancelablePromise<MeterViewControllerDeleteNodeResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/meter-views/{id}/nodes/{nodeId}',
    path: {
        id: data.id,
        nodeId: data.nodeId
    },
    errors: {
        400: 'Cannot delete node with children',
        404: 'Node not found'
    }
}); };

/**
 * Update folder name
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.nodeId Folder node ID
 * @param data.requestBody Folder name update
 * @returns unknown
 * @returns void Folder name updated successfully
 * @throws ApiError
 */
export const meterViewControllerUpdateFolderName = (data: MeterViewControllerUpdateFolderNameData): CancelablePromise<MeterViewControllerUpdateFolderNameResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/meter-views/{id}/nodes/{nodeId}/folder-name',
    path: {
        id: data.id,
        nodeId: data.nodeId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input data or node is not a folder',
        404: 'Folder node not found'
    }
}); };

/**
 * Update node parent ID
 * @param data The data for the request.
 * @param data.id Meter view ID
 * @param data.nodeId Node ID
 * @param data.requestBody Parent node update
 * @returns void Node parent updated successfully
 * @throws ApiError
 */
export const meterViewControllerUpdateNodeParent = (data: MeterViewControllerUpdateNodeParentData): CancelablePromise<MeterViewControllerUpdateNodeParentResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/meter-views/{id}/nodes/{nodeId}/parent',
    path: {
        id: data.id,
        nodeId: data.nodeId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input data or circular reference',
        404: 'Node not found'
    }
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const invoicesControllerBatchCreatePastInvoices = (): CancelablePromise<InvoicesControllerBatchCreatePastInvoicesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/create-past-invoices'
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const invoicesControllerBatchCreateScheduledInvoices = (): CancelablePromise<InvoicesControllerBatchCreateScheduledInvoicesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/create-scheduled-invoices'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Re-generates invoices for given year/month for locations or companies.
 * @throws ApiError
 */
export const invoicesControllerRecreateYearInvoicesForCompany = (data: InvoicesControllerRecreateYearInvoicesForCompanyData): CancelablePromise<InvoicesControllerRecreateYearInvoicesForCompanyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/invoices/recreate',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @param data.buildingId Filter by building ID
 * @param data.page Page number (1-based)
 * @param data.pageSize Items per page
 * @returns InvoicePageableResponseListDto Get invoices for given company.
 * @throws ApiError
 */
export const invoicesControllerGetInvoices = (data: InvoicesControllerGetInvoicesData): CancelablePromise<InvoicesControllerGetInvoicesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/procurement/invoices',
    query: {
        page: data.page,
        pageSize: data.pageSize,
        locationId: data.locationId,
        companyId: data.companyId,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @param data.buildingId Filter by building ID
 * @param data.page Page number (1-based)
 * @param data.pageSize Items per page
 * @returns InvoicePageableResponseListDto Get invoices for given company, with cost details calculated by procurement.
 * @throws ApiError
 */
export const invoicesControllerGetProcurementInvoices = (data: InvoicesControllerGetProcurementInvoicesData): CancelablePromise<InvoicesControllerGetProcurementInvoicesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/procurement/invoices',
    query: {
        page: data.page,
        pageSize: data.pageSize,
        locationId: data.locationId,
        companyId: data.companyId,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @param data.requestBody
 * @returns InvoiceResponseDto Updates status of an invoice
 * @throws ApiError
 */
export const invoicesControllerUpdateStatus = (data: InvoicesControllerUpdateStatusData): CancelablePromise<InvoicesControllerUpdateStatusResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/procurement/invoices/{invoiceId}/status',
    path: {
        invoiceId: data.invoiceId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @param data.requestBody
 * @returns InvoiceResponseDto Updates cost details of an invoice
 * @throws ApiError
 */
export const invoicesControllerUpdateCostDetails = (data: InvoicesControllerUpdateCostDetailsData): CancelablePromise<InvoicesControllerUpdateCostDetailsResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/procurement/invoices/{invoiceId}/cost-details',
    path: {
        invoiceId: data.invoiceId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @param data.requestBody
 * @returns InvoiceResponseDto Updates ocr cost details of an invoice. Accepts a body with the cost details or an empty body to execute OCR.
 * @throws ApiError
 */
export const invoicesControllerUpdateOcrCostDetails = (data: InvoicesControllerUpdateOcrCostDetailsData): CancelablePromise<InvoicesControllerUpdateOcrCostDetailsResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/procurement/invoices/{invoiceId}/ocr-cost-details',
    path: {
        invoiceId: data.invoiceId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @param data.requestBody
 * @returns InvoiceResponseDto Updates ocr cost verifications of an invoice
 * @throws ApiError
 */
export const invoicesControllerUpdateOcrCostVerification = (data: InvoicesControllerUpdateOcrCostVerificationData): CancelablePromise<InvoicesControllerUpdateOcrCostVerificationResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/procurement/invoices/{invoiceId}/cost-verification',
    path: {
        invoiceId: data.invoiceId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @param data.requestBody
 * @returns InvoiceResponseDto Updates notes of an invoice
 * @throws ApiError
 */
export const invoicesControllerUpdateNotes = (data: InvoicesControllerUpdateNotesData): CancelablePromise<InvoicesControllerUpdateNotesResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/procurement/invoices/{invoiceId}/notes',
    path: {
        invoiceId: data.invoiceId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @param data.id
 * @returns InvoiceResponseDto
 * @returns void Invoice file uploaded
 * @throws ApiError
 */
export const invoicesControllerUploadExternalInvoice = (data: InvoicesControllerUploadExternalInvoiceData): CancelablePromise<InvoicesControllerUploadExternalInvoiceResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/invoices/{invoiceId}/invoice',
    path: {
        invoiceId: data.invoiceId,
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @returns void External Invoice deleted
 * @throws ApiError
 */
export const invoicesControllerDeleteInvoiceFile = (data: InvoicesControllerDeleteInvoiceFileData): CancelablePromise<InvoicesControllerDeleteInvoiceFileResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/procurement/invoices/{invoiceId}/invoice',
    path: {
        invoiceId: data.invoiceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId
 * @returns InvoiceResponseDto
 * @returns void Invoice file uploaded
 * @throws ApiError
 */
export const invoicesControllerUploadInvoiceToMeter = (data: InvoicesControllerUploadInvoiceToMeterData): CancelablePromise<InvoicesControllerUploadInvoiceToMeterResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/invoices/meters/{deviceId}',
    path: {
        deviceId: data.deviceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @param data.id
 * @returns InvoiceResponseDto
 * @returns void Invoice file uploaded without ocr checking. this endpoint exist as long as ocr invoice checking has not been enabled for all customers
 * @throws ApiError
 */
export const invoicesControllerUploadExternalInvoiceLegacy = (data: InvoicesControllerUploadExternalInvoiceLegacyData): CancelablePromise<InvoicesControllerUploadExternalInvoiceLegacyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/invoices/{invoiceId}/invoice-legacy',
    path: {
        invoiceId: data.invoiceId,
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @returns void Invoice deleted
 * @throws ApiError
 */
export const invoicesControllerDeleteInvoice = (data: InvoicesControllerDeleteInvoiceData): CancelablePromise<InvoicesControllerDeleteInvoiceResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/procurement/invoices/{invoiceId}',
    path: {
        invoiceId: data.invoiceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @returns InvoiceResponseDto Get invoice by ID
 * @throws ApiError
 */
export const invoicesControllerGetInvoiceById = (data: InvoicesControllerGetInvoiceByIdData): CancelablePromise<InvoicesControllerGetInvoiceByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/procurement/invoices/{invoiceId}',
    path: {
        invoiceId: data.invoiceId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.invoiceId
 * @returns InvoiceResponseDto Get invoice by ID, with cost details calculated by procurement.
 * @throws ApiError
 */
export const invoicesControllerGetProcurementInvoiceById = (data: InvoicesControllerGetProcurementInvoiceByIdData): CancelablePromise<InvoicesControllerGetProcurementInvoiceByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/procurement/invoices/{invoiceId}',
    path: {
        invoiceId: data.invoiceId
    }
}); };

/**
 * Find manual invoice positions by location and period
 * @param data The data for the request.
 * @param data.locationId Location ID
 * @param data.year Year
 * @param data.month Month
 * @returns ManualInvoicePositionDto List of manual invoice positions
 * @throws ApiError
 */
export const manualInvoicePositionsControllerFindByLocationAndPeriod = (data: ManualInvoicePositionsControllerFindByLocationAndPeriodData): CancelablePromise<ManualInvoicePositionsControllerFindByLocationAndPeriodResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/procurement/manual-invoice-positions',
    query: {
        locationId: data.locationId,
        year: data.year,
        month: data.month
    }
}); };

/**
 * Create a new manual invoice position
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ManualInvoicePositionDto Manual invoice position created successfully
 * @throws ApiError
 */
export const manualInvoicePositionsControllerCreate = (data: ManualInvoicePositionsControllerCreateData): CancelablePromise<ManualInvoicePositionsControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/procurement/manual-invoice-positions',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden'
    }
}); };

/**
 * Update an existing manual invoice position
 * @param data The data for the request.
 * @param data.id Manual invoice position ID
 * @param data.requestBody
 * @returns ManualInvoicePositionDto Manual invoice position updated successfully
 * @throws ApiError
 */
export const manualInvoicePositionsControllerUpdate = (data: ManualInvoicePositionsControllerUpdateData): CancelablePromise<ManualInvoicePositionsControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/procurement/manual-invoice-positions/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Manual invoice position not found'
    }
}); };

/**
 * Delete a manual invoice position
 * @param data The data for the request.
 * @param data.id Manual invoice position ID
 * @returns void Manual invoice position deleted successfully
 * @throws ApiError
 */
export const manualInvoicePositionsControllerDelete = (data: ManualInvoicePositionsControllerDeleteData): CancelablePromise<ManualInvoicePositionsControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/procurement/manual-invoice-positions/{id}',
    path: {
        id: data.id
    },
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Manual invoice position not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.deviceId Device id
 * @param data.startDate Start date (ISO 8601 string)
 * @param data.endDate End date (ISO 8601 string)
 * @returns InsightsResponseDto Insights for a given device
 * @throws ApiError
 */
export const insightsControllerGetInsights = (data: InsightsControllerGetInsightsData): CancelablePromise<InsightsControllerGetInsightsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/functions/insights',
    query: {
        deviceId: data.deviceId,
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const dataIngesterControllerSendDataFetchCommand = (data: DataIngesterControllerSendDataFetchCommandData): CancelablePromise<DataIngesterControllerSendDataFetchCommandResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/platform/data-ingester/consumption',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.code
 * @param data.companyId
 * @returns unknown
 * @throws ApiError
 */
export const smaControllerUpdateToken = (data: SmaControllerUpdateTokenData): CancelablePromise<SmaControllerUpdateTokenResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/sma/token',
    query: {
        code: data.code,
        companyId: data.companyId
    }
}); };

/**
 * Fetch regulated network costs from ENET for a location and supply period
 * @param data The data for the request.
 * @param data.locationId Location to fetch network costs for
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @param data.energyType
 * @param data.voltageLevel Grid voltage level. Required for electricity (ENET mandates it); ignored for gas.
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetNetworkCosts = (data: EnetControllerGetNetworkCostsData): CancelablePromise<EnetControllerGetNetworkCostsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/network-costs',
    query: {
        locationId: data.locationId,
        from: data.from,
        to: data.to,
        energyType: data.energyType,
        voltageLevel: data.voltageLevel
    }
}); };

/**
 * Fetch the ENET concession fee (Konzessionsabgabe) per customer group for a location and supply period
 * @param data The data for the request.
 * @param data.locationId Location to fetch the concession fee for
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @param data.energyType Energy type. Electricity returns two customer groups; gas returns three.
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetConcessionFee = (data: EnetControllerGetConcessionFeeData): CancelablePromise<EnetControllerGetConcessionFeeResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/concession-fee',
    query: {
        locationId: data.locationId,
        from: data.from,
        to: data.to,
        energyType: data.energyType
    }
}); };

/**
 * Fetch the ENET §19 StromNEV special grid usage surcharge for a location and supply period
 * @param data The data for the request.
 * @param data.locationId Location to fetch the special grid usage surcharge for
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetSpecialGridUsage = (data: EnetControllerGetSpecialGridUsageData): CancelablePromise<EnetControllerGetSpecialGridUsageResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/special-grid-usage',
    query: {
        locationId: data.locationId,
        from: data.from,
        to: data.to
    }
}); };

/**
 * Fetch the ENET energy tax (Stromsteuer / Energiesteuer) for a supply period
 * @param data The data for the request.
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @param data.energyType Energy type. Electricity returns Stromsteuer; gas returns Energiesteuer.
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetEnergyTax = (data: EnetControllerGetEnergyTaxData): CancelablePromise<EnetControllerGetEnergyTaxResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/energy-tax',
    query: {
        from: data.from,
        to: data.to,
        energyType: data.energyType
    }
}); };

/**
 * Fetch the ENET gas RLM metering fees (meter operation, reading service, remote readout, volume converter, data logger) for a location and supply period
 * @param data The data for the request.
 * @param data.locationId Location to fetch gas RLM metering fees for
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @param data.pressureLevel Gas pressure level (messebene). Required together with meterSize and meterKind.
 * @param data.meterSize Meter size (zaehler.geraetemerkmal). Required together with pressureLevel and meterKind.
 * @param data.meterKind Meter kind (zaehler.geraetetyp). Required together with pressureLevel and meterSize.
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetGasRlmMetering = (data: EnetControllerGetGasRlmMeteringData): CancelablePromise<EnetControllerGetGasRlmMeteringResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/gas-rlm-metering',
    query: {
        locationId: data.locationId,
        from: data.from,
        to: data.to,
        pressureLevel: data.pressureLevel,
        meterSize: data.meterSize,
        meterKind: data.meterKind
    }
}); };

/**
 * Fetch the ENET KWKG (KWK) and Offshore levies for a supply period
 * @param data The data for the request.
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetElectricityLevies = (data: EnetControllerGetElectricityLeviesData): CancelablePromise<EnetControllerGetElectricityLeviesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/electricity-levies',
    query: {
        from: data.from,
        to: data.to
    }
}); };

/**
 * Fetch the ENET gas market-area levies (RLM balancing, conversion, storage) for a supply period
 * @param data The data for the request.
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetGasLevies = (data: EnetControllerGetGasLeviesData): CancelablePromise<EnetControllerGetGasLeviesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/gas-levies',
    query: {
        from: data.from,
        to: data.to
    }
}); };

/**
 * Fetch the ENET gas RLM grid energy-price zones (kWh from, to, marginal price, sheet validity, and whether the sheet is final or provisional) for a location, supply period and pressure level
 * @param data The data for the request.
 * @param data.locationId Location to fetch gas RLM energy zones for
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @param data.pressureLevel Gas pressure level (netzebene) that selects the network price sheet.
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetGasRlmEnergyZones = (data: EnetControllerGetGasRlmEnergyZonesData): CancelablePromise<EnetControllerGetGasRlmEnergyZonesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/gas-rlm-energy-zones',
    query: {
        locationId: data.locationId,
        from: data.from,
        to: data.to,
        pressureLevel: data.pressureLevel
    }
}); };

/**
 * Fetch the ENET gas RLM grid demand-price zones (peak kW from, to, marginal price, sheet validity, and whether the sheet is final or provisional) for a location, supply period and pressure level
 * @param data The data for the request.
 * @param data.locationId Location to fetch gas RLM peak zones for
 * @param data.from Supply period start (YYYY-MM-DD)
 * @param data.to Supply period end (YYYY-MM-DD)
 * @param data.pressureLevel Gas pressure level (netzebene) that selects the network price sheet.
 * @returns unknown
 * @throws ApiError
 */
export const enetControllerGetGasRlmPeakZones = (data: EnetControllerGetGasRlmPeakZonesData): CancelablePromise<EnetControllerGetGasRlmPeakZonesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/integrations/enet/gas-rlm-peak-zones',
    query: {
        locationId: data.locationId,
        from: data.from,
        to: data.to,
        pressureLevel: data.pressureLevel
    }
}); };

/**
 * @returns unknown
 * @throws ApiError
 */
export const logsControllerFindGapLogsByTimestamp = (): CancelablePromise<LogsControllerFindGapLogsByTimestampResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/logs/data-gaps'
}); };

/**
 * @param data The data for the request.
 * @param data.apiProviderTitle
 * @param data.date
 * @returns unknown
 * @throws ApiError
 */
export const logsControllerFindIngestionLogs = (data: LogsControllerFindIngestionLogsData): CancelablePromise<LogsControllerFindIngestionLogsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/logs/ingestion',
    query: {
        apiProviderTitle: data.apiProviderTitle,
        date: data.date
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @param data.companyId
 * @param data.reportType
 * @returns unknown[] Get list of recipients for a given report.
 * @throws ApiError
 */
export const reportsControllerGetReportRecipients = (data: ReportsControllerGetReportRecipientsData): CancelablePromise<ReportsControllerGetReportRecipientsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/reports/recipients',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        reportType: data.reportType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns MultivariateLinearRegressionResponse Successful creation of Regression
 * @throws ApiError
 */
export const multivariateLinearRegressionControllerCreateRegression = (data: MultivariateLinearRegressionControllerCreateRegressionData): CancelablePromise<MultivariateLinearRegressionControllerCreateRegressionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/analytics/multivariate-linear-regression',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.page Page number (1-based)
 * @param data.pageSize Items per page
 * @param data.companyId Company ID to filter regressions. Required if locationId is not provided.
 * @param data.locationId Location ID to filter regressions. Required if companyId is not provided.
 * @param data.dateRange
 * @param data.sortBy Field to sort regressions by. Default is "createdAt".
 * @param data.sortOrder Sort order for regressions. Default is "DESC". Case-insensitive.
 * @returns MultivariateLinearRegressionPageableResponseList Get all MultivariateLinearRegressions
 * @throws ApiError
 */
export const multivariateLinearRegressionControllerGetAllRegressions = (data: MultivariateLinearRegressionControllerGetAllRegressionsData): CancelablePromise<MultivariateLinearRegressionControllerGetAllRegressionsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/analytics/multivariate-linear-regression',
    query: {
        page: data.page,
        pageSize: data.pageSize,
        companyId: data.companyId,
        locationId: data.locationId,
        dateRange: data.dateRange,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder
    },
    errors: {
        401: 'Unauthorized access'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns MultivariateLinearRegressionResponse Successfully updated Regression
 * @throws ApiError
 */
export const multivariateLinearRegressionControllerUpdateRegression = (data: MultivariateLinearRegressionControllerUpdateRegressionData): CancelablePromise<MultivariateLinearRegressionControllerUpdateRegressionResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v2/analytics/multivariate-linear-regression/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns MultivariateLinearRegressionResponse Successfully retrieved regression by ID
 * @throws ApiError
 */
export const multivariateLinearRegressionControllerGetRegressionById = (data: MultivariateLinearRegressionControllerGetRegressionByIdData): CancelablePromise<MultivariateLinearRegressionControllerGetRegressionByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/analytics/multivariate-linear-regression/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successfully deleted Regression
 * @returns void
 * @throws ApiError
 */
export const multivariateLinearRegressionControllerDeleteRegression = (data: MultivariateLinearRegressionControllerDeleteRegressionData): CancelablePromise<MultivariateLinearRegressionControllerDeleteRegressionResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/analytics/multivariate-linear-regression/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.from Start of the range (ISO date string)
 * @param data.to End of the range (ISO date string)
 * @returns ActualVsModelSeriesResponse Measured dependent series and the output of the regression model within the given range
 * @throws ApiError
 */
export const multivariateLinearRegressionControllerGetActualVsModelSeries = (data: MultivariateLinearRegressionControllerGetActualVsModelSeriesData): CancelablePromise<MultivariateLinearRegressionControllerGetActualVsModelSeriesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/analytics/multivariate-linear-regression/{id}/actual-vs-model-series',
    path: {
        id: data.id
    },
    query: {
        from: data.from,
        to: data.to
    }
}); };

/**
 * List baselines
 * @param data The data for the request.
 * @param data.companyId At least one of companyId or locationId is required
 * @param data.locationId At least one of companyId or locationId is required
 * @param data.page
 * @param data.limit
 * @param data.sortBy
 * @param data.sortOrder
 * @param data.filtersDateRange1
 * @param data.filtersDateRange0
 * @returns unknown
 * @throws ApiError
 */
export const baselineControllerFindAll = (data: BaselineControllerFindAllData = {}): CancelablePromise<BaselineControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/analytics/baseline',
    query: {
        companyId: data.companyId,
        locationId: data.locationId,
        page: data.page,
        limit: data.limit,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder,
        'filters[dateRange][1]': data.filtersDateRange1,
        'filters[dateRange][0]': data.filtersDateRange0
    }
}); };

/**
 * Create a baseline definition
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Baseline created
 * @throws ApiError
 */
export const baselineControllerCreate = (data: BaselineControllerCreateData): CancelablePromise<BaselineControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/analytics/baseline',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Run baseline analysis and return results
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Baseline analysis result
 * @throws ApiError
 */
export const baselineControllerGetAnalysis = (data: BaselineControllerGetAnalysisData): CancelablePromise<BaselineControllerGetAnalysisResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/analytics/baseline/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * Update a baseline definition
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown Baseline updated
 * @throws ApiError
 */
export const baselineControllerUpdate = (data: BaselineControllerUpdateData): CancelablePromise<BaselineControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/analytics/baseline/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Delete a baseline definition
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const baselineControllerDelete = (data: BaselineControllerDeleteData): CancelablePromise<BaselineControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/analytics/baseline/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * Fetch all feature news
 * @param data The data for the request.
 * @param data.page Page number (1-based)
 * @param data.pageSize Items per page
 * @returns FeatureNewsDTO Successfully fetched feature news
 * @throws ApiError
 */
export const featureNewsControllerGetFeatureNews = (data: FeatureNewsControllerGetFeatureNewsData): CancelablePromise<FeatureNewsControllerGetFeatureNewsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/feature-news',
    query: {
        page: data.page,
        pageSize: data.pageSize
    },
    errors: {
        500: 'Internal server error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @param data.buildingId Filter by building ID
 * @returns BudgetSummaryDto Get Budget for company or location
 * @throws ApiError
 */
export const budgetControllerGetInvoices = (data: BudgetControllerGetInvoicesData = {}): CancelablePromise<BudgetControllerGetInvoicesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v3/budget/budget',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @param data.buildingId Filter by building ID
 * @returns BudgetSummaryDto Get Budget for company or location. Open invoices use procurement costs when that calculation succeeds.
 * @throws ApiError
 */
export const budgetControllerGetInvoicesWithProcurementCosts = (data: BudgetControllerGetInvoicesWithProcurementCostsData = {}): CancelablePromise<BudgetControllerGetInvoicesWithProcurementCostsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v4/budget/budget',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.formData
 * @returns UploadConsumptionFilesDto Upload consumption files successfully
 * @returns unknown
 * @throws ApiError
 */
export const uploadControllerUploadConsumptionFiles = (data: UploadControllerUploadConsumptionFilesData): CancelablePromise<UploadControllerUploadConsumptionFilesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/upload/consumption',
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @returns UploadDemoDevicesResponseDto Upload demo devices data successfully
 * @throws ApiError
 */
export const uploadControllerUploadDemoDevices = (): CancelablePromise<UploadControllerUploadDemoDevicesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/upload/consumption/demo-devices'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.formData
 * @returns unknown
 * @throws ApiError
 */
export const uploadControllerUploadSlpManualConsumption = (data: UploadControllerUploadSlpManualConsumptionData): CancelablePromise<UploadControllerUploadSlpManualConsumptionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/upload/consumption/slp-manual/{companyId}',
    path: {
        companyId: data.companyId
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.month
 * @returns unknown
 * @throws ApiError
 */
export const manualMeterUploadControllerTemplate = (data: ManualMeterUploadControllerTemplateData): CancelablePromise<ManualMeterUploadControllerTemplateResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/upload/manual-meters/{companyId}/template',
    path: {
        companyId: data.companyId
    },
    query: {
        month: data.month
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns unknown
 * @throws ApiError
 */
export const manualMeterUploadControllerPreview = (data: ManualMeterUploadControllerPreviewData): CancelablePromise<ManualMeterUploadControllerPreviewResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/upload/manual-meters/{companyId}/preview',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns unknown
 * @throws ApiError
 */
export const manualMeterUploadControllerApply = (data: ManualMeterUploadControllerApplyData): CancelablePromise<ManualMeterUploadControllerApplyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/upload/manual-meters/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.page
 * @param data.search
 * @param data.sortBy
 * @param data.sortOrder
 * @returns unknown
 * @throws ApiError
 */
export const manualMeterUploadControllerHistory = (data: ManualMeterUploadControllerHistoryData): CancelablePromise<ManualMeterUploadControllerHistoryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/upload/manual-meters/{companyId}/history',
    path: {
        companyId: data.companyId
    },
    query: {
        page: data.page,
        search: data.search,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const manualMeterUploadControllerDetail = (data: ManualMeterUploadControllerDetailData): CancelablePromise<ManualMeterUploadControllerDetailResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/upload/manual-meters/{companyId}/history/{id}',
    path: {
        companyId: data.companyId,
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const manualMeterUploadControllerOriginalFile = (data: ManualMeterUploadControllerOriginalFileData): CancelablePromise<ManualMeterUploadControllerOriginalFileResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/upload/manual-meters/{companyId}/history/{id}/file',
    path: {
        companyId: data.companyId,
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const manualMeterUploadControllerRetry = (data: ManualMeterUploadControllerRetryData): CancelablePromise<ManualMeterUploadControllerRetryResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/upload/manual-meters/{companyId}/history/{id}/retry',
    path: {
        companyId: data.companyId,
        id: data.id
    }
}); };

/**
 * Get health information for devices.
 * @param data The data for the request.
 * @param data.requestBody Parameters for device healthcheck
 * @returns DeviceHealthCheckResultDto Successfully run health check on devices
 * @returns unknown
 * @throws ApiError
 */
export const normalizerControllerCheckDevicesHealth = (data: NormalizerControllerCheckDevicesHealthData): CancelablePromise<NormalizerControllerCheckDevicesHealthResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/normalizer/devices-health-check',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Normalize and persist consumption data
 * Normalizes consumption data to 15-minute intervals and persists it to the database
 * @param data The data for the request.
 * @param data.requestBody Normalization parameters including devices and time periods
 * @returns unknown Data successfully normalized and persisted
 * @throws ApiError
 */
export const normalizerControllerNormalize = (data: NormalizerControllerNormalizeData): CancelablePromise<NormalizerControllerNormalizeResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/normalizer',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad request - invalid input parameters or unsupported series',
        404: 'Device not found',
        500: 'Internal server error'
    }
}); };

/**
 * Test endpoint for updating virtual series
 * Triggers virtual series calculation and persistence for testing purposes
 * @param data The data for the request.
 * @param data.requestBody Parameters for virtual series update
 * @returns unknown Virtual series successfully calculated and persisted
 * @throws ApiError
 */
export const normalizerControllerUpdateVirtualsAfterDataNormalization = (data: NormalizerControllerUpdateVirtualsAfterDataNormalizationData): CancelablePromise<NormalizerControllerUpdateVirtualsAfterDataNormalizationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/normalizer/virtual-series',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad request - invalid input parameters',
        500: 'Internal server error'
    }
}); };

/**
 * Setup virtual meters for database persistence
 * Performs all necessary database operations to setup virtual meters for persistence including validation, metadata updates, aggregation, and SLP data migration
 * @param data The data for the request.
 * @param data.requestBody Setup configuration with flags to control which operations to perform
 * @returns unknown Virtual meters setup completed successfully
 * @throws ApiError
 */
export const normalizerControllerSetupVirtualMeters = (data: NormalizerControllerSetupVirtualMetersData): CancelablePromise<NormalizerControllerSetupVirtualMetersResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/normalizer/setup-virtuals',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad request - invalid input parameters',
        500: 'Internal server error'
    }
}); };

/**
 * Persist normalized data submitted via file upload
 * Performs all necessary database operations to persist manually normalized data
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const normalizerControllerHandleManualNormalizedData = (data: NormalizerControllerHandleManualNormalizedDataData): CancelablePromise<NormalizerControllerHandleManualNormalizedDataResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/normalizer/manual-consumption',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get the scope-aware hierarchical meter overview
 * @param data The data for the request.
 * @param data.companyId
 * @param data.from
 * @param data.to
 * @param data.regionId
 * @param data.locationId
 * @param data.buildingId
 * @returns MeterOverviewResponseDto
 * @throws ApiError
 */
export const meterOverviewControllerGetOverview = (data: MeterOverviewControllerGetOverviewData): CancelablePromise<MeterOverviewControllerGetOverviewResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meter-overview',
    query: {
        companyId: data.companyId,
        regionId: data.regionId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        from: data.from,
        to: data.to
    }
}); };

/**
 * Get the canonical 15-minute electricity balance for an Atlas location diagram
 * @param data The data for the request.
 * @param data.locationId
 * @param data.from
 * @param data.to
 * @param data.buildingId
 * @returns MeterOverviewElectricityBalanceResponseDto
 * @throws ApiError
 */
export const meterOverviewControllerGetElectricityBalance = (data: MeterOverviewControllerGetElectricityBalanceData): CancelablePromise<MeterOverviewControllerGetElectricityBalanceResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meter-overview/electricity-balance',
    query: {
        locationId: data.locationId,
        buildingId: data.buildingId,
        from: data.from,
        to: data.to
    }
}); };

/**
 * Create a consumer group for a location and energy type
 * @param data The data for the request.
 * @param data.requestBody
 * @returns MeterOverviewGroupDto
 * @throws ApiError
 */
export const meterOverviewControllerCreateGroup = (data: MeterOverviewControllerCreateGroupData): CancelablePromise<MeterOverviewControllerCreateGroupResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/meter-overview/groups',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Rename a meter overview consumer group
 * @param data The data for the request.
 * @param data.groupId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const meterOverviewControllerRenameGroup = (data: MeterOverviewControllerRenameGroupData): CancelablePromise<MeterOverviewControllerRenameGroupResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/meter-overview/groups/{groupId}',
    path: {
        groupId: data.groupId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Delete a meter overview consumer group and ungroup its members
 * @param data The data for the request.
 * @param data.groupId
 * @param data.companyId
 * @param data.locationId
 * @param data.energyTypeId
 * @param data.measurementUnitId
 * @returns void
 * @throws ApiError
 */
export const meterOverviewControllerDeleteGroup = (data: MeterOverviewControllerDeleteGroupData): CancelablePromise<MeterOverviewControllerDeleteGroupResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/meter-overview/groups/{groupId}',
    path: {
        groupId: data.groupId
    },
    query: {
        companyId: data.companyId,
        locationId: data.locationId,
        energyTypeId: data.energyTypeId,
        measurementUnitId: data.measurementUnitId
    }
}); };

/**
 * Assign or unassign a consumer in the location-specific meter overview
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const meterOverviewControllerSetGroupMembership = (data: MeterOverviewControllerSetGroupMembershipData): CancelablePromise<MeterOverviewControllerSetGroupMembershipResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/meter-overview/group-membership',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Create a virtual device
 * Creates a new virtual meter device with specified configuration and formula
 * @param data The data for the request.
 * @param data.requestBody
 * @returns VirtualDeviceResponseDto Virtual device created successfully
 * @throws ApiError
 */
export const virtualMeterControllerCreateVirtualDevice = (data: VirtualMeterControllerCreateVirtualDeviceData): CancelablePromise<VirtualMeterControllerCreateVirtualDeviceResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/virtual-meter',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input data',
        500: 'Internal server error'
    }
}); };

/**
 * Delete a virtual device
 * Deletes an existing virtual meter device
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void Virtual device deleted successfully (no content returned)
 * @throws ApiError
 */
export const virtualMeterControllerDeleteVirtualDevice = (data: VirtualMeterControllerDeleteVirtualDeviceData): CancelablePromise<VirtualMeterControllerDeleteVirtualDeviceResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/virtual-meter',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input data',
        404: 'Virtual device not found',
        500: 'Internal server error'
    }
}); };

/**
 * Update a virtual device
 * Updates an existing virtual meter device with new configuration and formula
 * @param data The data for the request.
 * @param data.deviceId Device ID of the virtual meter to update
 * @param data.requestBody
 * @returns UpdateVirtualDeviceResponseDto Virtual device updated successfully
 * @throws ApiError
 */
export const virtualMeterControllerUpdateVirtualDevice = (data: VirtualMeterControllerUpdateVirtualDeviceData): CancelablePromise<VirtualMeterControllerUpdateVirtualDeviceResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/virtual-meter/{deviceId}',
    path: {
        deviceId: data.deviceId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid input data',
        404: 'Virtual device not found',
        500: 'Internal server error'
    }
}); };

/**
 * Location hierarchy, buildings, devices and regions for a company
 * @param data The data for the request.
 * @param data.companyId Company firebase id.
 * @param data.userId Accepted for backward compatibility with the legacy endpoint and deliberately ignored — the user is derived from the auth context. Trusting a client-supplied user id here would allow reading another user’s locations.
 * @returns unknown
 * @throws ApiError
 */
export const locationsInfoControllerGetLocationsInfo = (data: LocationsInfoControllerGetLocationsInfoData): CancelablePromise<LocationsInfoControllerGetLocationsInfoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/firebase/locations-info',
    query: {
        companyId: data.companyId,
        userId: data.userId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @param data.buildingId Building ID
 * @returns unknown
 * @throws ApiError
 */
export const deviceControllerGetDevicesByBuilding = (data: DeviceControllerGetDevicesByBuildingData): CancelablePromise<DeviceControllerGetDevicesByBuildingResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/companies/{companyId}/locations/{locationId}/buildings/{buildingId}/devices',
    path: {
        companyId: data.companyId,
        locationId: data.locationId,
        buildingId: data.buildingId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeviceListResponseDto
 * @throws ApiError
 */
export const deviceControllerUpsertDevice = (data: DeviceControllerUpsertDeviceData): CancelablePromise<DeviceControllerUpsertDeviceResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/companies/{companyId}/locations/{locationId}/buildings/{buildingId}/devices',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @param data.buildingId Building ID
 * @param data.deviceId Device ID
 * @returns unknown
 * @throws ApiError
 */
export const deviceControllerDeleteDevice = (data: DeviceControllerDeleteDeviceData): CancelablePromise<DeviceControllerDeleteDeviceResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/companies/{companyId}/locations/{locationId}/buildings/{buildingId}/devices/{deviceId}',
    path: {
        companyId: data.companyId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        deviceId: data.deviceId
    }
}); };

/**
 * Get all forecasts by company or location
 * @param data The data for the request.
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @returns ForecastResponseDto List of forecasts
 * @throws ApiError
 */
export const forecastControllerFindAll = (data: ForecastControllerFindAllData = {}): CancelablePromise<ForecastControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/forecasts',
    query: {
        locationId: data.locationId,
        companyId: data.companyId
    }
}); };

/**
 * Create new forecast
 * @param data The data for the request.
 * @param data.requestBody Create forecast data
 * @returns ForecastResponseDto Forecast created
 * @throws ApiError
 */
export const forecastControllerCreate = (data: ForecastControllerCreateData): CancelablePromise<ForecastControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/forecasts',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get specific forecast by ID
 * @param data The data for the request.
 * @param data.forecastId Forecast ID
 * @returns ForecastResponseDto Forecast details
 * @throws ApiError
 */
export const forecastControllerFindOneById = (data: ForecastControllerFindOneByIdData): CancelablePromise<ForecastControllerFindOneByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/forecasts/{forecastId}',
    path: {
        forecastId: data.forecastId
    }
}); };

/**
 * Get forecast data points
 * @param data The data for the request.
 * @param data.forecastId Forecast ID
 * @returns ForecastDataResponseDto Forecast data points with consumption values in 15-minute intervals
 * @throws ApiError
 */
export const forecastControllerGetForecastData = (data: ForecastControllerGetForecastDataData): CancelablePromise<ForecastControllerGetForecastDataResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/forecasts/{forecastId}/data',
    path: {
        forecastId: data.forecastId
    },
    errors: {
        400: 'Bad request - MODEL_GENERATED forecasts not supported'
    }
}); };

/**
 * Update forecast state
 * @param data The data for the request.
 * @param data.forecastId Forecast ID
 * @param data.requestBody Update forecast state
 * @returns ForecastResponseDto Forecast state updated
 * @throws ApiError
 */
export const forecastControllerPatchState = (data: ForecastControllerPatchStateData): CancelablePromise<ForecastControllerPatchStateResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/forecasts/{forecastId}/state',
    path: {
        forecastId: data.forecastId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Create new adjustment for forecast
 * @param data The data for the request.
 * @param data.forecastId Forecast ID
 * @param data.requestBody Create adjustment data
 * @returns AdjustmentResponseDto Adjustment created
 * @throws ApiError
 */
export const forecastControllerCreateAdjustment = (data: ForecastControllerCreateAdjustmentData): CancelablePromise<ForecastControllerCreateAdjustmentResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/forecasts/{forecastId}/adjustments',
    path: {
        forecastId: data.forecastId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Update adjustment
 * @param data The data for the request.
 * @param data.forecastId Forecast ID
 * @param data.adjustmentId Adjustment ID
 * @param data.requestBody Update adjustment data
 * @returns AdjustmentResponseDto Adjustment updated
 * @throws ApiError
 */
export const forecastControllerUpdateAdjustment = (data: ForecastControllerUpdateAdjustmentData): CancelablePromise<ForecastControllerUpdateAdjustmentResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/forecasts/{forecastId}/adjustments/{adjustmentId}',
    path: {
        forecastId: data.forecastId,
        adjustmentId: data.adjustmentId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Delete adjustment
 * @param data The data for the request.
 * @param data.forecastId Forecast ID
 * @param data.adjustmentId Adjustment ID
 * @returns void Adjustment deleted
 * @throws ApiError
 */
export const forecastControllerDeleteAdjustment = (data: ForecastControllerDeleteAdjustmentData): CancelablePromise<ForecastControllerDeleteAdjustmentResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/forecasts/{forecastId}/adjustments/{adjustmentId}',
    path: {
        forecastId: data.forecastId,
        adjustmentId: data.adjustmentId
    }
}); };

/**
 * Update adjustment active state
 * @param data The data for the request.
 * @param data.forecastId Forecast ID
 * @param data.adjustmentId Adjustment ID
 * @param data.requestBody Update adjustment active state
 * @returns AdjustmentResponseDto Adjustment active state updated
 * @throws ApiError
 */
export const forecastControllerPatchAdjustmentActive = (data: ForecastControllerPatchAdjustmentActiveData): CancelablePromise<ForecastControllerPatchAdjustmentActiveResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/forecasts/{forecastId}/adjustments/{adjustmentId}/active',
    path: {
        forecastId: data.forecastId,
        adjustmentId: data.adjustmentId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get short-term load forecast on company, location, building or device level
 * @param data The data for the request.
 * @param data.from Start datetime (minute precision)
 * @param data.to End datetime (minute precision)
 * @param data.granularity Forecast granularity in minutes (15 = quarter-hourly, 60 = hourly, 1440 = daily)
 * @param data.dataType Type of data to return (energy or power)
 * @param data.companyId Company ID
 * @param data.locationId Location ID
 * @param data.buildingId Building ID
 * @param data.deviceId Device ID
 * @returns ShortTermForecastResponseDto Forecast generated successfully
 * @throws ApiError
 */
export const shortTermForecastControllerGetShortTermForecast = (data: ShortTermForecastControllerGetShortTermForecastData): CancelablePromise<ShortTermForecastControllerGetShortTermForecastResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/short-term-forecasts',
    query: {
        from: data.from,
        to: data.to,
        granularity: data.granularity,
        dataType: data.dataType,
        companyId: data.companyId,
        locationId: data.locationId,
        buildingId: data.buildingId,
        deviceId: data.deviceId
    },
    errors: {
        400: 'Bad request - Invalid query parameters',
        401: 'Unauthorized - Access denied',
        500: 'Internal server error'
    }
}); };

/**
 * Get load adjustments
 * Retrieve load adjustments by company or location
 * @param data The data for the request.
 * @param data.year Filter by year
 * @param data.energyType
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @returns LoadAdjustmentListResponseDto Load adjustments retrieved successfully
 * @throws ApiError
 */
export const loadAdjustmentControllerFindAll = (data: LoadAdjustmentControllerFindAllData): CancelablePromise<LoadAdjustmentControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-planning/adjustments',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType
    }
}); };

/**
 * Create load adjustment
 * Create a new load adjustment
 * @param data The data for the request.
 * @param data.requestBody Load adjustment data
 * @returns LoadAdjustmentResponseDto Load adjustment created successfully
 * @throws ApiError
 */
export const loadAdjustmentControllerCreate = (data: LoadAdjustmentControllerCreateData): CancelablePromise<LoadAdjustmentControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/load-planning/adjustments',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get load adjustment by ID
 * Retrieve a specific load adjustment
 * @param data The data for the request.
 * @param data.id Load adjustment ID
 * @returns LoadAdjustmentResponseDto Load adjustment retrieved successfully
 * @throws ApiError
 */
export const loadAdjustmentControllerFindOne = (data: LoadAdjustmentControllerFindOneData): CancelablePromise<LoadAdjustmentControllerFindOneResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-planning/adjustments/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * Update load adjustment
 * Update an existing load adjustment
 * @param data The data for the request.
 * @param data.id Load adjustment ID
 * @param data.requestBody Updated load adjustment data
 * @returns LoadAdjustmentResponseDto Load adjustment updated successfully
 * @throws ApiError
 */
export const loadAdjustmentControllerUpdate = (data: LoadAdjustmentControllerUpdateData): CancelablePromise<LoadAdjustmentControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/load-planning/adjustments/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Delete load adjustment
 * Delete a load adjustment permanently
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const loadAdjustmentControllerDelete = (data: LoadAdjustmentControllerDeleteData): CancelablePromise<LoadAdjustmentControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/load-planning/adjustments/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * Activate load adjustment
 * Set a load adjustment as active
 * @param data The data for the request.
 * @param data.id Load adjustment ID
 * @returns LoadAdjustmentResponseDto Load adjustment activated successfully
 * @throws ApiError
 */
export const loadAdjustmentControllerActivate = (data: LoadAdjustmentControllerActivateData): CancelablePromise<LoadAdjustmentControllerActivateResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/load-planning/adjustments/{id}/activate',
    path: {
        id: data.id
    }
}); };

/**
 * Deactivate load adjustment
 * Set a load adjustment as inactive
 * @param data The data for the request.
 * @param data.id Load adjustment ID
 * @returns LoadAdjustmentResponseDto Load adjustment deactivated successfully
 * @throws ApiError
 */
export const loadAdjustmentControllerDeactivate = (data: LoadAdjustmentControllerDeactivateData): CancelablePromise<LoadAdjustmentControllerDeactivateResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/load-planning/adjustments/{id}/deactivate',
    path: {
        id: data.id
    }
}); };

/**
 * Get forecast for a specific location or company
 * @param data The data for the request.
 * @param data.energyType
 * @param data.year Filter by year
 * @param data.locationId Filter by location ID
 * @param data.companyId Filter by company ID
 * @param data.granularity
 * @returns LoadForecastDataDto Adjusted Forecast Generated
 * @throws ApiError
 */
export const loadPlanningForecastControllerGetForecast = (data: LoadPlanningForecastControllerGetForecastData): CancelablePromise<LoadPlanningForecastControllerGetForecastResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/load-planning/forecasts',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        energyType: data.energyType,
        year: data.year,
        granularity: data.granularity
    }
}); };

/**
 * Get all available NACE codes
 * @returns NaceCode List of NACE codes
 * @throws ApiError
 */
export const naceCodeControllerGetAllCodes = (): CancelablePromise<NaceCodeControllerGetAllCodesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/nace-codes'
}); };

/**
 * Get all machine categories
 * @returns MachineCategoryDto List of machine categories
 * @throws ApiError
 */
export const machineCategoryControllerGetAllCategories = (): CancelablePromise<MachineCategoryControllerGetAllCategoriesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/machine-categories'
}); };

/**
 * @param data The data for the request.
 * @param data.meterId The meter ID to filter documents
 * @returns MeterDocumentResponseDto Get all meter documents for a specific meter
 * @throws ApiError
 */
export const meterDocumentControllerGetMeterDocuments = (data: MeterDocumentControllerGetMeterDocumentsData): CancelablePromise<MeterDocumentControllerGetMeterDocumentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meter-documents',
    query: {
        meterId: data.meterId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns MeterDocumentResponseDto Create a new meter document
 * @throws ApiError
 */
export const meterDocumentControllerCreateMeterDocument = (data: MeterDocumentControllerCreateMeterDocumentData): CancelablePromise<MeterDocumentControllerCreateMeterDocumentResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/meter-documents',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Invalid request payload'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id Meter document ID
 * @returns void Meter document successfully deleted
 * @throws ApiError
 */
export const meterDocumentControllerDeleteMeterDocument = (data: MeterDocumentControllerDeleteMeterDocumentData): CancelablePromise<MeterDocumentControllerDeleteMeterDocumentResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/meter-documents/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Meter document not found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id Meter document ID
 * @returns binary File downloaded successfully
 * @throws ApiError
 */
export const meterDocumentControllerDownload = (data: MeterDocumentControllerDownloadData): CancelablePromise<MeterDocumentControllerDownloadResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/meter-documents/{id}/download',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.key
 * @returns UiPreferenceResponseDto UI preference of the calling user
 * @throws ApiError
 */
export const uiPreferenceControllerGetPreference = (data: UiPreferenceControllerGetPreferenceData): CancelablePromise<UiPreferenceControllerGetPreferenceResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/ui-preferences/{key}',
    path: {
        key: data.key
    },
    errors: {
        400: 'Unknown preference key'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.key
 * @param data.requestBody
 * @returns UiPreferenceResponseDto Saved UI preference of the calling user
 * @throws ApiError
 */
export const uiPreferenceControllerUpdatePreference = (data: UiPreferenceControllerUpdatePreferenceData): CancelablePromise<UiPreferenceControllerUpdatePreferenceResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/ui-preferences/{key}',
    path: {
        key: data.key
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Unknown preference key or invalid value'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Create insight
 * @returns FetchOneInsightInboxDto Insight created
 * @throws ApiError
 */
export const insightInboxControllerCreate = (data: InsightInboxControllerCreateData): CancelablePromise<InsightInboxControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/insight-inbox',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.buildingId Filter by building ID
 * @param data.companyId Filter by company ID
 * @param data.locationId Filter by location ID
 * @param data.assigneeId Filter by assignee user ID (across all statuses)
 * @param data.statuses Filter by status (can be multiple)
 * @param data.priorities Filter by priority (can be multiple)
 * @param data.categories Filter by category (can be multiple, OR-ed together)
 * @param data.energyTypes Filter by energy type (can be multiple, OR-ed together)
 * @param data.isHidden Customer visibility filter. Omitted returns released insights only. `true` returns the not-yet-released review set and is restricted to the insights admin.
 * @param data.startDate Filter by start date (ISO 8601 string)
 * @param data.endDate Filter by end date (ISO 8601 string)
 * @param data.page Page number for pagination
 * @param data.pageSize Number of items per page
 * @param data.sortBy Sort by field
 * @param data.sortOrder Sort order
 * @param data.groupBy Grouping dimension. "none" (default) returns the flat paginated list. "meter" groups by deviceId (an insight appears in every one of its deviceId groups). "category" groups by category. "location" groups by location (an insight appears in every one of its location groups). When set, the response is InsightInboxGroupedResponseListDto.
 * @returns unknown List of insights. Flat list when groupBy is omitted/none, grouped otherwise.
 * @throws ApiError
 */
export const insightInboxControllerFindAll = (data: InsightInboxControllerFindAllData = {}): CancelablePromise<InsightInboxControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-inbox',
    query: {
        buildingId: data.buildingId,
        companyId: data.companyId,
        locationId: data.locationId,
        assigneeId: data.assigneeId,
        statuses: data.statuses,
        priorities: data.priorities,
        categories: data.categories,
        energyTypes: data.energyTypes,
        isHidden: data.isHidden,
        startDate: data.startDate,
        endDate: data.endDate,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder,
        groupBy: data.groupBy
    }
}); };

/**
 * @returns DismissalReasonConfigDto Category → dismissal-reasons configuration
 * @throws ApiError
 */
export const insightInboxControllerGetDismissalReasonConfig = (): CancelablePromise<InsightInboxControllerGetDismissalReasonConfigResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-inbox/dismissal-reasons'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns FetchOneInsightInboxDto Insight details
 * @throws ApiError
 */
export const insightInboxControllerFindOne = (data: InsightInboxControllerFindOneData): CancelablePromise<InsightInboxControllerFindOneResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-inbox/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Update insight
 * @returns FetchOneInsightInboxDto Insight updated
 * @throws ApiError
 */
export const insightInboxControllerUpdate = (data: InsightInboxControllerUpdateData): CancelablePromise<InsightInboxControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/insight-inbox/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Insight deleted
 * @throws ApiError
 */
export const insightInboxControllerDelete = (data: InsightInboxControllerDeleteData): CancelablePromise<InsightInboxControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/insight-inbox/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ObjectChangeHistoryDto Insight change history
 * @throws ApiError
 */
export const insightInboxControllerGetChangeHistory = (data: InsightInboxControllerGetChangeHistoryData): CancelablePromise<InsightInboxControllerGetChangeHistoryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-inbox/{id}/change-history',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Resolve multiple insights
 * @returns BulkInsightActionResultDto Bulk resolve result
 * @throws ApiError
 */
export const insightInboxControllerBulkResolve = (data: InsightInboxControllerBulkResolveData): CancelablePromise<InsightInboxControllerBulkResolveResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/bulk/resolve',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Dismiss multiple insights
 * @returns BulkInsightActionResultDto Bulk dismiss result
 * @throws ApiError
 */
export const insightInboxControllerBulkDismiss = (data: InsightInboxControllerBulkDismissData): CancelablePromise<InsightInboxControllerBulkDismissResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/bulk/dismiss',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Dismiss a mixed selection, grouped by category with a per-group reason
 * @returns BulkInsightActionResultDto Bulk grouped dismiss result
 * @throws ApiError
 */
export const insightInboxControllerBulkDismissGrouped = (data: InsightInboxControllerBulkDismissGroupedData): CancelablePromise<InsightInboxControllerBulkDismissGroupedResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/bulk/dismiss-grouped',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Assign multiple insights
 * @returns BulkInsightActionResultDto Bulk assign result
 * @throws ApiError
 */
export const insightInboxControllerBulkAssign = (data: InsightInboxControllerBulkAssignData): CancelablePromise<InsightInboxControllerBulkAssignResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/bulk/assign',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Release or hide multiple insights
 * @returns BulkInsightActionResultDto Bulk visibility result
 * @throws ApiError
 */
export const insightInboxControllerBulkSetVisibility = (data: InsightInboxControllerBulkSetVisibilityData): CancelablePromise<InsightInboxControllerBulkSetVisibilityResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/bulk/visibility',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Release or hide the insight
 * @returns FetchOneInsightInboxDto Insight visibility updated
 * @throws ApiError
 */
export const insightInboxControllerSetVisibility = (data: InsightInboxControllerSetVisibilityData): CancelablePromise<InsightInboxControllerSetVisibilityResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/{id}/visibility',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns FetchOneInsightInboxDto Marked as under investigation
 * @throws ApiError
 */
export const insightInboxControllerInvestigate = (data: InsightInboxControllerInvestigateData): CancelablePromise<InsightInboxControllerInvestigateResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/{id}/investigate',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns FetchOneInsightInboxDto Converted to measure
 * @throws ApiError
 */
export const insightInboxControllerConvert = (data: InsightInboxControllerConvertData): CancelablePromise<InsightInboxControllerConvertResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/{id}/convert',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Resolve insight
 * @returns FetchOneInsightInboxDto Marked as resolved
 * @throws ApiError
 */
export const insightInboxControllerResolve = (data: InsightInboxControllerResolveData): CancelablePromise<InsightInboxControllerResolveResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/{id}/resolve',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Dismiss insight
 * @returns FetchOneInsightInboxDto Insight dismissed
 * @throws ApiError
 */
export const insightInboxControllerDismiss = (data: InsightInboxControllerDismissData): CancelablePromise<InsightInboxControllerDismissResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/{id}/dismiss',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Assign user to insight
 * @returns FetchOneInsightInboxDto User assigned to insight
 * @throws ApiError
 */
export const insightInboxControllerAssign = (data: InsightInboxControllerAssignData): CancelablePromise<InsightInboxControllerAssignResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-inbox/{id}/assign',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void Insight marked as viewed
 * @throws ApiError
 */
export const insightInboxControllerMarkViewed = (data: InsightInboxControllerMarkViewedData): CancelablePromise<InsightInboxControllerMarkViewedResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/insight-inbox/{id}/viewed',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Manually create a Baseload Benchmark insight
 * @returns FetchOneInsightInboxDto Baseload Benchmark insight created
 * @throws ApiError
 */
export const insightInboxManualControllerCreateBaseloadBenchmark = (data: InsightInboxManualControllerCreateBaseloadBenchmarkData): CancelablePromise<InsightInboxManualControllerCreateBaseloadBenchmarkResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/insight-inbox/baseload-benchmark',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody Manually create a Baseload Trend insight
 * @returns FetchOneInsightInboxDto Baseload Trend insight created
 * @throws ApiError
 */
export const insightInboxManualControllerCreateBaseloadTrend = (data: InsightInboxManualControllerCreateBaseloadTrendData): CancelablePromise<InsightInboxManualControllerCreateBaseloadTrendResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/insight-inbox/baseload-trend',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get the insight settings of every meter of the given locations
 * @param data The data for the request.
 * @param data.locationIds Locations whose meters are returned
 * @returns InsightInboxSettingsListDto One entry per meter; insights of a meter without saved settings are null
 * @throws ApiError
 */
export const insightSettingsControllerGetForLocations = (data: InsightSettingsControllerGetForLocationsData): CancelablePromise<InsightSettingsControllerGetForLocationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-settings',
    query: {
        locationIds: data.locationIds
    }
}); };

/**
 * Get the recommended insight settings of every meter of the given locations, without saving them
 * @param data The data for the request.
 * @param data.locationIds Locations whose meters are returned
 * @returns InsightInboxSettingsListDto The recommended insight settings, one entry per meter
 * @throws ApiError
 */
export const insightSettingsControllerGetRecommendationsForLocations = (data: InsightSettingsControllerGetRecommendationsForLocationsData): CancelablePromise<InsightSettingsControllerGetRecommendationsForLocationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-settings/recommendations',
    query: {
        locationIds: data.locationIds
    }
}); };

/**
 * Create or replace the insight settings of many meters at once; nothing is saved if any meter fails
 * @param data The data for the request.
 * @param data.requestBody
 * @returns InsightInboxSettingsListDto The saved insight settings
 * @throws ApiError
 */
export const insightSettingsControllerUpsertMany = (data: InsightSettingsControllerUpsertManyData): CancelablePromise<InsightSettingsControllerUpsertManyResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/insight-settings/bulk',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Replace many meters' insight settings with the recommended ones; nothing is saved if any meter fails
 * @param data The data for the request.
 * @param data.requestBody
 * @returns InsightInboxSettingsListDto The saved insight settings
 * @throws ApiError
 */
export const insightSettingsControllerApplyRecommendations = (data: InsightSettingsControllerApplyRecommendationsData): CancelablePromise<InsightSettingsControllerApplyRecommendationsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/insight-settings/apply-recommendation',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get the insight settings for a meter
 * @param data The data for the request.
 * @param data.meterId The meter whose insight settings to fetch
 * @returns InsightInboxSettingsResponseDto The meter insight settings
 * @throws ApiError
 */
export const insightSettingsControllerGetForMeter = (data: InsightSettingsControllerGetForMeterData): CancelablePromise<InsightSettingsControllerGetForMeterResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-settings/meter/{meterId}',
    path: {
        meterId: data.meterId
    }
}); };

/**
 * Create or replace the insight settings for a meter
 * @param data The data for the request.
 * @param data.meterId The meter the settings belong to
 * @param data.requestBody
 * @returns InsightInboxSettingsResponseDto The saved meter insight settings
 * @throws ApiError
 */
export const insightSettingsControllerUpsertForMeter = (data: InsightSettingsControllerUpsertForMeterData): CancelablePromise<InsightSettingsControllerUpsertForMeterResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/insight-settings/meter/{meterId}',
    path: {
        meterId: data.meterId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Change some of the insight settings for a meter, leaving the omitted insights unchanged
 * @param data The data for the request.
 * @param data.meterId The meter the settings belong to
 * @param data.requestBody
 * @returns InsightInboxSettingsResponseDto The saved meter insight settings
 * @throws ApiError
 */
export const insightSettingsControllerPatchForMeter = (data: InsightSettingsControllerPatchForMeterData): CancelablePromise<InsightSettingsControllerPatchForMeterResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/insight-settings/meter/{meterId}',
    path: {
        meterId: data.meterId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get the insight settings the decision tree recommends from the meter's master data, without saving them
 * @param data The data for the request.
 * @param data.meterId The meter whose recommended insight settings to compute
 * @returns InsightInboxSettingsResponseDto The recommended meter insight settings
 * @throws ApiError
 */
export const insightSettingsControllerGetRecommendationForMeter = (data: InsightSettingsControllerGetRecommendationForMeterData): CancelablePromise<InsightSettingsControllerGetRecommendationForMeterResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insight-settings/meter/{meterId}/recommendation',
    path: {
        meterId: data.meterId
    }
}); };

/**
 * Replace the meter's insight settings with the ones recommended from its master data (decision tree)
 * @param data The data for the request.
 * @param data.meterId The meter the settings belong to
 * @returns InsightInboxSettingsResponseDto The saved meter insight settings
 * @throws ApiError
 */
export const insightSettingsControllerApplyRecommendationForMeter = (data: InsightSettingsControllerApplyRecommendationForMeterData): CancelablePromise<InsightSettingsControllerApplyRecommendationForMeterResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/insight-settings/meter/{meterId}/apply-recommendation',
    path: {
        meterId: data.meterId
    }
}); };

/**
 * Get the production schedules of every location the caller can access
 * @returns LocationProductionSchedulesResponseDto The saved production schedules
 * @throws ApiError
 */
export const locationProductionScheduleControllerGetForCaller = (): CancelablePromise<LocationProductionScheduleControllerGetForCallerResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/location-production-schedule'
}); };

/**
 * Create or replace one location's production schedule
 * @param data The data for the request.
 * @param data.locationId The location the schedule belongs to
 * @param data.requestBody
 * @returns LocationProductionScheduleDto The saved production schedule
 * @throws ApiError
 */
export const locationProductionScheduleControllerUpsertForLocation = (data: LocationProductionScheduleControllerUpsertForLocationData): CancelablePromise<LocationProductionScheduleControllerUpsertForLocationResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/location-production-schedule/{locationId}',
    path: {
        locationId: data.locationId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Create or replace the production schedules of many locations at once
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LocationProductionSchedulesResponseDto The saved production schedules
 * @throws ApiError
 */
export const locationProductionScheduleControllerBulkUpsert = (data: LocationProductionScheduleControllerBulkUpsertData): CancelablePromise<LocationProductionScheduleControllerBulkUpsertResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/location-production-schedule/bulk/upsert',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get the insights onboarding state of the caller's company
 * @returns InsightsOnboardingStateDto
 * @throws ApiError
 */
export const insightsOnboardingControllerGetState = (): CancelablePromise<InsightsOnboardingControllerGetStateResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/insights-onboarding'
}); };

/**
 * Start the onboarding, so it is shown in place of the insights inbox
 * @returns InsightsOnboardingStateDto
 * @throws ApiError
 */
export const insightsOnboardingControllerStart = (): CancelablePromise<InsightsOnboardingControllerStartResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/insights-onboarding/start'
}); };

/**
 * Mark the onboarding as completed, so the inbox is shown again
 * @returns InsightsOnboardingStateDto
 * @throws ApiError
 */
export const insightsOnboardingControllerComplete = (): CancelablePromise<InsightsOnboardingControllerCompleteResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/insights-onboarding/complete'
}); };

/**
 * Validate an invitation token (public)
 * @param data The data for the request.
 * @param data.token Raw invitation token from the email link
 * @returns ValidateInvitationResponseDto Valid invitation
 * @throws ApiError
 */
export const invitationControllerValidate = (data: InvitationControllerValidateData): CancelablePromise<InvitationControllerValidateResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/invitations/validate',
    query: {
        token: data.token
    },
    errors: {
        404: 'Invalid or expired token'
    }
}); };

/**
 * Accept an invitation (public)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Invitation accepted
 * @throws ApiError
 */
export const invitationControllerAccept = (data: InvitationControllerAcceptData): CancelablePromise<InvitationControllerAcceptResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/invitations/accept',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'Invalid, expired, or already used token'
    }
}); };

/**
 * List registered users and pending invitations for user management
 * @param data The data for the request.
 * @param data.companyId Company ID whose users and invitations should be listed
 * @param data.page Page number (1-based)
 * @param data.pageSize Items per page
 * @param data.search Search visible user name, email, company role, permission, location access, or invitation status
 * @param data.sortBy
 * @param data.sortDirection
 * @returns UserManagementListResponseDto Paginated user-management list
 * @throws ApiError
 */
export const invitationControllerFindUserManagementPage = (data: InvitationControllerFindUserManagementPageData): CancelablePromise<InvitationControllerFindUserManagementPageResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/invitations/user-management',
    query: {
        page: data.page,
        pageSize: data.pageSize,
        companyId: data.companyId,
        search: data.search,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection
    }
}); };

/**
 * List pending invitations for a company
 * @param data The data for the request.
 * @param data.companyId Company ID to list invitations for
 * @returns InvitationResponseDto List of invitations
 * @throws ApiError
 */
export const invitationControllerFindAll = (data: InvitationControllerFindAllData): CancelablePromise<InvitationControllerFindAllResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v2/invitations',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * Create a new invitation
 * @param data The data for the request.
 * @param data.requestBody
 * @returns InvitationResponseDto Invitation created
 * @throws ApiError
 */
export const invitationControllerCreate = (data: InvitationControllerCreateData): CancelablePromise<InvitationControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v2/invitations',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Validation error',
        401: 'Unauthorized',
        403: 'Forbidden — caller is not an admin of the company'
    }
}); };

/**
 * Update an invitation
 * @param data The data for the request.
 * @param data.id Invitation ID
 * @param data.requestBody
 * @returns InvitationResponseDto Invitation updated
 * @throws ApiError
 */
export const invitationControllerUpdate = (data: InvitationControllerUpdateData): CancelablePromise<InvitationControllerUpdateResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v2/invitations/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        401: 'Unauthorized',
        403: 'Forbidden — caller is not an admin of the company',
        404: 'Invitation not found'
    }
}); };

/**
 * Revoke an invitation
 * @param data The data for the request.
 * @param data.id Invitation ID
 * @returns void Invitation revoked
 * @throws ApiError
 */
export const invitationControllerRevoke = (data: InvitationControllerRevokeData): CancelablePromise<InvitationControllerRevokeResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v2/invitations/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody Create a measure from this insight
 * @returns FetchOneInsightInboxDto Measure created and linked; insight marked as converted
 * @throws ApiError
 */
export const savingsFlowControllerCreateMeasureFromInsight = (data: SavingsFlowControllerCreateMeasureFromInsightData): CancelablePromise<SavingsFlowControllerCreateMeasureFromInsightResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/savings-flow/insights/{id}/measure',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * Get public holidays for a location and date range
 * Country and subdivision are inferred from the location postal code (DE 5-digit, AT 4-digit). Each can be overridden via query parameters. Range is limited to 3 years.
 * @param data The data for the request.
 * @param data.locationId
 * @param data.validFrom Start of the range (YYYY-MM-DD)
 * @param data.validTo End of the range (YYYY-MM-DD). Range must not exceed 3 years.
 * @param data.countryIsoCode ISO 3166-1 alpha-2 country code override. If omitted, inferred from the location postal code (fallback DE).
 * @param data.subdivisionCode ISO 3166-2 subdivision code override (e.g. DE-BY). If omitted, inferred from the location postal code.
 * @param data.languageIsoCode ISO 639-1 language code for holiday names (e.g. DE, EN). Defaults to DE.
 * @returns PublicHolidaysResponseDto Public holidays for the location and range
 * @throws ApiError
 */
export const publicHolidaysControllerFindForLocation = (data: PublicHolidaysControllerFindForLocationData): CancelablePromise<PublicHolidaysControllerFindForLocationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/public-holidays/location/{locationId}',
    path: {
        locationId: data.locationId
    },
    query: {
        validFrom: data.validFrom,
        validTo: data.validTo,
        countryIsoCode: data.countryIsoCode,
        subdivisionCode: data.subdivisionCode,
        languageIsoCode: data.languageIsoCode
    }
}); };

/**
 * Get public holidays by explicit parameters (proxy to OpenHolidaysAPI)
 * Requires countryIsoCode. Subdivision can be passed directly or inferred from postalCode (DE 5-digit, AT 4-digit). Range is limited to 3 years.
 * @param data The data for the request.
 * @param data.countryIsoCode ISO 3166-1 alpha-2 country code
 * @param data.validFrom Start of the range (YYYY-MM-DD)
 * @param data.validTo End of the range (YYYY-MM-DD). Range must not exceed 3 years.
 * @param data.subdivisionCode ISO 3166-2 subdivision code (e.g. DE-BY). Takes precedence over postal code inference.
 * @param data.postalCode Postal code used to infer the subdivision when subdivisionCode is not provided. DE 5-digit and AT 4-digit supported.
 * @param data.languageIsoCode ISO 639-1 language code for holiday names. Defaults to DE.
 * @returns PublicHolidaysResponseDto Public holidays for the country/subdivision and range
 * @throws ApiError
 */
export const publicHolidaysControllerFindByParams = (data: PublicHolidaysControllerFindByParamsData): CancelablePromise<PublicHolidaysControllerFindByParamsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/public-holidays',
    query: {
        countryIsoCode: data.countryIsoCode,
        validFrom: data.validFrom,
        validTo: data.validTo,
        subdivisionCode: data.subdivisionCode,
        postalCode: data.postalCode,
        languageIsoCode: data.languageIsoCode
    }
}); };

/**
 * Get the main meter and its submeters aggregated over a set of time windows
 * Returns each meter's mean load (kW) and energy total over only the 15min intervals inside the given windows — a single window for a continuous timeframe, or many for disjoint periods such as the non-production episodes of a baseload insight — so the frontend can display the attribution without computing it. With includeSeries, each meter also carries those intervals as a series. Submeters are resolved from the infrastructure hierarchy (each meter's parent meter); by default only the leaves below the main meter are returned, limited to measured (not virtual, SLP or generation) meters of the main meter's energy type. Access is resolved from the meter itself: non-admin users must be assigned to the meter's location.
 * @param data The data for the request.
 * @param data.meterId Main meter ID
 * @param data.window The windows to aggregate over, repeated once per window, each as an ISO 8601 interval "start/end" (at most 100). A 15min interval belongs to a window when its end timestamp lies in (start, end]; overlapping windows count each interval once.
 * @param data.includeAllSubmeters When true, return every meter below the main meter in the infrastructure hierarchy, including intermediate ones whose consumption overlaps their children. By default only the leaves of the hierarchy below the main meter are returned. Either way, only measured (not virtual, SLP or generation) meters of the main meter's energy type are included.
 * @param data.includeSeries When true, each meter also carries its 15min series (only the intervals inside the windows), e.g. to plot the load's time course.
 * @returns SubmeterAttributionResponseDto
 * @throws ApiError
 */
export const submeterAttributionControllerGetAttribution = (data: SubmeterAttributionControllerGetAttributionData): CancelablePromise<SubmeterAttributionControllerGetAttributionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/submeter-attribution/meter/{meterId}',
    path: {
        meterId: data.meterId
    },
    query: {
        window: data.window,
        includeAllSubmeters: data.includeAllSubmeters,
        includeSeries: data.includeSeries
    },
    errors: {
        400: 'Missing, malformed or more than 100 windows',
        401: 'Unauthorized',
        403: 'Meter belongs to a location the caller is not assigned to',
        404: 'Meter not found'
    }
}); };